<template>
  <div class="other">
    <div class="citySelect">
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link font17">
          {{ $store.state.Counter.city }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="杭州" style="font-size: 17px"
            >杭州</el-dropdown-item
          >
          <el-dropdown-item command="上海" style="font-size: 17px"
            >上海</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="normal" v-if="mainGroup === '创新'">
      <el-radio
        :label="item.en"
        v-for="(item, index) in operations"
        :key="index"
        v-model="operation"
        @change="changeCurrent"
        >{{ item.ch }}</el-radio
      >
    </div>
    <div class="normal" v-if="subgroup == '租房'">
      <el-button type="primary" @click="toZuwoCenter()">小鸡租窝</el-button>
    </div>
    <div style="margin: 40px">
      <el-button type="primary" @click="toIndexPage()">数据列表</el-button>
      <el-button
        type="primary"
        @click="onPageClick('需求中心')"
        :class="{ 'item-box': redDot }"
        >需求中心</el-button
      >
    </div>
    <div class="newOperate" v-show="current === 'operate'">
      <h3 class="normal">新运营小队</h3>
      <div class="cibuttonwarp">
        <button
          class="normal cibutton"
          v-if="seeNewoperate"
          @click="$router.push({ path: '/newOperateTeam/summaryTable' })"
        >
          顾问端
        </button>
        <button
          class="normal cibutton"
          v-if="seeNewoperate"
          @click="$router.push({ path: '/newOperateTeam/customerSumTable' })"
        >
          客户端
        </button>
        <button
          class="normal cibutton"
          v-if="seeSecoperate"
          @click="$router.push({ path: '/newOperateTeam/brokerIndex' })"
        >
          经纪人端
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/shanghai/articleManage' })"
        >
          文章管理
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/reportCenter' })"
        >
          报告中心
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/opsIdentityToggle' })"
        >
          运营身份切换
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/FunctionViewStats' })"
        >
          功能浏览量统计
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/consultButtonClickData' })"
        >
          咨询按钮点击数据
        </button>
        <button
          class="cibutton"
          @click="
            $router.push({
              path: '/autumnBusinessActivity',
              query: { type: 'yunying' },
            })
          "
        >
          金秋商务活动
        </button>
        <button
            class="normal cibutton"
            @click="
              $router.push({
                path: '/double12BusinessActivity',
              })
            "
          >
            十二月商务活动
          </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/homePageClickData' })"
        >
          首页功能点击数据
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/addAgentStore' })"
        >
          增加门店
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/dataMonitoring' })"
        >
          数据监控
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/surveyQuestionnaire' })"
        >
          用户调研
        </button>
        <button class="normal cibutton" @click="onPageClick('公众号管理')">
          公众号管理
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/diversionAppData' })"
        >
          导流小程序数据统计
        </button>

        <button class="normal cibutton" @click="routerPushTo('/couponManage')">
          特惠项目管理
        </button>
        <button
          class="normal cibutton"
          @click="onPageClick('看房笔记数据看板')"
        >
          看房笔记数据看板
        </button>
        <button
          class="normal cibutton"
          @click="onPageClick('补贴楼盘数据看板')"
        >
          补贴楼盘数据看板
        </button>


        <button
          class="normal cibutton"
          @click="routerPushTo('/houseGuestDirectData')"
        >
          房客直聊数据统计
        </button>
        <button
          class="normal cibutton"
          @click="routerPushTo('/houseGuestDirectChatDetail')"
        >
          房客直聊聊天明细
        </button>
        <button
          class="normal cibutton"
          @click="routerPushTo('/houseGuestDirectOwnerDetail')"
        >
          房东详情看板
        </button>
        <button class="normal cibutton" @click="toFangdongHouseModify()">
          房东上传房源详情审核
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/bannerControl' })"
        >
          轮播banner管理
        </button>
        <button class="normal cibutton" @click="toGuwenHoutai()">
          顾问成交服务后台看板
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/CustomerServicedata' })"
        >
          客服数据查询
        </button>
        <button class="normal cibutton" @click="onPageClick('导入小程序数据')">
          导入小程序数据
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/evaluationPageClickData' })"
        >
          评测功能点击数据
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/returnReward' })"
        >
          B端回归奖励
        </button>
        <button class="normal cibutton" @click="getZhList()">
          新房专业完整度
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/bigScreenMapDisplay' })"
        >
          大屏幕地图展示
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/AgentStoreAudit' })"
        >
          经纪人门店审核
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/houseSelectService' })"
        >
          选房服务后台
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/estateTagManage' })"
        >
          楼盘标签
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/featuredListings' })"
        >
          精选房源
        </button>
      </div>
    </div>
    <!-- <div class="operate" v-show="current === 'operate'"> -->
    <div class="operate" v-show="false">
      <h3 class="normal">运营小队</h3>
      <div>
        <div class="alltitle">新房</div>
        <div>
          <div class="cititle">楼盘类功能</div>
          <div class="cibuttonwarp">
            <button class="normal cibutton" @click="onPageClick('资料审核')">
              预计开盘审核
            </button>
            <button
              v-if="$store.state.Counter.city === '杭州'"
              class="normal cibutton"
              @click="onPageClick('新房图片审核')"
            >
              新房图片审核
            </button>
            <button
              class="normal cibutton"
              v-if="$store.state.Counter.city === '杭州'"
              @click="onPageClick('追踪预计开盘')"
            >
              追踪预计开盘
            </button>
            <button
              class="normal cibutton"
              v-if="$store.state.Counter.city === '杭州'"
              @click="onPageClick('楼盘评论数')"
            >
              楼盘评论数
            </button>
            <div class="add-margin">
              <el-date-picker
                size="small"
                v-model="checkDate1"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              ></el-date-picker>
            </div>

            <button
              class="normal cibutton"
              @click="onPageClick('新盘点击量排名')"
            >
              新盘点击量排名
            </button>
          </div>
        </div>
        <div>
          <div>
            <div class="cititle">
              顾问功能
              <div class="threetitle">顾问段类目</div>
            </div>
            <div class="cibuttonwarp">
              <button
                class="normal cibutton"
                @click="onPageClick('给顾问加分')"
              >
                给顾问加分
              </button>
              <button
                class="normal cibutton"
                v-if="$store.state.Counter.city === '杭州'"
                @click="onPageClick('顾问回答审核加分')"
              >
                顾问回答审核加分
              </button>
              <button
                class="normal cibutton"
                v-if="$store.state.Counter.city === '杭州'"
                @click="onPageClick('微控平台登录通道1')"
              >
                微控平台登录通道1
              </button>
              <button
                class="normal cibutton"
                v-if="$store.state.Counter.city === '杭州'"
                @click="onPageClick('微控平台登录通道2')"
              >
                微控平台登录通道2
              </button>
              <button
                class="normal cibutton"
                @click="onPageClick('置业顾问分享话题的人数和排名')"
              >
                置业顾问分享话题的人数和排名
              </button>
              <button class="normal cibutton" @click="getConsultantShareList">
                顾问分享名单
              </button>
              <button
                v-if="$store.state.Counter.city === '杭州'"
                class="normal cibutton"
                @click="onPageClick('朋友圈加分失败')"
              >
                朋友圈加分失败
              </button>
              <button
                v-if="$store.state.Counter.city === '杭州'"
                class="normal cibutton"
                @click="onPageClick('朋友圈加分')"
              >
                朋友圈加分
              </button>
              <button
                class="normal cibutton"
                @click="onPageClick('搜索某人朋友圈')"
              >
                搜索某人朋友圈
              </button>
              <button
                class="normal cibutton"
                @click="onPageClick('朋友圈统计')"
              >
                朋友圈统计
              </button>
              <button
                class="normal cibutton"
                @click="onPageClick('发布朋友圈')"
              >
                发布朋友圈
              </button>
            </div>
          </div>
          <div class="cititle">
            顾问审核
            <div class="threetitle">顾问段类目</div>
          </div>
          <div class="cibuttonwarp">
            <button
              class="normal cibutton cibutton"
              @click="onPageClick('入驻审核')"
            >
              入驻审核
            </button>
            <button class="normal cibutton" @click="onPageClick('头像审核')">
              头像审核
            </button>
            <button
              v-if="$store.state.Counter.city === '杭州'"
              class="normal cibutton"
              @click="onPageClick('群聊申诉', '顾问')"
            >
              顾问群聊申诉
            </button>
            <button
              v-if="$store.state.Counter.city === '杭州'"
              class="normal cibutton"
              @click="onPageClick('销售大群审核')"
            >
              销售大群审核
            </button>
            <button
              v-if="$store.state.Counter.city === '杭州'"
              class="normal cibutton"
              @click="onPageClick('举报审核')"
            >
              举报审核
            </button>
            <button class="normal cibutton" @click="toSalesDynamic()">
              置业顾问动态审核
            </button>
            <button class="normal cibutton cibutton" @click="toTaskAudit">
              限时任务审核
            </button>
            <button
              class="normal cibutton cibutton"
              @click="routerPushTo('/transactionContract')"
            >
              成交审核
            </button>
          </div>
        </div>
        <div>
          <div class="cititle">
            客户功能
            <div class="threetitle">客户端类目</div>
          </div>
          <div class="cibuttonwarp">
            <button class="normal cibutton" @click="onPageClick('最近留言')">
              最近留言
            </button>
            <button
              class="normal cibutton"
              @click="onPageClick('客服评价')"
              v-if="$store.state.Counter.city === '杭州'"
            >
              客服评价
            </button>
            <button class="normal cibutton" @click="onPageClick('搜索解禁')">
              搜索解禁
            </button>
            <button
              class="normal cibutton"
              @click="onPageClick('话题文章置顶')"
              v-if="$store.state.Counter.city === '杭州'"
            >
              话题文章置顶
            </button>
            <button
              class="normal cibutton"
              @click="onPageClick('回复楼盘提问')"
              v-if="$store.state.Counter.city === '杭州'"
            >
              回复楼盘提问
            </button>
            <button class="normal cibutton" @click="onPageClick('群聊灌水')">
              群聊灌水
            </button>
          </div>
          <div class="cititle">
            客户审核
            <div class="threetitle">客户端类目</div>
          </div>
          <div class="cibuttonwarp">
            <button
              v-if="$store.state.Counter.city === '杭州'"
              class="normal cibutton"
              @click="onPageClick('楼市提问')"
            >
              客户提问审核
            </button>
            <button
              class="normal cibutton"
              @click="onPageClick('建议反馈')"
              v-if="$store.state.Counter.city === '杭州'"
            >
              建议反馈
            </button>
            <button class="normal cibutton" @click="onPageClick('评价审核')">
              评价审核
            </button>
            <button class="normal cibutton" @click="getjudegcomment()">
              话题审核
            </button>
            <button class="normal cibutton" @click="toLive()">直播审核</button>
          </div>
          <div class="cititle">
            小程序群功能
            <div class="threetitle">客户端类目</div>
          </div>
          <div class="cibuttonwarp">
            <button
              v-if="$store.state.Counter.city === '杭州'"
              class="normal cibutton"
              @click="onPageClick('群聊申诉', '用户')"
            >
              用户群聊申诉
            </button>
            <button
              v-if="$store.state.Counter.city === '杭州'"
              class="normal cibutton"
              @click="onPageClick('业主群审核')"
            >
              业主群审核
            </button>
            <button class="normal cibutton" @click="showQun('假用户消息')">
              假用户消息
            </button>
            <button
              class="normal cibutton"
              @click="showQun('消息通知')"
              v-if="$store.state.Counter.city === '杭州'"
            >
              消息通知
            </button>
            <button
              v-if="$store.state.Counter.city === '杭州'"
              class="normal cibutton"
              @click="onPageClick('聊天举报')"
            >
              聊天举报
            </button>
            <button
              v-if="$store.state.Counter.city === '杭州'"
              class="normal cibutton"
              @click="getQlwgRecord()"
            >
              群聊违规
            </button>
          </div>
          <div class="cititle">
            合作公号
            <div class="threetitle">客户端类目</div>
          </div>
          <div class="cibuttonwarp">
            <button class="normal cibutton" @click="toessay()">
              合作公众号
            </button>
            <button class="normal cibutton" @click="routerPushTo('/uploadAd')">
              广告位上传
            </button>
          </div>
          <div class="cititle">
            海报
            <div class="threetitle">客户端类目</div>
          </div>
          <div class="cibuttonwarp">
            <button class="normal cibutton" @click="showPageHits('首页')">
              首页点击数
            </button>
            <!-- <button class="normal cibutton"  @click="getTodayPoster" v-if="$store.state.Counter.city === '杭州'"
                  >生成登记海报</button
                > -->
            <div class="add-margin" v-if="$store.state.Counter.city === '苏州'">
              <el-select size="small" v-model="posterType">
                <el-option
                  :value="item"
                  v-for="item in szPosterTypeList"
                  :key="item"
                  >{{ item }}</el-option
                >
              </el-select>
            </div>

            <button
              class="normal cibutton"
              @click="drawPoster"
              v-if="$store.state.Counter.city === '苏州'"
            >
              绘制海报
            </button>
            <div
              class="cibuttonwarp"
              style="margin: 0"
              v-if="$store.state.Counter.city === '杭州'"
            >
              <div class="add-margin">
                <el-select size="small" v-model="posterType">
                  <el-option
                    :value="item"
                    v-for="item in hzPosterTypeList"
                    :key="item"
                    >{{ item }}</el-option
                  >
                </el-select>
              </div>

              <button
                class="normal cibutton"
                @click="drawPoster"
                v-if="posterType === '每日楼市' || !posterType"
              >
                绘制海报
              </button>
              <el-input
                v-if="posterType === '比价表'"
                v-model="building_name"
                style="width: 200px"
                placeholder="输入楼盘名称"
              />
              <button
                class="normal cibutton"
                style="overflow: hidden; position: relative"
                v-if="posterType !== '每日楼市' && posterType"
              >
                请选择截图
                <input
                  type="file"
                  multiple
                  @change="voteRoomPoster"
                  id="input_image"
                />
              </button>
            </div>
          </div>
        </div>
        <div>
          <div class="cititle">
            数据统计结果
            <div class="threetitle">数据统计</div>
          </div>
          <div class="cibuttonwarp">
            <button class="normal cibutton" @click="getYunYinCountSysterm()">
              数据系统
            </button>
            <button class="normal cibutton" @click="getchuangxin()">
              产品数据系统
            </button>
            <button
              class="normal cibutton"
              @click="routerPushTo('/newHouseExtent')"
            >
              新房专业完整度
            </button>
            <button
              class="normal cibutton"
              @click="routerPushTo('/twoHouseExtent')"
            >
              二手房专业完整度
            </button>
            <button class="normal cibutton" @click="getAreaList()">
              常规完整度
            </button>
            <button class="normal cibutton" @click="checkEstateImageNum">
              楼盘图片视频数量
            </button>
            <button class="normal cibutton" @click="getSalePut()">
              销售上传
            </button>
            <button class="normal cibutton" @click="getQlList()">
              群聊条数查询
            </button>
            <button
              class="normal cibutton"
              @click="$router.push({ path: '/topicRecord' })"
            >
              智能话题识别
            </button>
            <button
              class="normal cibutton"
              @click="$router.push({ path: '/bankDiet' })"
            >
              贷款看板
            </button>
            <button class="normal cibutton" @click="toEmotionRecord">
              智能情绪识别
            </button>
            <button class="normal cibutton" @click="toHaterIdentify">
              小黑子识别
            </button>
          </div>
          <div class="cititle">
            顾问统计
            <div class="threetitle">数据统计</div>
          </div>
          <div class="cibuttonwarp">
            <button class="normal cibutton" @click="showSalerStatus">
              销售活跃情况
            </button>
            <button class="normal cibutton" @click="getStatisticsData">
              销售动态统计
            </button>
            <button
              class="normal cibutton"
              @click="getShareWeekTop"
              v-if="$store.state.Counter.city === '杭州'"
            >
              销售上周积分排名
            </button>
            <div class="add-margin">
              <el-date-picker
                size="small"
                v-model="checkDate1"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              ></el-date-picker>
            </div>

            <button
              class="normal cibutton"
              @click="getShareTop('销售', areaValue)"
            >
              销售分享排名
            </button>
            <button class="normal cibutton" @click="showMsgNum('置业顾问')">
              置业顾问咨询量排名
            </button>
          </div>
          <div class="cititle">
            客户统计
            <div class="threetitle">数据统计</div>
          </div>
          <div class="cibuttonwarp">
            <div class="add-margin" v-if="$store.state.Counter.city === '苏州'">
              <el-date-picker
                size="small"
                v-model="checkDate1"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              ></el-date-picker>
            </div>

            <button
              class="normal cibutton"
              @click="getSzInvite()"
              v-if="$store.state.Counter.city === '苏州'"
            >
              苏州运营分享
            </button>
            <button
              class="normal cibutton"
              @click="getInvite()"
              v-if="$store.state.Counter.city === '杭州'"
            >
              运营分享
            </button>
            <button
              class="normal cibutton"
              @click="findFried()"
              v-if="$store.state.Counter.city === '杭州'"
            >
              炒群记录
            </button>
          </div>
          <div class="cititle">积分商城</div>
          <div class="cibuttonwarp">
            <button class="normal cibutton" @click="toPointsMall">
              积分商城
            </button>
          </div>
          <div class="cititle">商务跟踪</div>
          <div class="cibuttonwarp">
            <button class="normal cibutton" @click="GoToRoutineTrail()">
              常规跟踪表
            </button>
            <button class="normal cibutton" @click="GoToBusinessPlanTrail()">
              商务计划跟踪表
            </button>
          </div>
          <div class="cititle">亚运活动</div>
          <div class="cibuttonwarp">
            <button
              class="normal cibutton"
              @click="routerPushTo('/asiaGamesMedal')"
            >
              亚运奖牌榜
            </button>
            <button
              class="normal cibutton"
              @click="routerPushTo('/asiaGamesQuestion')"
            >
              每日竞猜题目
            </button>
            <button
              class="normal cibutton"
              @click="routerPushTo('/asiaGamesComment')"
            >
              互动评论管理
            </button>
          </div>
        </div>
      </div>
      <div class="alltitle">二手房</div>
      <div class="cibuttonwarp">
        <button
          v-if="$store.state.Counter.city === '杭州'"
          class="normal cibutton"
          @click="onPageClick('中介审核')"
        >
          中介审核
        </button>
        <button
          v-if="$store.state.Counter.city === '杭州'"
          class="normal cibutton"
          @click="toCheckImage('楼盘')"
        >
          二手楼盘图片审核
        </button>
        <button
          v-if="$store.state.Counter.city === '杭州'"
          class="normal cibutton"
          @click="toCheckImage('房源')"
        >
          二手房源图片审核
        </button>
        <button
          v-if="$store.state.Counter.city === '杭州'"
          class="normal cibutton"
          @click="onPageClick('房源审核')"
        >
          房源审核
        </button>
        <div class="add-margin" v-if="$store.state.Counter.city === '杭州'">
          <el-date-picker
            size="small"
            v-model="checkDate1"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
        </div>

        <button
          v-if="$store.state.Counter.city === '杭州'"
          class="normal cibutton"
          @click="showEstateHits('二手房')"
        >
          二手盘点击量排名
        </button>
      </div>
      <div class="alltitle">猩号</div>
      <div class="cibuttonwarp" v-if="$store.state.Counter.city === '杭州'">
        <button class="normal cibutton" @click="onPageClick('APP进群审核')">
          APP进群审核
        </button>
        <button class="normal cibutton" @click="onPageClick('APP建群审核')">
          APP建群审核
        </button>
        <button class="normal cibutton" @click="onPageClick('APP举报审核')">
          APP举报审核
        </button>
        <button class="normal cibutton" @click="onPageClick('APP申诉')">
          APP申诉
        </button>
        <button class="normal cibutton" @click="onPageClick('APP反馈')">
          APP反馈
        </button>
      </div>
      <div class="alltitle">干货地图</div>
      <div class="cibuttonwarp">
        <!--
          <el-button type="primary" @click="toMapPage('getBounds')">城市边界</el-button>
        -->
        <button class="normal cibutton" @click="toMapPage('新房', '全城左')">
          新房左
        </button>
        <button class="normal cibutton" @click="toMapPage('新房', '全城右')">
          新房右
        </button>
        <button class="normal cibutton" @click="toMapPage('新房', '全城')">
          新房整
        </button>
        <button class="normal cibutton" @click="toMapPage('待首开', '全城左')">
          待首开和土拍左
        </button>
        <button class="normal cibutton" @click="toMapPage('待首开', '全城右')">
          待首开和土拍右
        </button>
        <button class="normal cibutton" @click="toMapPage('待首开', '全城')">
          待首开和土拍整
        </button>
        <button class="normal cibutton" @click="toMapPage('土拍', '全城左')">
          土拍左
        </button>
        <button class="normal cibutton" @click="toMapPage('土拍', '全城右')">
          土拍右
        </button>
        <button class="normal cibutton" @click="toMapPage('土拍', '全城')">
          土拍整
        </button>
        <button
          class="normal cibutton"
          @click="toMapPage('土拍圆点', '全城左')"
        >
          土拍圆点左
        </button>
        <button
          class="normal cibutton"
          @click="toMapPage('土拍圆点', '全城右')"
        >
          土拍圆点右
        </button>
        <button class="normal cibutton" @click="toMapPage('土拍圆点', '全城')">
          土拍圆点整
        </button>
        <button
          class="normal cibutton"
          @click="toMapPage('公示登记', '全城左')"
        >
          公示登记左
        </button>
        <button
          class="normal cibutton"
          @click="toMapPage('公示登记', '全城右')"
        >
          公示登记右
        </button>
        <button class="normal cibutton" @click="toMapPage('公示登记', '全城')">
          公示登记整
        </button>
        <button class="normal cibutton" @click="toMapPage('中签率')">
          中签率
        </button>
        <button class="normal cibutton" @click="toMapPage('热度')">热度</button>
        <button class="normal cibutton" @click="toMapPage('板块')">
          板块图
        </button>
        <button class="normal cibutton" @click="toMapPage('板块地图土拍')">
          板块地图土拍
        </button>
        <button class="normal cibutton" @click="toMapPage('getBounds')">
          城市地图
        </button>
      </div>
      <div class="alltitle">其他</div>
      <div class="cibuttonwarp">
        <div class="add-margin">
          <el-select size="small" v-model="codeType">
            <el-option :value="item" v-for="item in codeTypeList" :key="item">{{
              item
            }}</el-option>
          </el-select>
        </div>

        <button class="normal cibutton" @click="getMpCode">小程序码</button>
        <button class="normal cibutton" @click="onPageClick('评价审核')">
          评价审核
        </button>
        <button class="normal cibutton" @click="getEssayData()">
          合作公众号分享数据
        </button>
      </div>
      <div class="cibuttonwarp" v-if="$store.state.Counter.city === '杭州'">
        <div class="add-margin">
          <el-date-picker
            size="small"
            v-model="checkDate1"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
        </div>

        <button class="normal cibutton" @click="showEstateHits('二手房')">
          二手盘点击量排名
        </button>
        <button class="normal cibutton" @click="showMsgNum('经纪人')">
          经纪人咨询量排名
        </button>
        <button class="normal cibutton" @click="getShareTop('经纪人')">
          经纪人分享排名
        </button>
      </div>
      <div class="cibuttonwarp" v-if="$store.state.Counter.city === '杭州'">
        <button class="normal cibutton" @click="getEstateGS('正在公示')">
          正在公示
        </button>
        <button class="normal cibutton" @click="getEstateGS('正在登记')">
          正在登记
        </button>
        <button class="normal cibutton" @click="onPageClick('专家入驻')">
          专家入驻
        </button>
        <button class="normal cibutton" @click="getSaleJoinData">
          近期入驻人数
        </button>
        <button class="normal cibutton" @click="getSalesMsgNum">
          顾问群聊消息数排名
        </button>
        <button class="normal cibutton" @click="setChatSales">
          拉顾问进群
        </button>
        <button class="normal cibutton" @click="onPageClick('留言举报')">
          留言举报审核
        </button>
        <button class="normal cibutton" @click="searchGsReal()">
          追踪公示楼盘数据
        </button>
        <!--
            <button class="normal cibutton"  @click="unUserStatus()">解禁</button>
          -->
        <button class="normal cibutton" @click="getYuyueInfo()">
          楼盘预约
        </button>
        <button class="normal cibutton" @click="noNewsOrImages('1')">
          小区内配套
        </button>
        <button class="normal cibutton" @click="addNews()">
          新增动态/配套
        </button>
        <button class="normal cibutton" @click="getAdvanceList()">
          预售证信息
        </button>
        <button class="normal cibutton" @click="getAreaShare()">
          区域销售分享
        </button>
        <button class="normal cibutton" @click="getWkMessage()">
          微信群聊统计
        </button>
        <button class="normal cibutton" @click="showQun('创建小群')">
          创建小群
        </button>
        <button class="normal cibutton" @click="onPageClick('自动问答')">
          自动问答管理
        </button>
        <button class="normal cibutton" @click="toGetOneDayTalk('运营')">
          群聊记录
        </button>
        <button class="normal cibutton" @click="changeTopicLabel()">
          话题类目
        </button>
        <button class="normal cibutton" @click="toCheckTalk">
          群聊地毯式检查
        </button>
        <button class="normal cibutton" @click="toCheckWeiguiTalk">
          聊天图片违规
        </button>
      </div>
      <div class="cibuttonwarp" v-if="$store.state.Counter.city === '苏州'">
        <div class="add-margin">
          <el-date-picker
            size="small"
            v-model="checkDate1"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
        </div>

        <button class="normal cibutton" @click="getShareNum('楼市小V')">
          合作中介分享
        </button>
        <button class="normal cibutton" @click="getShareNum('置业顾问')">
          置业顾问分享
        </button>
        <button class="normal cibutton" @click="setSubstitute('')">
          变回自己
        </button>
      </div>
      <div class="cibuttonwarp" v-if="$store.state.Counter.city === '苏州'">
        <button class="normal cibutton" @click="szYuShouList()">
          预售证楼盘
        </button>

        <button class="normal cibutton" @click="onPageClick('拿证审核')">
          拿证审核
        </button>

        <button class="normal cibutton" @click="onPageClick('分配客户')">
          手动分配客户
        </button>
      </div>
    </div>
    <div>
      <div class="business" v-show="current === 'business'">
        <h3>新商务小队</h3>
        <div class="cititle">全部功能</div>
        <div class="cibuttonwarp">
          <button
            class="normal cibutton"
            @click="
              $router.push({ path: '/newBusinessTeam/businessCustomerSum' })
            "
          >
            商务数据看板
          </button>
          <button
            class="normal cibutton"
            @click="
              $router.push({ path: '/newBusinessTeam/businessAdvertisement' })
            "
          >
            商务广告数据
          </button>
          <button
            class="normal cibutton"
            @click="$router.push({ path: '/infoOfflineManage' })"
          >
            信息下架管理
          </button>
          <button
            class="normal cibutton"
            @click="$router.push({ path: '/newBuildBoard' })"
          >
            新房楼盘数据
          </button>
          <button
            class="normal cibutton"
            @click="$router.push({ path: '/guwenImpactBoard' })"
          >
            置业顾问效果数据
          </button>
          <button
            class="normal cibutton"
            @click="$router.push({ path: '/acCustomerList' })"
          >
            活动客户列表
          </button>

          <el-badge
            :is-dot="pointData.hasAllAccountDetail"
            class="red-point-item"
          >
            <button
              class="cibutton"
              @click="$router.push({ path: '/allAccountDetail' })"
            >
              全号明细
            </button>
          </el-badge>
          <button
            class="normal cibutton"
            @click="$router.push({ path: '/autumnBusinessActivity' })"
          >
            金秋商务活动
          </button>

          <button
            class="normal cibutton"
            @click="$router.push({ path: '/competitorsAddata' })"
          >
            竞品广告数据
          </button>
          <button
            class="normal cibutton"
            @click="$router.push({ path: '/transactionEntry' })"
          >
            成交录入
          </button>
        </div>
        <h3>商务小队</h3>
        <div class="cititle">红包相关</div>
        <div class="cibuttonwarp">
          <button class="normal cibutton" @click="GoToRedPacket()">
            红包活动
          </button>
          <el-badge
            :is-dot="pointData.hasRedpacketAudit"
            class="red-point-item"
          >
            <button class="cibutton" @click="GoToRedPacketAudit()">
              红包活动审核
            </button>
          </el-badge>

          <button class="normal cibutton" @click="GoToRedPacketStatistics()">
            红包数据
          </button>
          <button class="normal cibutton" @click="GoToErrRedPacket()">
            失败红包处理
          </button>
          <button
            class="normal cibutton"
            @click="routerPushTo('/asiaGamesPreheat')"
          >
            活动红包数据
          </button>
        </div>
        <div class="cititle">优惠券相关</div>
        <div class="cibuttonwarp">
          <button
            class="normal cibutton"
            @click="routerPushTo('/couponManage')"
          >
            特惠项目管理
          </button>
          <button
            class="normal cibutton"
            @click="routerPushTo('/activityCustomerList')"
          >
            活动客户列表
          </button>
          <button class="normal cibutton" @click="routerPushTo('/dealSubsidy')">
            百万补贴项目管理
          </button>
        </div>
        <div class="cititle">广告相关</div>
        <div class="cibuttonwarp">
          <button
            v-if="$store.state.Counter.city === '杭州'"
            class="normal cibutton"
            @click="onPageClick('楼盘集合')"
          >
            策划广告数据统计
          </button>
          <button class="normal cibutton" @click="getAdTotal">
            广告位统计
          </button>
          <button class="normal cibutton" @click="getAdTotal1">
            广告曝光量统计
          </button>
          <button class="normal cibutton" @click="routerPushTo('/uploadAd')">
            广告位上传
          </button>
          <el-badge :is-dot="pointData.hasAdAudit" class="red-point-item">
            <button class="cibutton" @click="routerPushTo('/checkAd')">
              广告位审核
            </button>
          </el-badge>
          <button
            class="normal cibutton"
            @click="routerPushTo('/adPublication')"
          >
            广告上刊记录查询
          </button>
          <button class="normal cibutton" @click="routerPushTo('/adScreen')">
            广告截图
          </button>
          <button
            class="normal cibutton"
            @click="routerPushTo('/cooperationList')"
            v-if="erp_id == '2hwvqwwo1ow'"
          >
            联系方式合作
          </button>
        </div>
        <div class="cititle">分配客户相关</div>
        <div class="cibuttonwarp">
          <button
            class="normal cibutton"
            @click="routerPushTo('/CustomerDistribution')"
          >
            手动分配客户
          </button>
          <el-badge :is-dot="pointData.hasCouponAudit" class="red-point-item">
            <button
              class="cibutton"
              @click="routerPushTo('/assignCustomerReviews')"
            >
              手动分配客户审核
            </button>
          </el-badge>
          <button
            class="normal cibutton"
            @click="routerPushTo('/assignCustomerRecords')"
          >
            查询分配记录
          </button>
          <button
            class="normal cibutton"
            @click="listName = 'assignCustomer'"
            v-if="$store.state.Counter.city === '杭州'"
          >
            分配客户情况
          </button>
        </div>
        <div class="cititle">其他</div>
        <div class="cibuttonwarp">
          <div class="add-margin">
            <el-date-picker
              size="small"
              v-model="checkDate1"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            ></el-date-picker>
          </div>
          <button class="normal cibutton" @click="showMsgNum('置业顾问')">
            置业顾问咨询量排名
          </button>

          <button class="normal cibutton" @click="listName = 'guwenFuwu'">
            顾问情况
          </button>
          <div class="normal">
            <button
              :style="{ backgroundColor: oldFirst ? 'red' : '' }"
              @click="oldFirst = !oldFirst"
            >
              旧访问优先
            </button>
            客户比对
            <el-select
              ref="agent1Select"
              filterable
              placeholder="选择楼盘"
              default-first-option
              :remote-method="searchEstate"
              remote
              v-model="real_estate_id"
            >
              <el-option
                v-for="(item, index) in matchEstates"
                :key="index"
                :label="item.real_estate_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <input type="file" @change="comparingCustomers" />
          </div>
          <button class="normal cibutton" @click="GoToRoutineTrail()">
            常规跟踪表
          </button>
          <button class="normal cibutton" @click="GoToBusinessPlanTrail()">
            商务计划跟踪表
          </button>
          <button class="normal cibutton" @click="routerPushTo('/dealCount')">
            成交数量
          </button>
          <!-- <button class="normal cibutton" @click="routerPushTo('/SingleChat')">
            私聊顾问
          </button> -->
          <button
            class="normal cibutton"
            @click="routerPushTo('/discountsExamine')"
          >
            特惠信息审核
          </button>
          <button
            class="normal cibutton"
            @click="routerPushTo('/discountsExamineNew')"
          >
            特惠信息审核·新
          </button>
          <button
            class="normal cibutton"
            @click="routerPushTo('/reservationShowings')"
          >
            预约看房活动
          </button>
          <button
            class="normal cibutton"
            @click="routerPushTo('/estateChatSearch')"
          >
            查询楼盘私聊信息
          </button>
          <button
            class="normal cibutton"
            @click="routerPushTo('/privateCallback')"
          >
            私聊回拨查询
          </button>
          <button class="normal cibutton" @click="routerPushTo('/fourthBooth')">
            第四展位
          </button>
          <button class="normal cibutton" @click="routerPushTo('/brandStore')">
            品牌馆编辑
          </button>
          <button class="normal cibutton" @click="showZxTable = true">
            装修推广数据
          </button>
          <button class="normal cibutton" @click="showZxConsult = true">
            装修电话咨询统计
          </button>
          <button
            class="normal cibutton"
            @click="routerPushTo('/manageProperties')"
          >
            小阳春活动
          </button>
          <button
            class="normal cibutton"
            @click="routerPushTo('/ManageAffarisTables')"
          >
            管理报表
          </button>
          <button class="normal cibutton" @click="routerPushTo('/presaleInfo')">
            预售证信息
          </button>
          <button
            class="normal cibutton"
            @click="routerPushTo('/CooperationManagement')"
          >
            招商合作
          </button>
          <button
            class="normal cibutton"
            @click="routerPushTo('/cooperationList')"
          >
            联系方式合作
          </button>
        </div>
      </div>
    </div>
    <div class="market" v-show="current === 'market'">
      <h3 class="normal">销售小队</h3>
      <div class="cititle">全部功能</div>
      <div class="cibuttonwarp">
        <!-- <button class="normal cibutton" @click="checkTalkRecord">
          咨询电话统计
        </button>
        <button class="normal cibutton" @click="setEstateSort('lvi0rhqsj8')">
          公寓楼盘置顶
        </button>
        <button class="normal cibutton" @click="setEstateSort('w45e61qtpt')">
          临安楼盘置顶
        </button>
        <button class="normal cibutton" @click="setEstateSort('r6x907mrmh')">
          大平层
        </button>
        <button class="normal cibutton" @click="setEstateSort('212r7ga045a')">
          不摇号
        </button>
        <button class="normal cibutton" @click="setEstateSort('2mn1nn4v9zg')">
          不限购
        </button>
        <button class="normal cibutton" @click="getxiaoshou()">数据系统</button> -->

        <el-badge :is-dot="pointData.hasDesignerAudit" class="red-point-item">
          <button
            class="normal cibutton"
            style="margin: 0"
            @click="routerPushTo('/auditList')"
          >
            设计师入驻审核
          </button>
        </el-badge>
        <el-badge :is-dot="pointData.hasDecorationAudit" class="red-point-item">
          <button
            class="normal cibutton"
            style="margin: 0"
            @click="routerPushTo('/decorationPlanAudit')"
          >
            装修方案审核
          </button>
        </el-badge>
        <button
          class="normal cibutton"
          @click="routerPushTo('/DecorationPlan')"
        >
          装修方案
        </button>
        <button
          class="normal cibutton"
          @click="routerPushTo('/decorationStatisticsTable')"
        >
          装修统计
        </button>
        <button
          class="normal cibutton"
          @click="routerPushTo('/decorationCompanyConsult')"
        >
          装修公司咨询分配
        </button>
        <button class="normal cibutton" @click="routerPushTo('/storeMap')">
          门店地图
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/opsIdentityToggle' })"
        >
          运营身份切换
        </button>

        <el-badge :is-dot="pointData.hasManagerAudit" class="red-point-item">
          <button
            class="cibutton"
            @click="$router.push({ path: '/storeManageModify' })"
          >
            店长申请审核
          </button>
        </el-badge>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/jmh2DataStatis' })"
        >
          鸡米花套餐购买统计表
        </button>

        <button
          class="normal cibutton"
          @click="routerPushTo('/agentConsumeTable')"
        >
          经纪人付费明细
        </button>
        <button
          class="normal cibutton"
          @click="routerPushTo('/renewalDashboard')"
        >
          续费看板
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/businessReconciliation' })"
        >
          二手业务核对
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/agentBenefitsData' })"
        >
          经纪人权益情况
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/agentDealChampionPoster' })"
        >
          成交达人海报
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/addAgentStore' })"
        >
          增加门店
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/agentPosterDealdata' })"
        >
          经纪人海报成交数据
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/manualGroupbuying' })"
        >
          手动拼团成功
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/sendInviteCard' })"
        >
          发放拉新券
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/AgentTopup' })"
        >
          经纪人充值
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/AgentStoreAudit' })"
        >
          经纪人门店审核
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/agentUploadRecord' })"
        >
          经纪人上传成交数据审核
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/bigScreenMapDisplay' })"
        >
          大屏幕地图展示
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/houseSelectService' })"
        >
          选房服务后台
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/estateTagManage' })"
        >
          楼盘标签
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/featuredListings' })"
        >
          精选房源
        </button>
      </div>
      <!-- <div class="cititle">选房师管理</div>
      <div class="cibuttonwarp">
        <button
          class="normal cibutton"
          @click="onPageClick('客源管理');"
          >客源管理</button
        >
        <button class="normal cibutton" @click="gotoOfficial()">官方选房师</button>
        <button class="normal cibutton" @click="getCuctomers()">分配福利客户</button>
        <button class="normal cibutton" @click="giveCuctomersRecord()">客户分配记录</button>
        <button class="normal cibutton" @click="toBKdata()">新房板块图</button>
        <button class="normal cibutton" @click="toLPdata()">楼盘资料库</button>
      </div> -->
    </div>

    <div class="market" v-show="current === 'xinghao'">
      <h3 class="normal">猩群运营</h3>
      <div class="cititle">全部功能</div>
      <div class="cibuttonwarp">
        <button class="normal cibutton" @click="onPageClick('发空间说')">
          发空间说
        </button>
        <button class="normal cibutton" @click="onPageClick('猩号炒群')">
          猩号炒群
        </button>
        <button class="normal cibutton" @click="onPageClick('猩号炒频道')">
          猩号炒频道
        </button>
        <button class="normal cibutton" @click="onPageClick('猩号灌水')">
          猩号空间说灌水
        </button>
        <button class="normal cibutton" @click="onPageClick('造假用户')">
          选择头像昵称
        </button>
        <button class="normal cibutton" @click="showQun('假用户消息')">
          炒小鸡选房的群
        </button>
        <button class="normal cibutton" @click="onPageClick('频道管理')">
          频道管理
        </button>
        <button class="normal cibutton" @click="onPageClick('运营助手')">
          运营助手
        </button>
      </div>
      <div class="cititle">统计</div>
      <div class="cibuttonwarp">
        <button class="normal cibutton" @click="getUserNum()">
          猩群用户数量
        </button>
        <button class="normal cibutton" @click="onPageClick('猩号APP数据')">
          APP整体数据
        </button>
        <button class="normal cibutton" @click="showXHTalkTotal">
          猩群话题发布统计
        </button>
        <button class="normal cibutton" @click="showxHGSTotal">
          猩群空间说灌水统计
        </button>
        <button
          class="normal cibutton"
          @click="changeListName('groupWaterTable')"
        >
          空间群灌水统计
        </button>
        <button
          class="normal cibutton"
          @click="changeListName('channelWaterTable')"
        >
          频道灌水统计
        </button>
        <button class="normal cibutton" @click="toCountSharevisite">
          分享链接统计
        </button>
      </div>
      <div class="alltitle">猩号</div>
      <div class="cibuttonwarp" v-if="$store.state.Counter.city === '杭州'">
        <button class="normal cibutton" @click="onPageClick('APP进群审核')">
          APP进群审核
        </button>
        <button class="normal cibutton" @click="onPageClick('APP建群审核')">
          APP建群审核
        </button>
        <button class="normal cibutton" @click="onPageClick('APP举报审核')">
          APP举报审核
        </button>
        <button class="normal cibutton" @click="onPageClick('APP申诉')">
          APP申诉
        </button>
        <button class="normal cibutton" @click="onPageClick('APP反馈')">
          APP反馈
        </button>
      </div>
      <div class="alltitle">旅游</div>
      <div class="cibuttonwarp" v-if="$store.state.Counter.city === '杭州'">
        <button class="normal cibutton" @click="onPageClick('旅游地图')">
          旅游地图
        </button>
      </div>
      <div class="alltitle">小区</div>
      <div class="cibuttonwarp" v-if="$store.state.Counter.city === '杭州'">
        <button class="normal cibutton" @click="onPageClick('小区入驻审核')">
          小区入驻审核
        </button>
        <button class="normal cibutton" @click="onPageClick('小区区长设置')">
          小区区长设置
        </button>
        <button class="normal cibutton" @click="onPageClick('定位数据')">
          定位数据
        </button>
        <button class="normal cibutton" @click="onPageClick('投诉列表')">
          投诉列表
        </button>
        <button class="normal cibutton" @click="routerPushTo('/xjxqDataBoard')">
          数据看板
        </button>
      </div>
    </div>

    <div class="market" v-show="current === 'safety'">
      <h3 class="normal">安全监控</h3>
      <div class="cibuttonwarp">
        <button class="normal cibutton" @click="onPageClick('留言审核')">
          留言审核
        </button>
        <button class="normal cibutton" @click="onPageClick('内容审核')">
          内容审核
        </button>
      </div>
    </div>

    <div class="content" v-show="current === 'content'">
      <h3 class="normal">内容小队</h3>
      <div class="cititle">问答以及智能化</div>
      <div class="cibuttonwarp">
        <button class="normal cibutton" @click="toGetOneDayTalk('内容')">
          群聊记录
        </button>
        <button class="normal cibutton" @click="toCommentEstate">
          楼盘点评
        </button>
        <button
          class="normal cibutton"
          @click="routerPushTo('/estateRateCount')"
        >
          楼盘评测统计表
        </button>
        <button class="normal cibutton" @click="onPageClick('最近留言')">
          最近留言
        </button>
        <button class="normal cibutton" @click="gohousetype()">智能问答</button>
        <button class="normal cibutton" @click="goBuildingValuation">
          楼盘评价
        </button>
        <button class="normal cibutton" @click="godownSideValuation">
          楼盘不利于有利评价
        </button>
        <button class="normal cibutton" @click="routerPushTo('/checkAIAns')">
          AI问答结果评判
        </button>
        <button
          class="normal cibutton"
          @click="routerPushTo('/intelligentHouse')"
        >
          智能助手标注
        </button>
        <button
          class="normal cibutton"
          @click="routerPushTo('/intelligenceArticle')"
        >
          智能文章助手
        </button>
      </div>
      <div class="cititle">智能媒体</div>
      <div class="cibuttonwarp">
        <button class="normal cibutton" @click="onPageClick('智能评价')">
          智能评价
        </button>
        <button class="normal cibutton" @click="onPageClick('智能标题')">
          智能标题
        </button>
        <button
          class="normal cibutton"
          @click="routerPushTo('/intelligenceSelectTopic')"
        >
          智能选题
        </button>
        <button class="normal cibutton" @click="routerPushTo('/voiceClone')">
          克隆声音
        </button>
        <button class="normal cibutton" @click="routerPushTo('/articleAdapt')">
          文章改进与重编
        </button>
        <button class="normal cibutton" @click="onPageClick('楼盘评测视频')">
          楼盘评测视频
        </button>
        <button class="normal cibutton" @click="onPageClick('楼盘评测文章')">
          楼盘评测文章
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/shanghai/articleManage' })"
        >
          文章管理
        </button>
        <button class="normal cibutton" @click="onPageClick('智能话题管理')">
          智能话题管理
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/houseSelectService' })"
        >
          选房服务后台
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/estateTagManage' })"
        >
          楼盘标签
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/featuredListings' })"
        >
          精选房源
        </button>
      </div>
      <div class="cititle">楼盘分类</div>
      <div class="cibuttonwarp">
        <button class="normal cibutton" @click="getApartList()">4室户型</button>
        <button class="normal cibutton" @click="getOldPrice()">
          2-3万楼盘
        </button>
        <button class="normal cibutton" @click="getHouse()">90方楼盘</button>
      </div>
      <div class="cititle">楼盘动态</div>
      <div class="cibuttonwarp">
        <button class="normal cibutton" @click="getEstateGS('正在公示')">
          正在公示表格
        </button>
        <button class="normal cibutton" @click="getEstateGS('正在登记')">
          正在登记表格
        </button>
        <button class="normal cibutton" @click="getEstateText('正在公示')">
          正在公示文本
        </button>
        <button class="normal cibutton" @click="getEstateText('正在登记')">
          正在登记文本
        </button>
        <button class="normal cibutton" @click="showNews">最新政府文章</button>
        <button class="normal cibutton" @click="getEstateRate">近期摇号</button>
        <button class="normal cibutton" @click="getEstateZJ()">总价楼盘</button>
        <button class="normal cibutton" @click="getyuji()">
          预计开盘excel/sale
        </button>
        <button class="normal cibutton" @click="getHzTitle()">杭州公示</button>
        <button class="normal cibutton" @click="getZJRecent()">中签率</button>
      </div>
      <div class="cititle">楼盘周边</div>
      <div class="cibuttonwarp">
        <button class="normal cibutton" @click="onNearbyClick">附近地图</button>
        <button class="normal cibutton" @click="toMapPage('板块')">
          板块图
        </button>
        <button class="normal cibutton" @click="toMapPage('控规')">
          板块规划
        </button>
        <button class="normal cibutton" @click="toMapPage('板块规划')">
          控规图
        </button>
        <button class="normal cibutton" @click="toMapPage('高架')">
          快速路
        </button>
        <button class="normal cibutton" @click="toMapPage('板块热力')">
          热力图
        </button>
        <button class="normal cibutton" @click="toMapPage('地铁图')">
          地铁图
        </button>
        <button class="normal cibutton" @click="checkEstateImageNum">
          楼盘图片视频数量
        </button>
      </div>
      <div class="cititle">干货地图</div>
      <div class="cibuttonwarp">
        <button class="normal cibutton" @click="toMapPage('新房', '全城左')">
          新房左
        </button>
        <button class="normal cibutton" @click="toMapPage('新房', '全城右')">
          新房右
        </button>
        <button class="normal cibutton" @click="toMapPage('新房', '全城')">
          新房整
        </button>
        <button class="normal cibutton" @click="toMapPage('待首开', '全城左')">
          待首开和土拍左
        </button>
        <button class="normal cibutton" @click="toMapPage('待首开', '全城右')">
          待首开和土拍右
        </button>
        <button class="normal cibutton" @click="toMapPage('待首开', '全城')">
          待首开和土拍整
        </button>
        <button class="normal cibutton" @click="toMapPage('土拍', '全城左')">
          土拍左
        </button>
        <button class="normal cibutton" @click="toMapPage('土拍', '全城右')">
          土拍右
        </button>
        <button class="normal cibutton" @click="toMapPage('土拍', '全城')">
          土拍整
        </button>
        <button
          class="normal cibutton"
          @click="toMapPage('土拍圆点', '全城左')"
        >
          土拍圆点左
        </button>
        <button
          class="normal cibutton"
          @click="toMapPage('土拍圆点', '全城右')"
        >
          土拍圆点右
        </button>
        <button class="normal cibutton" @click="toMapPage('土拍圆点', '全城')">
          土拍圆点整
        </button>
        <button
          class="normal cibutton"
          @click="toMapPage('公示登记', '全城左')"
        >
          公示登记左
        </button>
        <button
          class="normal cibutton"
          @click="toMapPage('公示登记', '全城右')"
        >
          公示登记右
        </button>
        <button class="normal cibutton" @click="toMapPage('公示登记', '全城')">
          公示登记整
        </button>
        <button class="normal cibutton" @click="toMapPage('科创大走廊')">
          科创大走廊
        </button>
        <button
          class="normal cibutton"
          @click="toMapPage('新房', area)"
          v-for="area in areaArr"
          :key="area"
        >
          {{ area }}
        </button>
      </div>
      <div class="cititle">房产政策</div>
      <div class="cibuttonwarp">
        <button
          class="normal cibutton"
          @click="routerPushTo('/propertyPolicy')"
        >
          房产政策数据库
        </button>
      </div>
      <div class="cititle">二手房</div>
      <div class="cibuttonwarp">
        <button
          class="normal cibutton"
          @click="routerPushTo('/areaTwoHouseMoonDeal')"
        >
          区域月成交
        </button>
        <button
          class="normal cibutton"
          @click="routerPushTo('/schoolTwoHouseDeal')"
        >
          学区成交查询
        </button>
        <button
          class="normal cibutton"
          @click="routerPushTo('/areaTwoHouseHighestDeal')"
        >
          区域成交榜单
        </button>
        <button
          class="normal cibutton"
          @click="routerPushTo('/beikeSechandHouse')"
        >
          贝壳二手房数据查询
        </button>
        <button class="normal cibutton" @click="drawPoster2(1)">
          每日早报(成交)
        </button>
        <button class="normal cibutton" @click="drawPoster2(2)">
          每日早报(挂牌)
        </button>
        <button
          class="normal cibutton"
          @click="routerPushTo('/secondDistrictSale')"
        >
          区域二手房成交/挂牌查询
        </button>
        <button
          class="normal cibutton"
          @click="routerPushTo('/secondSchoolSale')"
        >
          学区二手房成交/挂牌查询
        </button>
        <button
          class="normal cibutton"
          @click="routerPushTo('/secondSubwaySale')"
        >
          地铁二手房成交/挂牌查询
        </button>
        <button
          class="normal cibutton"
          @click="routerPushTo('/areanameDataSummary')"
        >
          板块数据概括查询
        </button>
        <button
          class="normal cibutton"
          @click="routerPushTo('/schoolDataSummary')"
        >
          学区数据概括查询
        </button>
        <button
          class="normal cibutton"
          @click="routerPushTo('/EstateHousesSearch')"
        >
          在售楼盘查询
        </button>
        <button
          class="normal cibutton"
          @click="routerPushTo('/priceChangeAnalysis')"
        >
          涨价降价房源筛选
        </button>
        <button
          class="normal cibutton"
          @click="routerPushTo('/newHouseFilter')"
        >
          新房楼盘筛选
        </button>
      </div>

      <div class="cititle">其他</div>
      <div class="cibuttonwarp">
        <button class="normal cibutton" @click="getGongZong()">
          公众号消息通知
        </button>

        <button class="normal cibutton" @click="getHotingList()">
          生命周期
        </button>
        <button class="normal cibutton" @click="getEstateSort()">
          近期排行
        </button>
        <button
          class="normal cibutton"
          style="overflow: hidden; position: relative"
        >
          图片拼接
          <input type="file" multiple @change="combineImg" id="input_image" />
        </button>
        <button class="normal cibutton" @click="getVisitData">访问链接</button>

        <button class="normal cibutton" @click="toServiceReply">
          服务号回复
        </button>
        <button class="normal cibutton" @click="onPageClick('公众号管理')">
          公众号管理
        </button>
        <button class="normal cibutton" @click="onPageClick('导入小程序数据')">
          导入小程序数据
        </button>
        <button class="normal cibutton" @click="onPageClick('行情评论')">
          行情评论
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/estateAIAnalysis' })"
        >
          楼盘AI分析数据
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/bigScreenMapDisplay' })"
        >
          大屏幕地图展示
        </button>
      </div>
    </div>
    <div class="data" v-show="current === 'data'">
      <h3 class="normal">数据小队</h3>
      <div>
        <div class="cititle">猩号</div>
        <div class="cibuttonwarp">
          <button class="normal cibutton" @click="getPoiIformation()">
            筛选猩号空间
          </button>
          <button class="normal cibutton" @click="toOpinion()">
            猩号意见反馈
          </button>
          <button class="normal cibutton" @click="onPageClick('猩号空间管理')">
            猩号空间管理
          </button>
          <button class="normal cibutton" @click="gefinished()">
            筛选工作完成度表
          </button>
          <button
            class="normal cibutton"
            @click="routerPushTo('/couponManage')"
          >
            特惠项目管理
          </button>
        </div>
        <div class="cititle">评测类工具</div>
        <div class="cibuttonwarp">
          <button class="normal cibutton" @click="houseTypeTools()">
            户型工具
          </button>
          <button class="normal cibutton" @click="toMapPage('控规')">
            板块规划
          </button>
          <button class="normal cibutton" @click="toMapPage('板块规划')">
            控规图
          </button>
          <button class="normal cibutton" @click="toHangPai()">航拍管理</button>
          <button class="normal cibutton" @click="ToaerialSurvey()">
            航拍排查
          </button>
          <button class="normal cibutton" @click="toPoiManage()">
            POI管理
          </button>
        </div>
        <div class="cititle">问答类工具</div>
        <div class="cibuttonwarp">
          <button class="normal cibutton" @click="toTestReply">
            测试自动回复
          </button>
          <button class="normal cibutton" @click="questionSituation()">
            智能问答匹配情况
          </button>
          <button class="normal cibutton" @click="toGetOneDayTalk('数据')">
            群聊记录
          </button>
          <button class="normal cibutton" @click="onPageClick('自动问答')">
            自动问答管理
          </button>

          <button
            class="normal cibutton"
            @click="getStatisticalTable('tjList')"
          >
            匹配统计表格
          </button>
          <button class="normal cibutton" @click="checkMatchRecord()">
            问答匹配审核
          </button>
          <button class="normal cibutton" @click="chooseQuse()">
            判断问答是否为广告
          </button>
          <button class="normal cibutton" @click="totalAd()">
            问答广告统计表
          </button>
          <button
            class="normal cibutton"
            @click="changeListName('checkAutoReply')"
          >
            检查回答
          </button>
          <button class="normal cibutton" @click="routerPushTo('/checkAIAns')">
            AI问答结果评判
          </button>
          <button class="normal cibutton" @click="routerPushTo('/terminology')">
            专业词汇编辑
          </button>
          <button class="normal cibutton" @click="routerPushTo('/SearchCheck')">
            搜索结果标注
          </button>
          <button
            class="normal cibutton"
            @click="routerPushTo('/messageStatic')"
          >
            智能助手消息统计
          </button>
          <button
            class="normal cibutton"
            @click="routerPushTo('/intelligentHouse')"
          >
            智能助手标注
          </button>
        </div>
        <div class="cititle">统计类工具</div>
        <div class="cibuttonwarp">
          <button class="normal cibutton" @click="getPcList('pcList')">
            评测合计数据
          </button>
          <button class="normal cibutton" @click="getPcList('ptList')">
            配套合计数据
          </button>
          <button class="normal cibutton" @click="getNewPcList()">
            评测总和
          </button>
          <button class="normal cibutton" @click="getshuju()">数据系统</button>
          <button
            class="normal cibutton"
            @click="routerPushTo('/newHouseExtent')"
          >
            新房专业完整度
          </button>
          <button
            class="normal cibutton"
            @click="routerPushTo('/twoHouseExtent')"
          >
            二手房专业完整度
          </button>
          <button class="normal cibutton" @click="createAccout()">
            开发商账号管理
          </button>
          <button class="normal cibutton" @click="tohouseUploadData()">
            新增图片视频数量
          </button>
        </div>
        <div class="cititle">土拍</div>
        <div class="cibuttonwarp">
          <el-button class="normal cibutton" :loading="candidateLoading" @click="openCreateBatch">
            新建土拍批次
          </el-button>
          <select name="" id="" v-model="landStatusState">
            <option value="待出让">待出让</option>
            <option value="已出让">已出让</option>
          </select>
          <input type="text" placeholder="第几批" v-model="landStatusBatch" />
          <button class="normal cibutton" @click="changeLandStatus()">
            更改
          </button>
        </div>

        <el-dialog title="新建土拍批次" :visible.sync="batchDialogVisible" width="850px"
          :close-on-click-modal="false" :close-on-press-escape="!batchSubmitting" :show-close="!batchSubmitting">
          <el-form label-width="90px" @submit.native.prevent>
            <el-form-item label="批次名称">
              <el-input v-model="batchName" maxlength="50" :disabled="batchSubmitting" />
            </el-form-item>
          </el-form>
          <p>仅显示今天录入且未归批次的地块，默认全选，可取消勾选。</p>
          <el-table ref="candidateTable" :data="batchCandidates" row-key="id" border
            @selection-change="selectedLands = $event">
            <el-table-column type="selection" width="50" :selectable="() => !batchSubmitting" />
            <el-table-column prop="number" label="宗地编号" width="200" />
            <el-table-column prop="name" label="地块名称" />
            <el-table-column prop="district" label="区域" width="90" />
          </el-table>
          <p>已选 {{ selectedLands.length }} 个地块。创建后立即展示，楼盘和评分后台处理，结果会发送到钉钉信息监控群。</p>
          <span slot="footer">
            <el-button :disabled="batchSubmitting" @click="batchDialogVisible = false">取消</el-button>
            <el-button type="primary" :loading="batchSubmitting"
              :disabled="!batchName.trim() || !selectedLands.length" @click="createBatch">创建并后台处理</el-button>
          </span>
        </el-dialog>

        <div class="cititle">商铺</div>
        <div class="cibuttonwarp">
          <button class="normal cibutton" @click="createStore()">
            商铺编辑
          </button>
          <button class="normal cibutton" @click="toStoreLocation()">
            商铺周边位置编辑
          </button>
          <button class="normal cibutton" @click="toStorePeopleLocation()">
            商铺人流量位置编辑
          </button>
          <button class="normal cibutton" @click="toStoreHX()">
            商铺户型图编辑
          </button>
          <button class="normal cibutton" @click="toDrawStore()">画商铺</button>
        </div>

        <div class="cititle">二手房</div>
        <div class="cibuttonwarp">
          <button class="normal cibutton" @click="toMatchEstateName(true)">
            楼盘名称待匹配
          </button>
          <button class="normal cibutton" @click="getEstateNameMatchList()">
            楼盘名称已匹配
          </button>
          <button
            class="normal cibutton"
            @click="routerPushTo('/deleteEstate')"
          >
            删除二手楼盘
          </button>
          <button
            class="normal cibutton"
            @click="routerPushTo('/estateDealData')"
          >
            二手成交上传
          </button>
          <button
            class="normal cibutton"
            @click="routerPushTo('/agentUploadData')"
          >
            经纪人上传图片视频数量
          </button>
        </div>

        <div class="cititle">审核</div>
        <div class="cibuttonwarp">
          <button class="normal cibutton" @click="onPageClick('新房图片审核')">
            图片视频审核
          </button>
          <button
            class="normal cibutton"
            @click="onPageClick('上传楼盘详情审核')"
          >
            上传楼盘详情审核
          </button>
          <button class="normal cibutton" @click="onPageClick('新增配套审核')">
            新增配套审核
          </button>
          <el-badge
            :is-dot="pointData.hasInfoFeedbackAudit"
            class="red-point-item"
          >
            <button class="cibutton" @click="toEstateImportDataModify()">
              楼盘重磅资料审核
            </button>
          </el-badge>
          <button class="normal cibutton" @click="onPageClick('置业顾问管理')">
            置业顾问管理
          </button>
          <button
            class="normal cibutton"
            @click="routerPushTo('/communityFacilityAudit')"
          >
            小区设施审核
          </button>
        </div>
        <div class="cititle">其他</div>
        <div class="cibuttonwarp">
          <button class="normal cibutton" @click="searchGsReal()">
            追踪公示楼盘数据
          </button>

          <button class="normal cibutton" @click="getSellList()">
            2020后公示数据
          </button>
          <button
            class="normal cibutton"
            v-if="$store.state.Counter.city === '苏州'"
            @click="szYuShouList()"
          >
            预售证楼盘
          </button>
          <button
            class="normal cibutton"
            v-if="$store.state.Counter.city === '苏州'"
            @click="matchAdvance()"
          >
            更新预售证
          </button>
          <button class="normal cibutton" @click="listName = 'updataImage'">
            更新截图
          </button>
          <button class="normal cibutton" @click="toEstateAsManage">
            楼盘别名管理
          </button>
          <button class="normal cibutton" @click="onPageClick('拆迁地图数据')">
            拆迁地图数据
          </button>
          <button
            class="normal cibutton"
            @click="showGFTnotice"
            :disabled="isLoading"
          >
            <span v-if="isLoading">加载中...</span>
            <span v-else>购房通公示</span>
          </button>
          <button class="normal cibutton" @click="queryAllFreePrice()">
            一房一价绑定
          </button>
          <button
            class="normal cibutton"
            @click="$router.push({ path: '/infoOfflineManage' })"
          >
            信息下架管理
          </button>
          <button
            v-if="$store.state.Counter.city === '杭州'"
            class="normal cibutton"
            @click="onPageClick('成交数据')"
          >
            成交数据
          </button>
        </div>
        <div class="cibuttonwarp">
          <div class="add-margin">
            <el-select size="small" v-model="type" style="width: 100px">
              <el-option value="新房">新房</el-option>
              <el-option value="二手房">二手房</el-option>
            </el-select>
          </div>
          <div class="add-margin">
            <el-select
              size="small"
              v-model="value"
              style="width: 100px; margin-left: 5px"
            >
              <el-option value="日照">日照</el-option>
              <el-option value="户型">户型</el-option>
            </el-select>
          </div>
          <div class="add-margin">
            <el-date-picker
              size="small"
              style="margin-left: 5px"
              v-model="checkDate1"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
          </div>

          <button class="normal cibutton" @click="getSunHouse('详情')">
            查询
          </button>

          <!--
              <button class="normal cibutton"  @click="getSunHouse('日照')">日照</button>
              <button class="normal cibutton"  @click="getSunHouse('户型')">户型</button>
            -->
        </div>
        <div class="cibuttonwarp">
          <div class="add-margin">
            <el-date-picker
              size="small"
              v-model="value1"
              type="daterange"
              align="right"
              unlink-panels
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </div>

          <button class="normal cibutton" @click="getSunHouse('统计')">
            统计近期上传数据
          </button>
        </div>

        <div class="cititle">产业评测</div>
        <div class="cibuttonwarp">
          <div>
            <el-select
              class="add-margin"
              size="small"
              v-model="valueBigType"
              style="width: 100px"
              @change="changeValueMap"
            >
              <el-option label="楼盘" value="estate"> </el-option>
              <el-option label="板块" value="area"> </el-option>
            </el-select>
            <el-select
              class="add-margin"
              size="small"
              v-model="valueType"
              placeholder="选择类别"
              style="width: 100px"
            >
              <el-option
                v-for="(value, key) in valueMap"
                :key="key"
                :label="value"
                :value="key"
              >
              </el-option>
            </el-select>
          </div>
          <button class="normal cibutton" @click="updateEstateValue('sort')">
            查看产业排序
          </button>
          <button class="normal cibutton" @click="goEstateValueMap(valueType)">
            查看产业地图
          </button>
          <button class="normal cibutton" @click="updateEstateValue('count')">
            更新产业计算
          </button>
          <button class="normal cibutton" @click="updateEstateValue('score')">
            更新产业分
          </button>
        </div>

        <div class="cititle">其它评测</div>
        <div class="cibuttonwarp">
          <el-select
            class="add-margin"
            size="small"
            v-model="valueOtherType"
            style="width: 100px"
          >
            <el-option label="配套" value="配套"> </el-option>
            <el-option label="规划" value="规划"> </el-option>
            <el-option label="配套密度" value="配套密度"> </el-option>
          </el-select>
          <el-select
            class="add-margin"
            size="small"
            v-model="locationType"
            placeholder="选择类别"
            style="width: 100px"
            v-if="valueOtherType == '配套'"
          >
            <el-option
              v-for="(value, key) in locationMap"
              :key="key"
              :label="value"
              :value="key"
            >
            </el-option>
          </el-select>
          <button
            class="normal cibutton"
            @click="getOtherValueScore(valueOtherType)"
          >
            查看排序
          </button>
          <button
            class="normal cibutton"
            @click="goEstateValueMap('', valueOtherType)"
          >
            查看地图
          </button>
          <button
            class="normal cibutton"
            @click="goEstateValueMap('', '安置房')"
          >
            安置房地图
          </button>
          <button
            class="normal cibutton"
            @click="routerPushTo('/sunshineEvaluation')"
          >
            日照评测
          </button>
        </div>
      </div>
    </div>
    <div class="innovate" v-show="current === 'innovate'">
      <h3 class="normal">创新小队</h3>
      <div class="cititle">全部功能</div>
      <div class="cibuttonwarp">
        <div class="add-margin">小程序图标上传</div>
        <div class="add-margin">
          <input
            type="text"
            size="small"
            placeholder="图片名称, 不要后缀"
            v-model="imageName"
          />
        </div>
        <div class="add-margin">
          <input type="file" size="small" @change="chooseImage" />
        </div>
        <div>{{ imageSrc }}</div>
        <button
          class="normal cibutton"
          v-if="userType === '系统管理员'"
          @click="$router.push({ path: 'employee' })"
        >
          后台账号管理
        </button>
        <button class="normal cibutton" @click="checkErp">checkErp</button>
        <button
          class="normal cibutton"
          v-if="userType === '系统管理员'"
          @click="switchTimedTask('定时任务')"
        >
          开关定时任务
        </button>
        <button class="normal cibutton" @click="switchTimedTask('用户校验')">
          开关用户校验
        </button>
        <button
          class="normal cibutton"
          v-if="userType === '系统管理员'"
          @click="switchTimedTask('实时加分')"
        >
          开关实时加分
        </button>
        <button
          class="normal cibutton"
          v-if="userType === '系统管理员'"
          @click="switchTimedTask('房源视频')"
        >
          开关房源视频
        </button>
        <button class="normal cibutton" @click="checkOldSpider">
          二手房爬虫
        </button>
        <!--
          <button class="normal" type="primary" @click="sehflalseh()">sehflalseh</button>
        -->
        <button class="normal cibutton" @click="getMoments()">
          加分失败打印
        </button>
        <button class="normal cibutton" @click="getLogs">小鸡错误日志</button>
        <button class="normal cibutton" @click="toGetUpdataApp()">
          猩号app版本更新
        </button>
        <button class="normal cibutton" @click="getXHLogs()">
          猩号错误日志
        </button>
        <button class="normal cibutton" @click="toTestReply">
          测试自动回复
        </button>
        <button class="normal cibutton" @click="selcectCheWei">
          车位材料判断
        </button>
        <button class="normal cibutton" @click="toEmoticon">
          猩号表情管理
        </button>
        <button
          class="normal cibutton"
          @click="$router.push({ path: '/xiaojiEmoji' })"
        >
          小鸡表情管理
        </button>
        <!-- <button class="normal cibutton" @click="estateLabel">楼栋标签编辑</button> -->
        <button class="normal cibutton" @click="toChoosePriceFile">
          更新二手均价
        </button>
        <button
          class="normal cibutton"
          @click="routerPushTo('/wechatMiniProgramDataTrend')"
        >
          小程序数据趋势
        </button>
        <button class="normal cibutton" @click="routerPushTo('/versionTips')">
          版本更新说明
        </button>
      </div>
      <div class="cititle">其他</div>
      <div class="cibuttonwarp">
        <div class="add-margin">
          <el-date-picker
            size="small"
            v-model="checkDate2"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
        </div>

        <!--
          <el-button type="primary" @click="getGiveTime">交付名单</el-button>
        -->
        <!-- <button
          class="normal cibutton" @click="getVisitData">整体访问量</button> -->
        <button class="normal cibutton" @click="showPageHits('首页')">
          新房首页点击数
        </button>
        <button class="normal cibutton" @click="showPageHits('楼盘页面')">
          新房楼盘页点击数
        </button>
        <button class="normal cibutton" @click="showPageHits('二手房首页')">
          二手房首页点击数
        </button>
        <button class="normal cibutton" @click="showPageHits('二手楼盘首页')">
          二手房楼盘页点击数
        </button>

        <button class="normal cibutton" @click="talkNum">群互动</button>
        <button class="normal cibutton" @click="getRedEvbag">红包</button>

        <button class="normal cibutton" @click="getchuangxin()">
          数据系统
        </button>
        <button class="normal cibutton" @click="onPageClick('猩号炒群')">
          猩号炒群
        </button>
        <button class="normal cibutton" @click="getDataInfo()">数据面板</button>
        <button
          v-if="canViewPerformanceMonitor"
          class="normal cibutton"
          @click="routerPushTo('/performance-monitor')"
        >
          性能监控
        </button>
      </div>
      <div class="cititle">家电</div>
      <div class="cibuttonwarp">
        <button class="normal cibutton" @click="toNewGoods()">新建商品</button>
        <button class="normal cibutton" @click="toGoodsShow()">商品展示</button>
        <button
          class="normal cibutton"
          @click="routerPushTo('/businessIfoUpload')"
        >
          商家信息上传
        </button>
        <button
          class="normal cibutton"
          @click="routerPushTo('/businessInfoshow')"
        >
          商家信息展示
        </button>
      </div>
      <div class="cititle">装修</div>
      <div class="cibuttonwarp">
        <button
          class="normal cibutton"
          @click="routerPushTo('/renovationManage')"
        >
          装修品牌及活动管理
        </button>
      </div>
    </div>
    <!-- 内部权限 -->
    <div class="authority" v-show="current === 'authority'">
      <h3 class="normal">内部权限</h3>
    </div>

    <div class="market" v-show="current === 'feedback'">
      <h3 class="normal">意见反馈</h3>
      <div class="cibuttonwarp">
        <button
          class="normal cibutton"
          @click="routerPushTo('/feedbackQuestion')"
        >
          意见反馈
        </button>
        <button class="normal cibutton" @click="routerPushTo('/feedbackCount')">
          意见统计
        </button>
      </div>
    </div>

    <!--
      <div>
        搜索文章
        <input type="text" @keydown.enter="searchArticle">
        <div v-for="item in articleList" :key="item.id" @click="showArticleShare(item.id,item.title)">{{item.title}}</div>
      </div>
    -->
    <!-- <el-button type="primary" @click="updateAll">所有户型</el-button> -->
    <div v-if="showZxTable" style="max-width: 500px; margin: 50px auto">
      <h2 style="text-align: center; margin: 20px 0">装修推广数据</h2>
      <el-date-picker
        v-model="zxDataTime"
        type="daterange"
        range-separator="至"
        value-format="yyyy-MM-dd"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="margin: 20px"
      >
      </el-date-picker>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="getZXData()"
      >
        搜索
      </el-button>
      <el-table :data="zxData" border stripe>
        <el-table-column prop="date" label="日期" width="100px">
        </el-table-column>
        <el-table-column prop="new_pv" label="新房首页按钮曝光">
        </el-table-column>
        <el-table-column prop="second_pv" label="二手房首页按钮曝光">
        </el-table-column>
        <el-table-column prop="new_ad_exposure" label="新房首页贴片曝光">
        </el-table-column>
        <el-table-column prop="second_ad_exposure" label="二手房首页贴片曝光">
        </el-table-column>
      </el-table>
    </div>
    <div v-if="showZxConsult" style="max-width: 500px; margin: 50px auto">
      <h2 style="text-align: center; margin: 20px 0">
        装修推广的电话量和咨询量统计数据
      </h2>
      <el-date-picker
        v-model="zxConsultTime"
        type="daterange"
        range-separator="至"
        value-format="yyyy-MM-dd"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="margin: 20px"
      >
      </el-date-picker>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="getZXConsult()"
      >
        搜索
      </el-button>
      <el-table :data="zxConsult" border stripe @cell-click="modifyZXData">
        <el-table-column prop="date" label="日期" width="100px">
        </el-table-column>
        <el-table-column prop="phone" label="电话"> </el-table-column>
        <el-table-column prop="talk" label="咨询"> </el-table-column>
      </el-table>
    </div>
    <div v-show="showSale" style="max-width: 680px; margin: 50px auto">
      <h2 style="text-align: center; margin: 20px 0">
        {{ checkDate1 }}{{ listName == "shareTop" ? "销售" : "经纪人" }}分享排名
      </h2>
      <el-select v-model="areaValue" v-if="listName == 'shareTop'">
        <el-option
          v-for="item in areaFilterList"
          :key="item.value"
          :label="item.text"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="scoreType"
        @change="getShareTop('销售', areaValue, scoreType)"
        v-if="listName == 'shareTop'"
      >
        <el-option label="邀请用户得分" :value="null"></el-option>
        <el-option label="仅签到得分" :value="'仅签到得分'"></el-option>
        <el-option label="转发文章得分" :value="'转发文章得分'"></el-option>
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="getShareTop('销售', areaValue, scoreType)"
        style="margin-left: 10px"
      >
        搜索
      </el-button>
      <el-table
        v-if="
          shareTop.length > 0 &&
          (listName == 'shareTop' || listName == 'shareTop2')
        "
        :data="shareTop"
        border
        stripe
      >
        <el-table-column prop="index" label="排名" width="50">
        </el-table-column>
        <el-table-column prop="user_name" label="姓名" width="80">
        </el-table-column>
        <el-table-column
          prop="district"
          label="区域"
          :filters="district"
          :filter-method="filterHandler"
        >
        </el-table-column>
        <el-table-column prop="real_estate_name" label="楼盘">
        </el-table-column>
        <el-table-column
          prop="total"
          :label="scoreType || '邀请用户得分'"
          width="150"
        >
          <template slot-scope="{ row }">
            <span>{{
              !scoreType
                ? row.total
                : scoreType == "仅签到得分"
                ? row.detail[row.time.split(" ")[0]].qd
                : row.detail[row.time.split(" ")[0]].article
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="time" label="时间" width="160">
        </el-table-column>
      </el-table>
    </div>
    <div
      v-if="sharePublic.length > 0 && listName == 'sharePublic'"
      style="max-width: 332px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">合作公众号分享数据</h2>
      <el-table :data="sharePublic" border stripe>
        <el-table-column prop="user_name" label="姓名" width="150">
        </el-table-column>
        <el-table-column prop="point" label="分享次数" width="180">
        </el-table-column>
      </el-table>
    </div>
    <div
      v-if="listName == 'shareTop3'"
      style="max-width: 700px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">
        {{ checkDate1 }}销售群聊违规
      </h2>
      <el-table :data="shareTop" border stripe>
        <el-table-column prop="create_time" label="消息时间" width="140px">
        </el-table-column>
        <el-table-column prop="user_name" label="姓名" width="80px">
        </el-table-column>
        <el-table-column prop="chat_name" label="群名"> </el-table-column>
        <el-table-column prop="content" label="违规内容"> </el-table-column>
      </el-table>
    </div>
    <div
      v-if="shareWeekTop.length > 0 && listName == 'shareWeekTop'"
      style="max-width: 580px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">销售上周分享分排名</h2>
      <el-table :data="shareWeekTop" border stripe>
        <el-table-column prop="index" label="排名"> </el-table-column>
        <el-table-column prop="user_name" label="姓名"> </el-table-column>
        <el-table-column prop="real_estate_name" label="楼盘">
        </el-table-column>
        <el-table-column prop="lastWeeks" label="总积分(上周)">
        </el-table-column>
      </el-table>
    </div>

    <div
      v-if="articleShares.length > 0 && listName == 'articleShares'"
      style="max-width: 580px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">文章分享排名</h2>
      <div>{{ articleTitle }}</div>
      <el-table :data="articleShares" border stripe>
        <el-table-column prop="index" label="排名"> </el-table-column>
        <el-table-column prop="user_name" label="姓名"> </el-table-column>
        <el-table-column prop="real_estate_name" label="楼盘">
        </el-table-column>
        <el-table-column prop="num" label="邀请人数"> </el-table-column>
      </el-table>
    </div>

    <div
      v-if="bindPriceList.length > 0 && listName == 'bindPriceList'"
      style="width: 700px; margin: 50px auto"
    >
      <h2>一房一价绑定</h2>
      <el-select
        v-model="bindPriceEstateId"
        filterable
        placeholder="搜索楼盘"
        default-first-option
        :remote-method="searchEstate"
        remote
      >
        <el-option
          v-for="(item, index) in matchEstates"
          :key="index"
          :label="item.real_estate_name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-table :data="bindPriceList" border stripe>
        <el-table-column prop="number" label="预售证"> </el-table-column>
        <el-table-column prop="name" label="楼盘名"> </el-table-column>
        <el-table-column prop="create_time" label="时间"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="toBindPriceEstate(scope.row, scope.$index)"
              >绑定</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div
      v-if="GsList.length > 0 && listName == 'GsList'"
      style="width: 700px; margin: 50px auto"
    >
      <div v-for="item in GsList" :key="item.id" style="margin: 20px 0">
        <h2>{{ item.state }}</h2>
        <el-table :data="item.list" border stripe>
          <el-table-column prop="real_estate_name" label="楼盘名" width="130px">
          </el-table-column>
          <el-table-column prop="hasSun" label="日照评测"> </el-table-column>
          <el-table-column prop="hasApart" label="户型评测"> </el-table-column>
          <el-table-column prop="hasEffect" label="楼栋评测"> </el-table-column>
          <el-table-column prop="hasPrice" label="一房一价"> </el-table-column>
          <el-table-column prop="hasNoise" label="噪音分析"> </el-table-column>
          <el-table-column prop="意向" label="意向登记"> </el-table-column>
          <el-table-column prop="摇号" label="摇号结果"> </el-table-column>
        </el-table>
      </div>
    </div>
    <div
      v-if="userList.length > 0 && listName == 'userList'"
      style="width: 520px; margin: 50px auto"
    >
      <el-table :data="filterUserList" border stripe>
        <el-table-column prop="id" label="id" width="110px"> </el-table-column>
        <el-table-column prop="user_name" label="名字" width="130px">
        </el-table-column>
        <el-table-column prop="user_type" label="身份"> </el-table-column>
        <el-table-column prop="user_status" label="状态" width="80px">
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="unStatus(scope.row, scope.$index)"
              >解禁</el-button
            >
          </template>
          <template slot="header" slot-scope="scope">
            <el-input
              v-if="scope.column"
              v-model="userSearch"
              size="mini"
              placeholder="输入关键字搜索"
            />
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div v-if="interest.list && listName == 'interest'">
      <h2>编辑银行利率</h2>
      <div class="normal">
        更新时间：<input type="text" v-model="interest.update_time" />
      </div>
      <div v-for="(bl, index) in interest.list" :key="index">
        <div style="margin-bottom: 10px">
          <div>
            银&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;行：<input
              type="text"
              v-model="bl.bank"
            />
          </div>
          <div>
            首套利率：<input type="text" v-model="bl.firstInterestRate" />
          </div>
          <div>首套 LPR：<input type="text" v-model="bl.firstLPR" /></div>
          <div>
            二套利率：<input type="text" v-model="bl.secondInterestRate" />
          </div>
          <div style="border-bottom: 1px solid #eee; padding-bottom: 10px">
            二套 LPR：<input type="text" v-model="bl.secondLPR" />
          </div>
        </div>
      </div>
      <el-button type="primary" @click="toadd()">添加</el-button>
      <el-button type="primary" @click="perserve()">保存</el-button>
    </div>

    <div v-if="listName == 'essay'" style="margin-top: 40px">
      <h2 v-if="essay.length == 0">编辑合作公众号</h2>
      <div v-if="essay.length != 0">
        <h2>编辑合作公众号</h2>
        <div v-for="(es, index) in essay" :key="index">
          <div style="margin: 20px 0">
            <input type="text" v-model="essay[index]" />
          </div>
        </div>
      </div>
      <div style="margin-top: 20px">
        <el-button type="primary" @click="toEssayAdd()">添加</el-button>
        <el-button type="primary" @click="essayPerserve()">保存</el-button>
      </div>
    </div>

    <div
      v-if="phoneUsers.length > 0 && listName == 'phoneUsers'"
      style="width: 520px; margin: 50px auto"
    >
      <el-table :data="phoneUsers" border stripe>
        <el-table-column prop="phone" label="电话" width="100">
        </el-table-column>
        <el-table-column prop="from" label="来源" width="80"> </el-table-column>
        <el-table-column prop="real_estate_name" label="楼盘">
        </el-table-column>
        <el-table-column prop="create_time" label="时间" width="160">
        </el-table-column>
      </el-table>
    </div>

    <div
      v-if="talkRecord.length > 0 && listName == 'talkRecord'"
      style="display: inline-block; margin: 50px auto"
    >
      <el-table :data="talkRecord" border stripe>
        <el-table-column prop="date" label="日期" width="100">
        </el-table-column>
        <el-table-column prop="dh" label="被动电话" width="100">
        </el-table-column>
        <el-table-column prop="zx" label="被动咨询" width="100">
        </el-table-column>
        <!-- <el-table-column
          :prop="key"
          :label="value"
          width="120"
          v-for="(value, key) in talkUserMap"
          :key="key"
        >
        </el-table-column> -->
      </el-table>
    </div>

    <div
      v-if="yuyueList.length > 0 && listName == 'yuyueList'"
      style="width: 700px; margin: 50px auto"
    >
      <el-table :data="yuyueList" border stripe>
        <el-table-column prop="create_time" label="时间" width="140px">
        </el-table-column>
        <el-table-column prop="name" label="名字" width="80px">
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="100px">
        </el-table-column>
        <el-table-column prop="real_estate_name" label="楼盘" width="180px">
        </el-table-column>
        <el-table-column prop="content" label="联系"> </el-table-column>
      </el-table>
    </div>

    <div
      v-if="newsList.length > 0 && listName == 'newsList'"
      style="width: 200px; margin: 50px auto"
    >
      <el-table :data="newsList" border stripe>
        <el-table-column prop="real_estate_name" label="楼盘">
        </el-table-column>
      </el-table>
    </div>
    <div
      v-if="addList.length > 0 && listName == 'addList'"
      style="width: 400px; margin: 50px auto"
    >
      <el-table :data="addList" border stripe>
        <el-table-column prop="date" label="时间"> </el-table-column>
        <el-table-column prop="num1" label="销售动态"> </el-table-column>
        <el-table-column prop="num2" label="小区内配套"> </el-table-column>
      </el-table>
    </div>
    <div v-if="listName == 'getGongZong'" style="margin-top: 40px">
      <h2 v-if="essay.length == 0">编辑公众号</h2>
      <div v-if="essay.length != 0">
        <h2>编辑公众号</h2>
        <div v-for="(es, index) in essay" :key="index">
          <div style="margin: 20px 0">
            <input type="text" v-model="essay[index]" />
          </div>
        </div>
      </div>
      <div style="margin-top: 20px">
        <el-button type="primary" @click="toEssayAdd()">添加</el-button>
        <el-button type="primary" @click="essayGetGongZong()">保存</el-button>
      </div>
    </div>
    <div
      v-if="checkSaleAd1.length > 0 && listName == 'checkSaleAd1'"
      style="max-width: 880px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">销售展示位账单记录</h2>
      <el-table
        :data="checkSaleAd1"
        border
        stripe
        show-summary
        :summary-method="getSummaries"
      >
        <el-table-column prop="time" label="时间" width="160px">
        </el-table-column>
        <el-table-column prop="operate" label="操作" width="80px">
        </el-table-column>
        <el-table-column prop="user_name" label="销售名"> </el-table-column>
        <el-table-column prop="real_estate_name" label="楼盘名" width="180px">
        </el-table-column>
        <el-table-column prop="money" label="金额" width="70px">
        </el-table-column>
        <el-table-column prop="start_time" label="起始日" width="100px">
        </el-table-column>
        <el-table-column prop="end_time" label="结束日" width="100px">
        </el-table-column>
      </el-table>
    </div>
    <div v-if="listName == 'seleceRZList'">
      <div style="margin: 20px 0">
        <el-select
          v-model="updataImage_text"
          filterable
          placeholder="搜索楼盘"
          default-first-option
          :remote-method="searchEstate"
          remote
        >
          <el-option
            v-for="(item, index) in matchEstates"
            :key="index"
            :label="item.real_estate_name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div v-if="listName == 'updataImage'">
      <div style="margin: 20px 0">
        <el-select
          v-model="updataImage_text"
          filterable
          placeholder="搜索楼盘"
          default-first-option
          :remote-method="searchEstate"
          remote
        >
          <el-option
            v-for="(item, index) in matchEstates"
            :key="index"
            :label="`${item.real_estate_name}(${item.type})`"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <el-select
        v-model="updataImage_type"
        placeholder="选择类别"
        style="width: 100px"
      >
        <el-option
          v-for="(type, index) of [
            {
              value: '投资价值',
              label: '投资价值',
            },
            {
              value: 'landplan',
              label: '规划',
            },
            {
              value: 'location',
              label: '配套',
            },
            {
              value: 'locationDensity',
              label: '便民',
            },
            {
              value: 'area',
              label: '板块',
            },
            {
              value: 'hxfb',
              label: '户型分布',
            },
            {
              value: 'sun',
              label: '日照',
            },
            {
              value: 'noise',
              label: '噪声',
            },
            {
              value: 'jg3d',
              label: '景观',
            },
            {
              value: 'people',
              label: '人口热力图',
            },
            {
              value: 'store',
              label: '周边商铺',
            },
            {
              value: 'industry',
              label: '周边产业',
            },
          ]"
          :label="type.label"
          :key="index + '555'"
          :value="type.value"
        >
        </el-option>
      </el-select>
      <button @click="updataImage_sure">确定</button>
    </div>
    <div
      v-if="visitData.length > 0 && listName == 'visitData'"
      style="max-width: 1200px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">近7日访问</h2>
      <div style="margin: 20px 0">
        <div style="margin: 20px 0">
          搜索楼盘id：<input
            type="text"
            placeholder="输入楼盘名 回车搜索"
            @keyup.enter="searchReal"
            v-model="searchText"
            style="width: 200px"
          />
          <div v-for="item in showdblist" :key="item.id">
            {{ item.real_estate_name }}：{{ item.id }}
          </div>
        </div>
        <div v-if="resultName === '个人空间'" style="margin: 20px 0">
          填写顾问id：<input
            type="text"
            placeholder="填写顾问的用户id"
            v-model="userId"
            style="width: 200px"
          />
        </div>
        <div v-if="resultName === '某个户型评测'" style="margin: 20px 0">
          填写户型编号：<input
            type="text"
            placeholder="填写户型编号"
            v-model="imgName2"
            style="width: 200px"
          />
        </div>
        <div v-if="showRealSearch" style="margin: 20px 0">
          填写楼盘id：<input
            type="text"
            placeholder="填写楼盘id"
            v-model="valueRealId"
            style="width: 200px"
          />
        </div>
        <el-select
          v-model="colType"
          placeholder="选房"
          style="width: 100px"
          v-if="resultName === '选日楼价'"
        >
          <el-option
            v-for="type in ['选房', '日照', '一房一价', '楼栋', '噪声']"
            :key="type"
            :label="type"
            :value="type"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="shouyeType"
          placeholder="正在公示"
          style="width: 100px"
          v-if="resultName === '公示/登记/摇号/预计'"
        >
          <el-option
            v-for="type in ['正在公示', '正在登记', '摇号查询', '预计开盘']"
            :key="type"
            :label="type"
            :value="type"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="tabbarStr"
          placeholder="买房问答"
          style="width: 100px"
          v-if="resultName === '买房/讨论/土拍/学区'"
        >
          <el-option
            v-for="type in ['买房问答', '楼市消息', '讨论', '土拍', '学区找房']"
            :key="type"
            :label="type"
            :value="type"
          >
          </el-option>
        </el-select>

        <el-button type="primary" @click="getShareLoad">生成分享路径</el-button>
        <div v-if="resultStr" style="margin: 20px 0">
          {{ resultName }}：{{ resultStr }}
        </div>
      </div>
      <el-table
        :data="visitData"
        border
        stripe
        @header-click="sortVisit"
        @cell-click="findFX"
      >
        <el-table-column prop="page_name" label="页面"> </el-table-column>
        <el-table-column prop="share_path" label="分享路径" width="300">
        </el-table-column>
        <el-table-column prop="page_visit_pv" label="访问次数">
        </el-table-column>
        <el-table-column prop="page_visit_uv" label="访问人数">
        </el-table-column>
        <el-table-column prop="page_staytime_pv" label="次均时长">
        </el-table-column>
        <el-table-column prop="entrypage_pv" label="入口页次数">
        </el-table-column>
        <el-table-column prop="exitpage_pv" label="退出页次数">
        </el-table-column>
        <el-table-column prop="exit_rate" label="退出率"> </el-table-column>
        <el-table-column prop="page_share_pv" label="分享次数">
        </el-table-column>
        <el-table-column prop="page_share_uv" label="分享人数">
        </el-table-column>
      </el-table>
    </div>

    <div
      v-if="estateImageNum.length > 0 && listName == 'estateImageNum'"
      style="max-width: 1450px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">楼盘图片视频数量</h2>
      <el-table
        :data="estateImageNum"
        border
        stripe
        @header-click="sortImageNum"
      >
        <el-table-column prop="real_estate_name" label="楼盘名">
        </el-table-column>
        <el-table-column
          prop="district"
          label="区域"
          width="70"
          :filters="filterDistrits"
          :filter-method="filterEstate"
        >
        </el-table-column>
        <el-table-column prop="area_name" label="板块" width="100">
        </el-table-column>
        <el-table-column
          prop="real_status"
          label="状态"
          width="70"
          :filters="[
            { text: '在售', value: '在售' },
            { text: '待首开', value: '待首开' },
          ]"
          :filter-method="filterEstate"
        >
        </el-table-column>
        <el-table-column
          prop="build_type"
          label="类型"
          width="70"
          :filters="[
            { text: '住宅', value: '住宅' },
            { text: '商住', value: '商住' },
          ]"
          :filter-method="filterEstate"
        >
        </el-table-column>
        <el-table-column prop="loc" label="区位配套" width="80">
        </el-table-column>
        <el-table-column prop="estate" label="楼盘图" width="70">
        </el-table-column>
        <el-table-column prop="apart" label="户型图" width="70">
        </el-table-column>
        <el-table-column prop="video" label="视频" width="50">
        </el-table-column>
        <el-table-column prop="ybf" label="样板房视频" width="90">
        </el-table-column>
        <el-table-column prop="gw" label="顾问人数" width="90">
        </el-table-column>
        <el-table-column prop="ybfvr" label="样板房vr" width="90">
        </el-table-column>
        <el-table-column prop="hp" label="航拍" width="70"> </el-table-column>
        <el-table-column prop="dr" label="达人点评" width="90">
        </el-table-column>
        <el-table-column prop="art" label="小鸡文章" width="90">
        </el-table-column>
        <el-table-column prop="info" label="详情" width="70"> </el-table-column>
        <el-table-column prop="active_num" label="热度" width="70">
        </el-table-column>
      </el-table>
    </div>

    <div
      v-if="salerStatus.length > 0 && listName == 'salerStatus'"
      style="max-width: 1350px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">销售数据</h2>
      <el-select v-model="usUser" @change="showSalerStatus">
        <el-option
          v-for="type in usUserList"
          :key="type"
          :label="type"
          :value="type"
        >
        </el-option>
      </el-select>
      <el-table :data="salerStatus" border stripe>
        <el-table-column prop="day" label="哪天"> </el-table-column>
        <el-table-column prop="total" label="现有销售"> </el-table-column>
        <el-table-column prop="new" label="新增销售"> </el-table-column>
        <el-table-column prop="activateNum" label="活跃销售"> </el-table-column>
        <el-table-column prop="signNum" label="仅签到"> </el-table-column>
        <el-table-column prop="shareWpNum" label="分享小程序">
        </el-table-column>
        <el-table-column prop="shareArticleNum" label="仅转发文章">
        </el-table-column>
        <el-table-column prop="top" label="最高分"> </el-table-column>
        <el-table-column prop="ave" label="平均分"> </el-table-column>
        <el-table-column prop="zero" label="0分占比"> </el-table-column>
        <el-table-column prop="fx" label="分享进入"> </el-table-column>
        <el-table-column prop="imgNum" label="新增图片"> </el-table-column>
        <el-table-column prop="audioNum" label="新增语音"> </el-table-column>
        <el-table-column prop="videoNum" label="新增视频"> </el-table-column>
        <el-table-column prop="chet" label="聊天"> </el-table-column>
        <el-table-column prop="kefu_talk" label="客服"> </el-table-column>
      </el-table>
    </div>

    <div
      v-if="estatePageHits.length > 0 && listName == 'estatePageHits'"
      style="max-width: 1500px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">新房楼盘页点击</h2>
      <el-table :data="estatePageHits" border stripe>
        <el-table-column prop="date" label="日期" width="120">
        </el-table-column>
        <el-table-column prop="一房一价" label="一房一价"> </el-table-column>
        <el-table-column prop="户型评测" label="户型评测"> </el-table-column>
        <el-table-column prop="配套地图" label="配套评测"> </el-table-column>
        <el-table-column prop="日照选房" label="日照评测"> </el-table-column>
        <el-table-column prop="噪声评测" label="噪声评测"> </el-table-column>
        <el-table-column prop="产业评测" label="产业评测"> </el-table-column>
        <el-table-column prop="规划评测" label="规划评测"> </el-table-column>
        <el-table-column prop="选房顺序" label="选房顺序"> </el-table-column>
        <el-table-column prop="楼栋分析" label="楼栋评测"> </el-table-column>
        <el-table-column prop="景观评测" label="景观评测"> </el-table-column>
        <el-table-column prop="楼盘问答" label="买房问答"> </el-table-column>
        <el-table-column prop="楼盘评价" label="楼盘评价"> </el-table-column>
        <el-table-column prop="VR航拍" label="VR航拍"> </el-table-column>
        <el-table-column prop="图库" label="图库"> </el-table-column>
        <el-table-column prop="楼盘详情" label="详情"> </el-table-column>
        <el-table-column prop="摇号记录" label="摇号记录"> </el-table-column>
        <el-table-column prop="智能匹配" label="智能匹配"> </el-table-column>
        <el-table-column prop="置业顾问" label="置业顾问"> </el-table-column>
        <el-table-column prop="业主群" label="业主群"> </el-table-column>
        <el-table-column prop="微信群" label="微信群"> </el-table-column>
        <el-table-column prop="pk" label="PK"> </el-table-column>
      </el-table>
    </div>

    <div
      v-if="homePageHits.length > 0 && listName == 'homePageHits'"
      style="max-width: 1500px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">新房首页点击</h2>
      <el-table :data="homePageHits" border stripe>
        <el-table-column prop="date" label="日期" width="120">
        </el-table-column>
        <el-table-column prop="正在公示" label="正在公示" width="80">
        </el-table-column>
        <el-table-column prop="正在登记" label="正在登记" width="80">
        </el-table-column>
        <el-table-column prop="摇号查询" label="摇号查询" width="80">
        </el-table-column>
        <el-table-column prop="预计开盘" label="预计开盘" width="80">
        </el-table-column>
        <el-table-column prop="特惠楼盘" label="特惠楼盘" width="80">
        </el-table-column>
        <el-table-column prop="评测榜单" label="评测榜单" width="80">
        </el-table-column>
        <el-table-column prop="日照评测" label="日照评测" width="80">
        </el-table-column>
        <el-table-column prop="噪声评测" label="噪声评测" width="80">
        </el-table-column>
        <el-table-column prop="户型评测" label="户型评测" width="80">
        </el-table-column>
        <el-table-column prop="买房问答" label="买房问答" width="80">
        </el-table-column>
        <el-table-column prop="地图找房" label="地图找房" width="80">
        </el-table-column>
        <el-table-column prop="地铁找房" label="地铁找房" width="80">
        </el-table-column>
        <el-table-column prop="学区找房" label="学区找房" width="80">
        </el-table-column>
        <el-table-column prop="半径找房" label="半径找房" width="80">
        </el-table-column>
        <el-table-column prop="评测合集" label="评测合集" width="80">
        </el-table-column>
        <el-table-column prop="选房评测" label="选房评测" width="80">
        </el-table-column>
        <el-table-column prop="倒挂评测" label="倒挂评测" width="80">
        </el-table-column>
        <el-table-column prop="VR航拍评测" label="VR航拍评测" width="100">
        </el-table-column>
        <el-table-column prop="样板房评测" label="样板房评测" width="100">
        </el-table-column>
        <el-table-column prop="比价评测" label="比价评测" width="100">
        </el-table-column>
        <el-table-column prop="配套评测" label="配套评测" width="80">
        </el-table-column>
        <el-table-column prop="产业评测" label="产业评测" width="80">
        </el-table-column>
        <el-table-column prop="3D户型评测" label="3D户型评测" width="100">
        </el-table-column>
        <el-table-column prop="景观评测" label="景观评测" width="80">
        </el-table-column>
        <el-table-column prop="规划评测" label="规划评测" width="80">
        </el-table-column>
        <el-table-column prop="评测文章" label="评测文章" width="80">
        </el-table-column>
        <el-table-column prop="评测视频" label="评测视频" width="80">
        </el-table-column>
        <el-table-column prop="土拍" label="土拍评测" width="80">
        </el-table-column>
        <el-table-column prop="板块评测" label="板块评测" width="80">
        </el-table-column>
        <el-table-column prop="百科政策" label="政策百科" width="80">
        </el-table-column>
        <el-table-column prop="pk" label="PK选房" width="80"> </el-table-column>
        <el-table-column prop="公寓" label="商业公寓" width="80">
        </el-table-column>
        <el-table-column prop="共有产权" label="共有产权" width="80">
        </el-table-column>
        <el-table-column prop="3D车位" label="3D车位" width="80">
        </el-table-column>
        <el-table-column prop="商铺" label="商铺" width="80"> </el-table-column>
      </el-table>
    </div>

    <div
      v-if="twoHomePageHits.length > 0 && listName == 'twoHomePageHits'"
      style="max-width: 1350px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">二手房首页点击</h2>
      <el-table :data="twoHomePageHits" border stripe>
        <el-table-column
          v-for="item in secKeys"
          :key="item"
          :prop="item"
          :label="item == 'date' ? '日期' : item"
          :width="item == 'date' ? '120' : ''"
        >
        </el-table-column>
      </el-table>
    </div>

    <div
      v-if="twoEstatePageHits.length > 0 && listName == 'twoEstatePageHits'"
      style="max-width: 1380px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">二手房楼盘页点击</h2>
      <el-table :data="twoEstatePageHits" border stripe>
        <el-table-column
          v-for="item in secKeys"
          :key="item"
          :prop="item"
          :label="item == 'date' ? '日期' : item"
          :width="item == 'date' ? '120' : ''"
        >
        </el-table-column>
      </el-table>
    </div>
    <div
      v-if="estateHits.length > 0 && listName == 'estateHits'"
      style="max-width: 600px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">
        {{ checkDate1 }}楼盘点击
      </h2>
      <el-table :data="estateHits" border stripe>
        <el-table-column prop="real_estate_name" label="楼盘名">
        </el-table-column>
        <el-table-column prop="num" label="点击"> </el-table-column>
      </el-table>
    </div>

    <div
      v-if="msgNumList.length > 0 && listName == 'msgNumList'"
      style="max-width: 600px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">
        {{ checkUserType }}{{ checkDate1 }}咨询
      </h2>
      <el-table :data="msgNumList" border stripe>
        <el-table-column
          prop="user_name"
          :label="'姓名（' + msgNumList.length + '）'"
        >
        </el-table-column>
        <el-table-column prop="real_estate_name" label="楼盘名">
        </el-table-column>
        <el-table-column prop="num" label="咨询人数"> </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="primary" @click="setSubstitute(scope.row.id)"
              >看聊天</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div
      v-if="estateScore.length > 0 && listName == 'estateScore'"
      style="max-width: 1080px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">配套评分</h2>
      <el-table :data="estateScore" border stripe @header-click="sortEstate">
        <el-table-column prop="real_estate_name" label="楼盘">
        </el-table-column>
        <el-table-column prop="loc_base.traffic" label="交通">
        </el-table-column>
        <el-table-column prop="loc_base.market" label="商场"> </el-table-column>
        <el-table-column prop="loc_base.school" label="学校"> </el-table-column>
        <el-table-column prop="loc_base.hospital" label="医院">
        </el-table-column>
        <el-table-column prop="loc_base.scenery" label="景观">
        </el-table-column>
        <el-table-column prop="loc_base.public" label="公建"> </el-table-column>
      </el-table>
    </div>

    <div
      v-if="estateRateList.length > 0 && listName == 'estateRate'"
      style="max-width: 1080px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">近期摇号</h2>
      <el-table :data="estateRateList" border stripe>
        <el-table-column prop="give" label="现房"> </el-table-column>
        <el-table-column prop="advance" label="预售证"> </el-table-column>
        <el-table-column prop="register" label="登记时间"> </el-table-column>
        <el-table-column prop="district" label="区域"> </el-table-column>
        <el-table-column prop="real_estate_name" label="楼盘名">
        </el-table-column>
        <el-table-column prop="price" label="价格"> </el-table-column>
        <el-table-column prop="house" label="套数"> </el-table-column>
        <el-table-column prop="people" label="人数"> </el-table-column>
        <el-table-column prop="rate" label="中签率"> </el-table-column>
      </el-table>
    </div>

    <div
      v-if="advanceList.length > 0 && listName == 'advanceList'"
      style="max-width: 1080px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">预售证信息</h2>
      <el-table :data="advanceList" border stripe>
        <el-table-column prop="number" label="预售证号"> </el-table-column>
        <el-table-column prop="name" label="开发项目名"> </el-table-column>
        <el-table-column prop="company" label="开发公司"> </el-table-column>
        <el-table-column prop="location" label="房屋坐落位置">
        </el-table-column>
        <el-table-column prop="purpose" label="用途"> </el-table-column>
        <el-table-column prop="date" label="核发日期"> </el-table-column>
      </el-table>
    </div>
    <div v-if="listName == 'xHTalkTotal'">
      <div>
        <h2 style="text-align: center">猩号话题发布统计</h2>
        <div>
          起始
          <el-date-picker
            v-model="ax.start_time"
            type="date"
            placeholder="起始日期"
            value-format="yyyy-MM-dd"
            style="width: 140px"
          >
          </el-date-picker>
        </div>
        <div>
          结束
          <el-date-picker
            v-model="ax.end_time"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 140px"
          >
          </el-date-picker>
        </div>
        <button @click="getXHTalkList">查询</button>
      </div>
      <el-table
        :data="xHTalkList"
        style="max-width: 1000px; margin: 0 auto"
        ref="tableData"
        :summary-method="sumList"
        :height="maxHeight"
        border
        show-summary
      >
        <el-table-column
          prop="name"
          label="姓名"
          column-key="name10"
          :filter-method="filterEstate"
          :filters="xHTalkListFilters.name"
        ></el-table-column>
        <el-table-column
          prop="label"
          label="类型"
          column-key="label10"
          :filter-method="filterEstate"
          :filters="xHTalkListFilters.label"
        ></el-table-column>
        <el-table-column
          prop="geo_name"
          label="空间"
          column-key="geo_name10"
          :filter-method="filterEstate"
          :filters="xHTalkListFilters.geo_name"
        >
        </el-table-column>
        <el-table-column
          prop="num"
          label="数量"
          column-key="num10"
        ></el-table-column>
        <el-table-column
          prop="date"
          label="时间"
          column-key="date10"
        ></el-table-column>
      </el-table>
    </div>
    <div v-if="listName == 'xHGSTotal'">
      <div>
        <h2 style="text-align: center">猩号空间说灌水统计</h2>
        <div>
          起始
          <el-date-picker
            v-model="ax.start_time"
            type="date"
            placeholder="起始日期"
            value-format="yyyy-MM-dd"
            style="width: 140px"
          >
          </el-date-picker>
        </div>
        <div>
          结束
          <el-date-picker
            v-model="ax.end_time"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 140px"
          >
          </el-date-picker>
        </div>
        <button @click="getXHGSList">查询</button>
      </div>
      <el-table
        :data="xHGSList"
        style="max-width: 1000px; margin: 0 auto"
        ref="tableData1"
        :height="maxHeight"
        border
        show-summary
        :summary-method="sumList"
      >
        <el-table-column
          prop="name"
          label="姓名"
          column-key="name"
          :filter-method="filterEstate"
          :filters="xHGSListFilters.name"
        ></el-table-column>
        <el-table-column
          prop="geo_name"
          label="空间"
          column-key="geo_name"
          :filter-method="filterEstate"
          :filters="xHGSListFilters.geo_name"
        ></el-table-column>
        <el-table-column
          prop="num"
          label="数量"
          column-key="num"
          sortable
        ></el-table-column>
        <el-table-column
          prop="title"
          label="标题"
          column-key="title"
        ></el-table-column>
        <el-table-column
          prop="date"
          label="时间"
          column-key="date"
        ></el-table-column>
      </el-table>
    </div>
    <div v-if="listName == 'groupWaterTable'">
      <div>
        <h2 style="text-align: center">空间群灌水统计</h2>
        <div>
          起始
          <el-date-picker
            v-model="ax.start_time"
            type="date"
            placeholder="起始日期"
            value-format="yyyy-MM-dd"
            style="width: 140px"
          >
          </el-date-picker>
        </div>
        <div>
          结束
          <el-date-picker
            v-model="ax.end_time"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 140px"
          >
          </el-date-picker>
        </div>
        <button @click="getGroupWater">查询</button>
      </div>
      <el-table
        :data="groupWaterList"
        style="max-width: 1000px; margin: 0 auto"
        ref="tableData2"
        :height="maxHeight"
        border
        show-summary
        :summary-method="sumList"
      >
        <el-table-column
          prop="name"
          label="姓名"
          column-key="name"
          :filter-method="filterEstate"
          :filters="groupWaterFilter.name"
        ></el-table-column>
        <el-table-column
          prop="geo_name"
          label="空间"
          column-key="geo_name"
          :filter-method="filterEstate"
          :filters="groupWaterFilter.geo_name"
        ></el-table-column>
        <el-table-column
          prop="num"
          label="数量"
          column-key="num"
          sortable
        ></el-table-column>
        <el-table-column
          prop="group_name"
          label="群名"
          column-key="title"
        ></el-table-column>
        <el-table-column
          prop="date"
          label="时间"
          column-key="date"
        ></el-table-column>
      </el-table>
    </div>
    <div v-if="listName == 'channelWaterTable'">
      <div>
        <h2 style="text-align: center">频道灌水统计</h2>
        <div>
          起始
          <el-date-picker
            v-model="ax.start_time"
            type="date"
            placeholder="起始日期"
            value-format="yyyy-MM-dd"
            style="width: 140px"
          >
          </el-date-picker>
        </div>
        <div>
          结束
          <el-date-picker
            v-model="ax.end_time"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 140px"
          >
          </el-date-picker>
        </div>
        <button @click="getChannelWater">查询</button>
      </div>
      <el-table
        :data="channelWaterList"
        style="max-width: 1000px; margin: 0 auto"
        ref="tableData3"
        :height="maxHeight"
        border
        show-summary
        :summary-method="sumList"
      >
        <el-table-column
          prop="name"
          label="姓名"
          column-key="name"
          :filter-method="filterEstate"
          :filters="channelWaterFilter.name"
        ></el-table-column>
        <el-table-column
          prop="geo_name"
          label="空间"
          column-key="geo_name"
          :filter-method="filterEstate"
          :filters="channelWaterFilter.geo_name"
        ></el-table-column>
        <el-table-column
          prop="num"
          label="数量"
          column-key="num"
          sortable
        ></el-table-column>
        <el-table-column
          prop="channel_name"
          label="频道"
          column-key="title"
        ></el-table-column>
        <el-table-column
          prop="date"
          label="时间"
          column-key="date"
        ></el-table-column>
      </el-table>
    </div>
    <div
      v-if="listName == 'yushouList'"
      style="max-width: 1180px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">苏州预售证</h2>
      <el-table :data="yushouList" border stripe>
        <el-table-column prop="number" label="预售证号"> </el-table-column>
        <el-table-column prop="name" label="开发项目名"> </el-table-column>
        <el-table-column prop="company" label="开发公司"> </el-table-column>
        <el-table-column prop="location" label="房屋坐落位置">
        </el-table-column>
        <el-table-column prop="purpose" label="用途"> </el-table-column>
        <el-table-column prop="date" label="核发日期"> </el-table-column>
        <el-table-column label="楼盘id" width="180">
          <template slot-scope="scope">
            <input
              type="text"
              @keydown.enter="matchOneAdvance($event, scope.row.id)"
            />
            <el-button type="primary" @click="ignoreAdvance(scope.row.id)"
              >忽略</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div
      v-if="saleJoinData.length > 0 && listName == 'saleJoinData'"
      style="max-width: 500px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">近期入驻人数</h2>
      <el-table :data="saleJoinData" border stripe>
        <el-table-column prop="date" label="日期"> </el-table-column>
        <el-table-column prop="sale" label="置业顾问"> </el-table-column>
        <el-table-column prop="agent" label="经纪人"> </el-table-column>
      </el-table>
    </div>

    <div
      v-if="
        realInfoList.length > 0 &&
        (listName == 'gsList' || listName == 'djList')
      "
      style="max-width: 1018px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">
        正在{{ listName == "gsList" ? "公示" : "登记" }}
      </h2>
      <el-table
        :data="realInfoList"
        :cell-style="judgeCellColor"
        :header-cell-style="headerrow"
        style="padding-bottom: 1px"
      >
        <el-table-column
          v-for="(value, key) in gsMap"
          :key="key"
          :label="value"
          :width="gsWMap[key] || ''"
        >
          <template slot-scope="scope">
            <div v-if="!scope.row[key]" style="color: rgba(0, 0, 0, 0.5)">
              待更新
            </div>
            <div
              v-else-if="
                typeof scope.row[key] === 'string' &&
                scope.row[key].includes('\n')
              "
              style="white-space: pre"
            >
              {{ scope.row[key] }}
            </div>
            <div v-else>{{ scope.row[key] }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div
      v-if="hotingList.length > 0 && listName == 'hotingList'"
      style="max-width: 1440px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin-top: 20px">生命周期</h2>
      <el-table :data="filterHoting" border :cell-style="judgeHotColor">
        <el-table-column
          prop="district"
          label="区域"
          width="80"
          :filters="areaFilterList"
          :filter-method="areaFilter"
        >
        </el-table-column>
        <el-table-column prop="area_name" label="板块" width="90">
        </el-table-column>
        <el-table-column prop="real_estate_name" label="楼盘名称" width="160">
        </el-table-column>
        <el-table-column prop="number" label="土拍编号" width="150">
        </el-table-column>
        <el-table-column prop="hang_date" label="土地挂牌" width="120">
        </el-table-column>
        <el-table-column prop="deal_date" label="土地成交" width="120">
        </el-table-column>
        <el-table-column prop="plan" label="规划公示"> </el-table-column>
        <el-table-column prop="apart" label="户型图"> </el-table-column>
        <el-table-column prop="status" label="销售公示"> </el-table-column>
        <el-table-column prop="expect" label="预计开盘"> </el-table-column>
        <el-table-column prop="dynamic" label="销售动态" width="200">
        </el-table-column>
      </el-table>
    </div>

    <div
      style="max-width: 750px; margin: 50px auto"
      v-if="news.length > 0 && listName == 'news'"
    >
      <h2 style="text-align: center; margin: 20px 0">最新政府文章</h2>
      <div style="margin: 20px 0">
        搜索文章：<input
          type="text"
          placeholder="输入文章标题或内容 回车查询"
          @keyup.enter="searchGovNews"
          v-model="searchText"
          style="width: 200px"
        />
      </div>
      <div class="count">
        第{{ pageNum + 1 }}页&ensp;&ensp;
        <el-button type="primary" @click="beforeClick" v-if="pageNum > 0"
          >上一页</el-button
        >
        <el-button type="primary" @click="nextClick">下一页</el-button>
      </div>
      <el-table :data="news" border stripe>
        <el-table-column prop="title" label="标题"> </el-table-column>
        <el-table-column prop="date" label="日期" width="90"> </el-table-column>
        <el-table-column prop="site" label="站点" width="120">
        </el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="currentNews = scope.row"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="image-background" v-if="currentNews">
      <div class="edit-area">
        <div class="edit-left">{{ currentNews.content }}</div>
        <textarea class="edit-right" v-model="currentNews.summary"></textarea>
      </div>
      <div class="control">
        <el-button size="mini" type="warning" @click="currentNews = null"
          >取消</el-button
        >
      </div>
    </div>

    <div v-if="listName == 'qunList'" style="margin: 50px auto">
      <h2 style="text-align: center; margin: 20px 0">{{ sendWay }}</h2>
      <el-select v-model="searchType" placeholder="楼盘群" style="width: 100px">
        <el-option
          v-for="type in QunType"
          :key="type"
          :label="type"
          :value="type"
        >
        </el-option>
      </el-select>
      <div style="margin: 20px 0" v-if="searchType === '销售聊天'">
        <el-select
          filterable
          placeholder="选择楼盘"
          default-first-option
          :remote-method="searchEstate"
          remote
          @change="searchQun"
        >
          <el-option
            v-for="(item, index) in matchEstates"
            :key="index"
            :label="item.real_estate_name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div style="margin: 20px 0" v-else>
        搜索：<input
          type="text"
          placeholder="输入群名 回车查询"
          @keyup.enter="searchQun"
          v-model="searchName"
          style="width: 200px"
        />
      </div>
      <div style="margin: 20px 0; display: flex; justify-content: center">
        已选(默认全选,单击删除)：
        <div
          v-for="(n, index) in chooseList"
          :key="index"
          @click="deletOne(index)"
        >
          {{ n.name }}
        </div>
      </div>
      <div style="margin: 20px 0" v-if="sendWay == '创建小群'">
        小群名(不小于6字)：<textarea
          v-model="content"
          cols="50"
          rows="5"
        ></textarea>
        <el-button
          type="primary"
          v-if="chooseList.length == 1 && content.length > 5"
          @click="addNewChat()"
          >确认创建</el-button
        >
      </div>
      <div style="margin: 20px 0" v-if="sendWay != '创建小群'">
        发消息：<textarea v-model="content" cols="50" rows="5"></textarea>
        <el-button type="primary" @click="sendQunMessage(1)"
          >发送文字</el-button
        >
      </div>
      <div v-if="sendWay === '假用户消息'">
        <input type="file" @change="chooseImage3" />
        <el-button type="primary" @click="sendQunMessage(2)"
          >发送图片</el-button
        >
        <div>{{ imageSrc }}</div>
        <div class="imageBox" v-if="imageSrc">
          <img :src="imageSrc" preview="1" />
          <button @click="delImage2()">删除</button>
        </div>
        <br />
        <input type="file" @change="chooseVideo" />
        <el-button type="primary" @click="sendQunMessage(43)"
          >发送视频</el-button
        >
        <div>{{ videoSrc }}</div>
        <div class="imageBox" v-if="videoSrc">
          <img :src="videoCover" preview="1" />
          <button @click="delVideo()">删除</button>
        </div>
        <el-select
          v-model="suiji"
          placeholder="随机用户"
          style="margin: 10px 0; width: 100px"
        >
          <el-option
            v-for="way in searchType == '话题群'
              ? ['随机用户', '当前用户', '发帖用户']
              : ['随机用户', '当前用户']"
            :key="way"
            :label="way"
            :value="way"
          >
          </el-option>
        </el-select>
        当前用户：{{ sjUser.user_name || "" }}
      </div>
      <div v-if="searchType === '销售聊天'">
        <div>聊天记录：</div>
        <div class="talkbox">
          <div v-for="(item, index) in records" :key="index">
            <div>
              {{ item.userType }}：{{ item.content }}（{{ item.create_time }}）
            </div>
          </div>
        </div>
      </div>
      <el-table
        :data="qunList"
        border
        stripe
        :style="{
          'max-width': searchType == '楼盘群' ? '300px' : '200px',
          margin: '50px auto',
        }"
      >
        <el-table-column prop="name" label="群名/名字"> </el-table-column>
        <el-table-column
          prop="type"
          label="类型"
          width="80"
          v-if="searchType == '楼盘群'"
        >
        </el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="addQun(scope.row)"
              >添加</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div
      v-if="listName == 'priceReal'"
      style="width: 1700px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">总价楼盘</h2>
      <el-select v-model="priceType" placeholder="200万+" style="width: 100px">
        <el-option
          v-for="type in priceList"
          :key="type"
          :label="type"
          :value="type"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="realStatus"
        placeholder="在售待首开"
        style="width: 100px"
      >
        <el-option
          v-for="type in ['在售待首开', '售罄']"
          :key="type"
          :label="type"
          :value="type"
        >
        </el-option>
      </el-select>
      <el-button type="primary" @click="getEstateZJ">查找</el-button>
      <div>共找到{{ priceRealList.length }}个楼盘</div>
      <el-table
        :data="priceRealList"
        border
        stripe
        v-if="priceRealList.length > 0"
      >
        <el-table-column prop="real_estate_name" label="楼盘名">
        </el-table-column>
        <el-table-column prop="priceStr" label="价格"> </el-table-column>
        <el-table-column prop="active_num" label="热度(w)"> </el-table-column>
        <el-table-column prop="district" label="区域"> </el-table-column>
        <el-table-column prop="area_name" label="板块"> </el-table-column>
        <el-table-column prop="subway" label="交通"> </el-table-column>
        <el-table-column prop="label2.lines_c" label="地铁"> </el-table-column>
        <el-table-column prop="allSmallSchool" label="全部小学">
        </el-table-column>
        <el-table-column prop="smallSchool" label="学区小学"> </el-table-column>
        <el-table-column prop="allMiddleSchool" label="全部中学">
        </el-table-column>
        <el-table-column prop="middleSchool" label="学区中学">
        </el-table-column>
        <el-table-column prop="price" label="二手房均价"> </el-table-column>
        <el-table-column prop="label2.square" label="户型面积">
        </el-table-column>
        <el-table-column prop="label2.room_count" label="房间">
        </el-table-column>
        <el-table-column prop="label2.type" label="类型"> </el-table-column>
        <el-table-column prop="label2.give_time" label="交付">
        </el-table-column>
        <el-table-column prop="label2.daoguaPrice" label="倒挂">
        </el-table-column>
        <el-table-column prop="rate_total" label="最近中签率">
        </el-table-column>
        <el-table-column prop="location_level" label="配套"> </el-table-column>
        <el-table-column prop="invest" label="投资"> </el-table-column>
      </el-table>
    </div>

    <div
      v-if="listName == 'apartList'"
      style="max-width: 1000px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">4室户型</h2>
      <div>共找到{{ apartList.length }}个户型</div>
      <el-button
        type="primary"
        class="download-button"
        @click="downloadExcel('4室户型')"
        >导出Excel</el-button
      >
      <el-table :data="apartList" border stripe v-if="apartList.length > 0">
        <el-table-column prop="real_estate_name" label="楼盘名">
        </el-table-column>
        <el-table-column prop="district" label="区域"> </el-table-column>
        <el-table-column prop="area_name" label="板块"> </el-table-column>
        <el-table-column prop="house_style" label="户型"> </el-table-column>
        <el-table-column prop="allRoomSquare" label="面积"> </el-table-column>
        <el-table-column prop="hasPc" label="是否评测"> </el-table-column>
      </el-table>
    </div>

    <div
      v-if="listName == 'oldPriceList'"
      style="max-width: 1700px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">2-3万楼盘</h2>
      <div>共找到{{ oldPriceList.length }}个楼盘</div>
      <el-button
        type="primary"
        class="download-button"
        @click="downloadExcel('2-3万楼盘')"
        >导出Excel</el-button
      >
      <el-table
        :data="oldPriceList"
        border
        stripe
        v-if="oldPriceList.length > 0"
      >
        <el-table-column prop="real_estate_name" label="楼盘名">
        </el-table-column>
        <el-table-column prop="area_name" label="板块"> </el-table-column>
        <el-table-column prop="priceStr" label="价格"> </el-table-column>
        <el-table-column prop="expect.date" label="预计开盘"> </el-table-column>
      </el-table>
    </div>

    <div
      v-if="listName == 'houseList'"
      style="max-width: 500px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">90方以下楼盘</h2>
      <div>共找到{{ houseList.length }}个楼盘</div>
      <el-button
        type="primary"
        class="download-button"
        @click="downloadExcel('90方楼盘')"
        >导出Excel</el-button
      >
      <el-table :data="houseList" border stripe v-if="houseList.length > 0">
        <el-table-column prop="real_estate_name" label="楼盘名">
        </el-table-column>
        <el-table-column prop="district" label="区域"> </el-table-column>
        <el-table-column prop="area_name" label="板块"> </el-table-column>
        <el-table-column prop="apart" label="具体户型"> </el-table-column>
      </el-table>
    </div>
    <div v-if="listName == 'guwenFuwu'">
      <el-select
        v-model.lazy="commentEstateId"
        filterable
        placeholder="评论楼盘"
        default-first-option
        :remote-method="searchEstate"
        remote
        @change="changeCommentType"
      >
        <el-option
          v-for="(item, index) in matchEstates"
          :key="index"
          :label="item.real_estate_name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <div>
        起始
        <el-date-picker
          v-model="ax.start_time"
          type="date"
          placeholder="起始日期"
          value-format="yyyy-MM-dd"
          style="width: 140px"
        >
        </el-date-picker>
      </div>
      <div>
        结束
        <el-date-picker
          v-model="ax.end_time"
          type="date"
          placeholder="结束日期"
          value-format="yyyy-MM-dd"
          style="width: 140px"
        >
        </el-date-picker>
      </div>
      <el-button @click="getGuwenFuwu">查看</el-button>
      <el-table :data="guwenList">
        <el-table-column label="顾问名" prop="user_name"> </el-table-column>
        <el-table-column label="微聊人数" prop="chat_person_num">
        </el-table-column>
        <el-table-column label="微聊回复率" prop="chat_rate"> </el-table-column>
        <el-table-column label="五分钟回复率" prop="limit_time_rate">
        </el-table-column>
        <el-table-column label="平均响应时长分" prop="time"> </el-table-column>
        <el-table-column label="聊天条数" prop="talk_num"> </el-table-column>
        <el-table-column label="申请交换微信数" prop="weixin_exchange_num">
        </el-table-column>
        <el-table-column
          label="交换微信成功数"
          prop="weixin_exchange_agree_num"
        >
        </el-table-column>
      </el-table>
    </div>

    <div
      v-if="listName == 'yujiExcel'"
      style="max-width: 300px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">预计开盘excel</h2>
      <el-select
        v-model="yjMonth"
        placeholder="选择预计月份"
        style="width: 100px"
      >
        <el-option
          v-for="type in monthList"
          :key="type"
          :label="type"
          :value="type"
        >
        </el-option>
      </el-select>
      <el-button class="normal" type="primary" @click="yujiExcel"
        >下载excel</el-button
      >
      <el-button class="normal" type="primary" @click="yujiExcel('1')"
        >顾问4000活跃+</el-button
      >
      <div>{{ yuJiUrl }}</div>
      <el-table :data="saleList" border stripe v-if="saleList.length > 0">
        <el-table-column prop="user_name" label="顾问"> </el-table-column>
        <el-table-column prop="thirty_num" label="活跃度"> </el-table-column>
      </el-table>
    </div>

    <div v-if="needList.length" style="max-width: 780px; margin: 50px auto">
      <el-table :data="needList" border stripe>
        <el-table-column prop="real_estate_name" label="楼盘" width="80">
        </el-table-column>
        <el-table-column prop="district" label="区域" width="80">
        </el-table-column>
        <el-table-column prop="area_name" label="板块" width="80">
        </el-table-column>
        <el-table-column prop="active_num" label="热度" width="80">
        </el-table-column>
        <el-table-column prop="vrNum" label="航拍" width="80">
        </el-table-column>
        <el-table-column prop="exportNum" label="达人短评" width="80">
        </el-table-column>
        <el-table-column prop="artNum" label="小鸡长文" width="80">
        </el-table-column>
      </el-table>
    </div>
    <div v-if="listName == 'topicList'" class="topicList">
      <div class="topic-check">
        <div v-for="item in checkList" :key="item.id" style="margin: 20px 0">
          <div>
            <button @click="showTopicLoc(item)" v-if="item.lnglat">位置</button>
            {{ item.words }}
          </div>
          <div
            v-if="item.images && item.images.length"
            style="display: flex; justify-content: center"
          >
            <div v-for="(img, index) in item.images" :key="index" class="cover">
              <el-image
                :src="img"
                style="height: 100px"
                fit="cover"
                lazy
                :preview-src-list="[img.replace('_mini.jpg', '')]"
              >
              </el-image>
            </div>
          </div>
          <div>
            <el-input
              v-model="item.note"
              type="text"
              placeholder="理由"
              style="width: 180px"
            ></el-input>
            <el-button type="primary" @click="pass(item)">通过</el-button>
            <el-button type="warning" @click="refuse(item)">拒绝</el-button>
          </div>
        </div>
      </div>
      <div class="topic-map">
        <el-amap
          class="amap-box"
          vid="checkTopic"
          ref="checkTopic"
          :zoom="zoom"
          :center="center"
          :amap-manager="amapManager"
          :plugin="plugin"
        >
          <el-amap-marker
            vid="topic_check"
            v-if="topicLnglat"
            :position="topicLnglat.split('-')[0].split('|')"
            icon="./../../static/images/marker.png"
          >
          </el-amap-marker>
        </el-amap>
      </div>
    </div>
    <div
      v-if="listName == 'salePut'"
      style="max-width: 600px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">销售上传</h2>
      <el-table :data="salePut" border stripe>
        <el-table-column prop="date" label="日期"> </el-table-column>
        <el-table-column prop="temp.图片" label="图片" width="100">
        </el-table-column>
        <el-table-column prop="temp.话题" label="话题" width="100">
        </el-table-column>
        <el-table-column prop="temp.问题" label="问题" width="100">
        </el-table-column>
        <el-table-column prop="temp.预计开盘" label="预计开盘" width="100">
        </el-table-column>
        <el-table-column prop="temp.公示登记" label="公示登记" width="100">
        </el-table-column>
      </el-table>
    </div>

    <div
      v-if="listName == 'inviteList'"
      style="max-width: 600px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">运营组数据</h2>
      <el-table :data="inviteList" border stripe>
        <el-table-column prop="date" label="日期"></el-table-column>
        <el-table-column
          v-for="user in inviteListUsers"
          :prop="'temp.' + user"
          :label="user"
          :key="user"
        ></el-table-column>
      </el-table>
    </div>

    <div
      v-if="listName == 'szInviteList'"
      style="max-width: 600px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">运营组数据</h2>
      <el-table :data="szInviteList" border stripe>
        <el-table-column prop="date" label="日期"> </el-table-column>
        <el-table-column prop="temp.王向宏" label="王向宏"> </el-table-column>
        <el-table-column prop="temp.波波" label="波波"> </el-table-column>
        <el-table-column prop="temp.丁心雨" label="丁心雨"> </el-table-column>
        <el-table-column prop="temp.木兵兵" label="木兵兵"> </el-table-column>
      </el-table>
    </div>

    <div
      v-if="listName == 'sunHouse'"
      style="max-width: 600px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">{{ value }}</h2>
      <h3>总计{{ uploadNum }}个</h3>
      <el-table :data="sunHouse" border stripe>
        <el-table-column prop="real_estate_name" label="楼盘">
        </el-table-column>
        <el-table-column prop="user_name" label="上传者"> </el-table-column>
        <el-table-column prop="serial_number" label="户型编号">
        </el-table-column>
      </el-table>
    </div>
    <div
      v-if="listName == 'estateImgCheck'"
      style="max-width: 600px; margin: 50px auto"
    >
      <el-table :data="estateImgCheck" border stripe>
        <el-table-column prop="real_estate_name" label="楼盘名">
        </el-table-column>
        <el-table-column prop="num" label="图片数"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="examine(scope.row, '图库')"
              >审核</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div
      v-if="listName == 'hangImgCheck'"
      style="max-width: 800px; margin: 50px auto"
    >
      <el-table :data="hangImgCheck" border stripe>
        <el-table-column prop="real_estate_name" label="楼盘" width="150px;">
        </el-table-column>
        <el-table-column prop="number" label="编号" width="130px;">
        </el-table-column>
        <el-table-column prop="square" label="面积"> </el-table-column>
        <el-table-column prop="layout" label="户型"> </el-table-column>
        <el-table-column prop="floor" label="楼层" width="120px;">
        </el-table-column>
        <el-table-column prop="trim" label="装修"> </el-table-column>
        <el-table-column prop="num" label="图片" width="50px;">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="examine(scope.row, '房源图库')"
              >审核</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div
      v-if="listName == 'HzTitle'"
      style="max-width: 500px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">杭州公示</h2>
      <el-table :data="HzTitle" border stripe>
        <el-table-column prop="date" label="公示日期" width="160">
        </el-table-column>
        <el-table-column prop="title" label="标题"> </el-table-column>
      </el-table>
    </div>

    <div
      v-if="listName == 'ZJReal'"
      style="max-width: 900px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">中签率楼盘</h2>
      <el-table :data="ZJReal" border stripe v-if="ZJReal.length > 0">
        <el-table-column prop="real_estate_name" label="楼盘">
        </el-table-column>
        <el-table-column prop="advance" label="时间"> </el-table-column>
        <el-table-column prop="building" label="楼栋"> </el-table-column>
        <!--
          <el-table-column prop="invalid.length" label="开盘次数">
          </el-table-column>
          <el-table-column prop="priceStr" label="价格">
          </el-table-column>
          <el-table-column prop="square" label="销售面积">
          </el-table-column>
          <el-table-column prop="trim" label="装修情况">
          </el-table-column>
          <el-table-column prop="house_total" label="房源数">
          </el-table-column>
          <el-table-column prop="people_total" label="登记人数">
          </el-table-column>
        -->
        <el-table-column prop="rate_total" label="最近中签率">
        </el-table-column>
      </el-table>
    </div>

    <div
      v-if="listName == 'sortList'"
      style="max-width: 800px; margin: 50px auto"
    >
      <div v-for="(s, index) in sortList" :key="index">
        <h2 style="text-align: center; margin: 20px 0">{{ s.type }}</h2>
        <div v-if="s.type !== '近期话题' && s.type !== '近期PK'">
          <el-table :data="s.list" border stripe v-if="s.list.length > 0">
            <el-table-column prop="real_estate_name" label="楼盘">
            </el-table-column>
            <el-table-column prop="sortTip" :label="s.type"> </el-table-column>
          </el-table>
        </div>
        <div v-if="s.type === '近期PK'">
          <el-table :data="s.list" border stripe v-if="s.list.length > 0">
            <el-table-column prop="fina" label="楼盘"> </el-table-column>
            <el-table-column prop="create_time" label="时间"> </el-table-column>
            <el-table-column prop="views_num" :label="'围观'">
            </el-table-column>
          </el-table>
        </div>
        <div v-if="s.type === '近期话题'">
          <div v-for="(l, index2) in s.list" :key="index2">
            <div>(围观{{ l.views_num }})({{ l.create_time }}){{ l.words }}</div>
            <div class="fDiv">
              <div v-for="(img, index3) in l.images" :key="index3">
                <img :src="img" preview="1" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="adCloseList.length > 0 && listName == 'adCloseList'"
      style="max-width: 600px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">展位即将到期</h2>
      <el-table :data="adCloseList" border stripe>
        <el-table-column prop="real_estate_name" label="楼盘名">
        </el-table-column>
        <el-table-column prop="user_name" label="姓名"> </el-table-column>
        <el-table-column prop="end_time" label="到期时间"> </el-table-column>
      </el-table>
    </div>
    <div
      v-if="logList.length > 0 && listName == 'logList'"
      style="max-width: 800px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">错误日志</h2>
      <el-table :data="logList" border stripe>
        <el-table-column prop="from" label="来源" width="130">
        </el-table-column>
        <el-table-column prop="message" label="错误信息" width="130">
        </el-table-column>
        <el-table-column prop="detail" label="错误详情"> </el-table-column>
        <el-table-column prop="create_time" label="时间" width="130">
        </el-table-column>
      </el-table>
    </div>

    <div
      v-if="xhLogList.length > 0 && listName == 'xhLogList'"
      style="max-width: 800px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">错误日志</h2>
      <select name="" id="" v-model="error_platform" @change="getXHLogs()">
        <option value="android">android</option>
        <option value="ios">ios</option>
      </select>
      <el-button type="primary" @click="getXHLogs(xhLogMaxId)"
        >下一页</el-button
      >
      <el-table :data="xhLogList" border stripe>
        <el-table-column prop="error" label="错误信息">
          <template slot-scope="{ row }">
            <div style="white-space: pre-line">{{ row.error }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="时间" width="130">
        </el-table-column>
      </el-table>
    </div>

    <div
      v-if="spiderData.length > 0 && listName == 'spiderData'"
      style="max-width: 1080px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">二手房爬虫</h2>
      <el-table :data="spiderData" border stripe>
        <el-table-column prop="date" label="日期"> </el-table-column>
        <el-table-column prop="haoNewHang" label="hzf新增房源">
        </el-table-column>
        <el-table-column prop="haoAllHang" label="hzf有效房源">
        </el-table-column>
        <el-table-column prop="beikeHang" label="bk更新房源"> </el-table-column>
        <el-table-column prop="wiwjHang" label="5i5j更新房源">
        </el-table-column>
        <el-table-column prop="haoDeal" label="hzf成交记录"> </el-table-column>
        <el-table-column prop="wiwjDeal" label="5i5j成交记录">
        </el-table-column>
        <el-table-column prop="beikeDaikan" label="bk带看"> </el-table-column>
        <el-table-column prop="wiwjDaikan" label="5i5j带看"> </el-table-column>
      </el-table>
    </div>

    <div class="image-background" v-if="mpCode">
      <div class="image-preview">
        <span class="close" @click="mpCode = null">关闭</span>
        <img :src="mpCode" width="400px" height="400px" preview="1" />
      </div>
    </div>

    <div class="image-background" v-if="mpCode2">
      <div class="image-preview2">
        <span class="close" @click="mpCode2 = null">关闭</span>
        <el-image
          :src="mpCode2"
          :style="{ width: '281px', height: '600px' }"
          :preview-src-list="[mpCode2]"
        />
      </div>
    </div>

    <div
      v-if="listName == 'messList'"
      style="max-width: 600px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">群聊统计</h2>
      <el-select v-model="dateType" placeholder="今天" style="width: 100px">
        <el-option v-for="s in dateList" :key="s" :label="s" :value="s">
        </el-option>
      </el-select>
      <el-button type="primary" @click="getWkMessage">查找</el-button>
      <el-table :data="messList" border stripe>
        <el-table-column prop="id" label="群id"> </el-table-column>
        <el-table-column prop="nickName" label="群名"> </el-table-column>
        <el-table-column prop="num" label="聊天信息"> </el-table-column>
      </el-table>
    </div>

    <div
      v-if="listName == 'friedList'"
      style="max-width: 1000px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">炒群记录</h2>
      <el-table :data="friedList" border stripe>
        <el-table-column prop="date" label="时间" width="100">
        </el-table-column>
        <el-table-column prop="user_name" label="名字"> </el-table-column>
        <el-table-column prop="chat_name" label="群名"> </el-table-column>
        <el-table-column prop="chao" label="炒群"> </el-table-column>
        <el-table-column prop="alladd" label="新增"> </el-table-column>
      </el-table>
    </div>

    <div
      v-if="listName == 'salesMsgNum'"
      style="max-width: 600px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">销售群聊消息数排名</h2>
      <el-table :data="salesMsgNum" border stripe>
        <el-table-column prop="index" label="排名" width="50">
        </el-table-column>
        <el-table-column prop="user_name" label="姓名" width="80">
        </el-table-column>
        <el-table-column prop="real_estate_name" label="楼盘">
        </el-table-column>
        <el-table-column prop="total" label="消息数" width="80">
        </el-table-column>
      </el-table>
    </div>

    <div v-if="listName === 'findPageAd'">
      <h2 style="text-align: center; margin: 20px 0">展位预定</h2>
      <h3 style="text-align: center; margin: 20px 0">{{ saleAdType }}</h3>
      <div class="salePays" v-if="salePayList.length">
        <div
          v-for="(onepay, index) in salePayList"
          :key="index"
          class="salePay"
        >
          <div>{{ onepay.user_name }}</div>
          <div>
            起始
            <el-date-picker
              v-model="onepay.start_time"
              type="date"
              placeholder="起始日期"
              value-format="yyyy-MM-dd"
              style="width: 140px"
            >
            </el-date-picker>
          </div>
          <div>
            结束
            <el-date-picker
              v-model="onepay.end_time"
              type="date"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
              style="width: 140px"
            >
            </el-date-picker>
          </div>
          <div style="margin: 5px 0">
            {{ onepay.money }}元：{{ onepay.way }}
            <button @click="modSalePay(index)">改日期</button>
          </div>
          <div>
            <input
              type="number"
              placeholder="退订金额(元)"
              v-model="onepay.outMoney"
              style="width: 100px"
            />
            <button @click="cancelSalePay(index)">退订</button>
          </div>
        </div>
      </div>
      <div>
        广告位置
        <el-select v-model="saleAdType" @change="onSaleAdTypeChange">
          <el-option label="找新房优秀顾问" value="找新房优秀顾问"></el-option>
          <el-option label="找新房猜你喜欢" value="找新房猜你喜欢"></el-option>
          <el-option label="首页新房榜单" value="首页新房榜单"></el-option>
        </el-select>
      </div>
      <div class="normal">
        搜索销售
        <el-select
          v-model="search_word"
          filterable
          placeholder="搜索销售姓名"
          default-first-option
          :remote-method="chooseSaleName"
          remote
          @change="searchSaleName"
        >
          <el-option
            v-for="item in allSaleName"
            :key="item.id"
            :label="item.user_name + '(' + item.user_type + ')'"
            :value="item.user_name"
          >
          </el-option>
        </el-select>
      </div>
      <div class="salesmanList">
        <div v-for="(sale, index) in salesmanList" :key="index" class="sale">
          <div style="display: flex; align-items: center">
            <img :src="sale.head_url" />
            <div style="margin: 0 10px">{{ sale.user_name }}</div>
            <div>{{ sale.estate_name || "无楼盘" }}</div>
            <el-button type="primary" @click="setToShow(sale)"
              >上展位</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="预定展位下单"
      :visible.sync="payVisible"
      width="25%"
      center
    >
      <el-form>
        <el-form-item label="置业顾问" :label-width="labelWidth">
          <span>{{ payUser.user_name }}</span>
        </el-form-item>
        <el-form-item label="起始日期" :label-width="labelWidth">
          <el-date-picker
            v-model="payUser.start_time"
            type="date"
            placeholder="起始日期"
            value-format="yyyy-MM-dd"
            style="width: 140px"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期" :label-width="labelWidth">
          <el-date-picker
            v-model="payUser.end_time"
            type="date"
            placeholder="起始日期"
            value-format="yyyy-MM-dd"
            style="width: 140px"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="付费金额" :label-width="labelWidth">
          <el-input v-model="payUser.money" type="number"></el-input>
        </el-form-item>
        <el-form-item label="付费方式" :label-width="labelWidth">
          <el-select
            v-model="payUser.way"
            filterable
            default-first-option
            placeholder="选择付费方式"
            size="mini"
          >
            <el-option label="微信" value="微信"> </el-option>
            <el-option label="支付宝" value="支付宝"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="payVisible = false">取 消</el-button>
        <el-button type="primary" @click="setSalePay">确 定</el-button>
      </div>
    </el-dialog>

    <div v-if="listName === 'commentEstate'" class="normal">
      <div class="normal">
        <div style="display: inline-block">
          <el-input
            type="textarea"
            v-model="commentWord"
            placeholder="评论内容"
            cols="70"
            rows="10"
            style="font-size: 18px"
          ></el-input>
        </div>
      </div>
      <div class="normal">
        <el-select
          filterable
          placeholder="评论账号"
          default-first-option
          v-model="commentUserId"
        >
          <el-option
            v-for="item in commentUsers"
            :key="item.id"
            :label="item.user_name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="commentAreaId"
          filterable
          placeholder="评论板块"
          default-first-option
          :remote-method="searchArea"
          remote
          v-if="commentType === '板块评测'"
        >
          <el-option
            v-for="(item, index) in matchAreas"
            :key="index"
            :label="item.area_name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          v-model.lazy="commentEstateId"
          filterable
          placeholder="评论楼盘"
          default-first-option
          :remote-method="searchEstate"
          remote
          v-else
          @change="changeCommentType"
        >
          <el-option
            v-for="(item, index) in matchEstates"
            :key="index"
            :label="item.real_estate_name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          filterable
          placeholder="评论类型"
          default-first-option
          v-model="commentType"
          @change="changeCommentType"
        >
          <el-option
            v-for="(item, index) in commentTypes"
            :key="index"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
        <el-select
          filterable
          v-if="commentType == '楼盘评测' && commentWordList.pingjia"
          placeholder="楼盘评价"
          default-first-option
          v-model="commentdd1"
          @change="changeCommentWordType1"
        >
          <el-option
            v-for="(item, index) in commentWordList.pingjia"
            :key="index"
            :label="item.louDong"
            :value="item.louDong"
          >
          </el-option>
        </el-select>

        <el-select
          filterable
          v-if="commentType == '楼盘评测' && commentWordList.pingjia"
          placeholder="状态"
          default-first-option
          v-model="commentdd3"
          @change="changeCommentWordType3"
        >
          <el-option
            v-for="(item, index) in commentdd13"
            :key="index"
            :label="item.key"
            :value="item.key"
          >
          </el-option>
        </el-select>
        <el-select
          filterable
          v-if="commentType == '3D选房评测' && commentWordList.xuanfanghao"
          placeholder="已开盘户号评测"
          default-first-option
          v-model="commentdd2"
          @change="changeCommentWordType2"
        >
          <el-option
            v-for="(item, index) in commentWordList.xuanfanghao"
            :key="index"
            :label="item.key"
            :value="item.key"
          >
          </el-option>
        </el-select>
        <el-select
          filterable
          placeholder="评论户型"
          default-first-option
          v-model="commentApart"
          v-if="commentType === '户型评测' || commentType === '样板房评测'"
        >
          <el-option
            v-for="item in commentAparts"
            :key="item.imgName2"
            :label="item.imgName1 + ' ' + item.imgName2"
            :value="item.imgName2"
          >
          </el-option>
        </el-select>
        <el-select
          filterable
          v-if="commentType == '样板房评测' && commentWordList.length > 0"
          placeholder="样板房评测"
          default-first-option
          v-model="commentdd4"
          @change="changeCommentWordType4"
        >
          <el-option
            v-for="(item, index) in commentWordList"
            :key="index"
            :label="item.name"
            :value="item.name"
          >
          </el-option>
        </el-select>
      </div>
      <el-button
        type="primary"
        @click="addEstateComment"
        :disabled="commentFlag"
        >评论</el-button
      >
      <el-button type="primary" @click="showzhineng()"
        >显示智能问答评论</el-button
      >
    </div>

    <div v-if="listName === 'fakeSaleAd'">
      <h2 style="text-align: center; margin: 20px 0">顾问小号展位</h2>
      <input
        type="text"
        @keydown.enter="searchUser"
        placeholder="回车搜索顾问"
      />
      <div class="normal">
        <el-select
          v-model="fakeSaleAdEstate"
          filterable
          placeholder="搜索楼盘"
          default-first-option
          :remote-method="searchEstate"
          remote
        >
          <el-option
            v-for="(item, index) in matchEstates"
            :key="index"
            :label="item.real_estate_name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="normal">
        <div style="display: inline-block">
          <div
            v-for="item in nameSearchUsers"
            :key="item.id"
            style="display: flex; align-items: center; margin-top: 20px"
          >
            <img
              :src="item.head_url"
              alt="没有头像"
              style="width: 50px; height: 50px; border-radius: 50%"
            />
            <div style="margin-left: 10px">{{ item.user_name }}</div>
            <button style="margin-left: 10px" @click="setFakeSaleAd(item)">
              上广告
            </button>
          </div>
        </div>
      </div>
      <div style="margin-bottom: 50px; margin-top: 10px">
        <div
          v-for="item in fakeSaleAd"
          :key="item.id"
          style="display: flex; align-items: center; justify-content: center"
        >
          <div>{{ item.real_estate_name }}</div>
          <img
            :src="item.user.head_url"
            alt=""
            style="width: 50px; height: 50px; border-radius: 50%"
          />
          <div>{{ item.user.user_name }}</div>
          <button style="margin-left: 10px" @click="downFakeSaleAd(item)">
            取消
          </button>
        </div>
      </div>
    </div>

    <div v-if="listName === 'waitMatchList'">
      <input type="text" v-model="matchListSearchText" placeholder="搜索" />
      <div>剩余{{ waitMatchList.length }}</div>
      <el-button class="normal" type="primary" @click="setMatchName"
        >提交</el-button
      >
      <div v-for="item in showWaitMatchList" :key="item.name">
        <span>{{ item.name }}</span> <input type="text" v-model="item.match" />
        <button @click="showAddress(item.name)">看地址</button>
        <button @click="startMultiMatch(item.name)">1对多</button>
        <div v-if="currentMulti.name === item.name">
          <div v-for="(multiOne, index) in currentMulti.list" :key="index">
            <input type="text" v-model="multiOne.name" placeholder="名称" />
            <input type="text" v-model="multiOne.id" placeholder="id" />
          </div>
          <button @click="addMultiMatchOne()">添加</button>
          <button @click="saveMultiMatch()">保存</button>
        </div>
        <div v-if="currentAddress.name === item.name">
          <div v-for="addr in currentAddress.list" :key="addr">{{ addr }}</div>
        </div>
      </div>
    </div>
    <div v-if="listName === 'hadMatchList'">
      <input type="text" v-model="matchListSearchText" placeholder="搜索" />
      <div v-for="item in showHadMatchList" :key="item.estate_name">
        <span>{{ item.estate_name }}</span> : <span>{{ item.match_name }}</span>
        <button @click="cancelMatch(item)">取消匹配</button>
      </div>
    </div>
    <div v-if="listName === 'redEvbag'">
      <div v-if="listName === 'redEvbag' && redList === 'table'">
        <div>
          <el-button @click="setredEvbag">新增</el-button>
          <el-table :data="redBagList">
            <el-table-column prop="id" label="id"></el-table-column>
            <el-table-column prop="money" label="金额(元)"></el-table-column>
            <el-table-column
              prop="extra"
              label="剩余金额(元)"
            ></el-table-column>
            <el-table-column
              prop="start_time"
              label="开始时间"
            ></el-table-column>
            <el-table-column
              prop="deal_time"
              label="结束时间"
            ></el-table-column>
            <el-table-column
              prop="estate_name"
              label="楼盘名"
            ></el-table-column>
            <el-table-column prop="" label="操作">
              <template slot-scope="{ row }">
                <el-button @click="changeRedBag(row)"> 编辑红包内容 </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div v-if="listName === 'redEvbag' && redList === 'inputRedAdd'">
        <el-select
          v-model.lazy="redObj.estate_id"
          filterable
          placeholder="选择楼盘"
          default-first-option
          :remote-method="searchEstate"
          remote
          @change="changeCommentType"
        >
          <el-option
            v-for="(item, index) in matchEstates"
            :key="index"
            :label="item.real_estate_name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <div class="normal">
          总金额(元):<el-input
            style="width: 250px"
            v-model="redObj.money"
            type="number"
          >
          </el-input>
        </div>
        <div class="normal">
          开始时间：
          <el-date-picker
            v-model="redObj.start_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
            default-time="00:00:00"
          >
          </el-date-picker>
        </div>
        <div class="normal">
          结束时间：
          <el-date-picker
            v-model="redObj.deal_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
            default-time="23:59:59"
          >
          </el-date-picker>
          <div>
            <el-button @click="saveRed('新增')">保存</el-button>
          </div>
        </div>
      </div>
      <div v-if="listName === 'redEvbag' && redList === 'inputRedChange'">
        <el-select
          v-model.lazy="redObj.estate_id"
          filterable
          placeholder="选择楼盘"
          default-first-option
          :remote-method="searchEstate"
          remote
          @change="changeCommentType"
        >
          <el-option
            v-for="(item, index) in matchEstates"
            :key="index"
            :label="item.real_estate_name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <div class="normal">
          总金额(元):<el-input
            style="width: 250px"
            v-model="redObj.money"
            type="number"
          >
          </el-input>
        </div>
        <div class="normal">
          开始时间：
          <el-date-picker
            v-model="redObj.start_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
            default-time="00:00:00"
          >
          </el-date-picker>
        </div>
        <div class="normal">
          结束时间：
          <el-date-picker
            v-model="redObj.deal_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
            default-time="23:59:59"
          >
          </el-date-picker>
          <div>
            <el-button @click="saveRed('修改')">保存</el-button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="listName === 'setEstateSort' && estateSortObj.id">
      <h2>{{ estateSortObj.name }}</h2>
      <el-select
        filterable
        placeholder="选择楼盘"
        default-first-option
        v-model="estateSortId"
        :remote-method="searchEstate"
        remote
        @change="addEstateToSort"
      >
        <el-option
          v-for="(item, index) in matchEstates"
          :key="index"
          :label="item.real_estate_name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <div
        class="normal"
        v-for="(item, index) in estateSortObj.list"
        :key="item.id"
      >
        <span>{{ item.name }}</span>
        <button @click="setToTop(index)">置顶</button>
        <button @click="moveOut(index)">移除</button>
      </div>
      <div class="normal">
        <el-button type="primary" @click="saveEstateSort">保存</el-button>
      </div>
    </div>

    <div v-if="listName === 'checkTalks'">
      <h2 id="infotop" style="text-align: center; margin: 20px 0">
        楼盘群消息记录
      </h2>
      <el-select v-model="loupanCheck" @change="getOneDayTalk">
        <el-option value="楼盘">楼盘</el-option>
        <el-option value="其他">其他</el-option>
      </el-select>
      <el-date-picker
        v-model="checkTalksDate"
        type="date"
        value-format="yyyy-MM-dd"
        @change="getOneDayTalk()"
        placeholder="选择日期"
      >
      </el-date-picker>
      <h3 v-if="checkTalksNum">{{ checkTalksNum }}</h3>
      <div
        v-show="loupanCheck == '楼盘'"
        v-for="(item, index) in checkTalks"
        :key="index"
        style="max-width: 1100px; margin: 50px auto"
      >
        <div>{{ item.name }}</div>
        <el-table :data="item.msgList" border stripe>
          <el-table-column
            prop="user_id"
            label="用户id"
            width="100"
          ></el-table-column>
          <el-table-column label="内容">
            <template slot-scope="{ row }">
              <el-image
                v-if="row.type == 2"
                style="width: 100px; height: 100px"
                :src="row.content"
                :preview-src-list="[row.content]"
                fit="contain"
                lazy
              ></el-image>
              <div v-else>{{ row.content }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="时间" width="150">
          </el-table-column>
          <el-table-column prop="state" label="状态" width="80">
            <template slot-scope="{ row }">
              <div>{{ row.state || "暂无状态" }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="510">
            <template slot-scope="{ row }">
              <el-button
                @click="uploadQuestion(row.content, row.id)"
                v-if="talkSelectGroup === '数据'"
                >录入问题</el-button
              >
              <el-button @click="toUserChatHistory(row.user_id)">
                查看用户聊天记录
              </el-button>
              <div v-if="talkSelectGroup === '运营' && row.type == 1">
                <select v-model="row.label1">
                  <option
                    :value="label"
                    v-for="(va, label) in topicLabelMap"
                    :key="label"
                  >
                    {{ label }}
                  </option>
                </select>
                <select v-model="row.label2" style="margin-right: 10px">
                  <option
                    :value="label"
                    v-for="label in topicLabelMap[row.label1]"
                    :key="label"
                  >
                    {{ label }}
                  </option>
                </select>
                <el-button type="primary" @click="topicWordSelect(row)"
                  >入库</el-button
                >
                <el-button @click="topOneTalk(row)">置顶展示</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="loupanCheck == '其他'">
        <div
          v-for="(item, index) of checkTalks"
          :key="index"
          style="max-width: 1000px; margin: 50px auto"
        >
          <el-table :data="item" border stripe>
            <el-table-column
              prop="user_id"
              label="用户id"
              width="100"
            ></el-table-column>
            <el-table-column prop="content" label="内容"> </el-table-column>
            <el-table-column prop="create_time" label="时间" width="150">
            </el-table-column>
            <el-table-column prop="status" label="状态" width="150">
            </el-table-column>
            <el-table-column prop="state" label="录入" width="150">
              <template slot-scope="{ row }">
                <div>{{ row.state || "暂无状态" }}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="260">
              <template slot-scope="{ row }">
                <el-button @click="uploadQuestion(row.content, row.id)"
                  >录入问题</el-button
                >
                <el-button @click="toUserChatHistory(row.user_id)">
                  查看用户聊天记录
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <a href="#infotop" style="position: fixed; bottom: 20px; right: 30px"
        >回到顶部</a
      >
    </div>
    <div v-if="listName === 'checkEveryTalk' || listName === 'searchToUnlock'">
      <div v-show="listName === 'checkEveryTalk'">
        <h2 style="text-align: center; margin: 20px 0" id="talk_title">
          群聊地毯式检查
        </h2>
        <el-date-picker
          v-model="everyTalkDate"
          type="date"
          value-format="yyyy-MM-dd"
          @change="checkEveryTalk()"
          placeholder="按日期检查"
        >
        </el-date-picker>
        或
        <el-button type="primary" @click="checkEveryTalk('recent')"
          >按最近检查</el-button
        >
        <el-button type="warning" v-if="showEveryOver" @click="setAllCheck"
          >本次已全部审核</el-button
        >
      </div>

      <div
        v-for="(item, index) in partTalkList"
        :key="index"
        style="max-width: 800px; margin: 50px auto 0 auto"
      >
        <div>{{ item.chat.name }}</div>
        <el-table :data="item.msgList" border stripe>
          <el-table-column prop="typeStr" label="类别" width="60">
          </el-table-column>
          <el-table-column label="内容">
            <template slot-scope="scope">
              <div style="display: inline-block">
                <div v-if="scope.row.type === 1 || scope.row.type === 10">
                  {{ scope.row.content }}
                </div>
                <div v-else-if="scope.row.type === 2">
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="scope.row.content"
                    :preview-src-list="[scope.row.content]"
                    fit="contain"
                    lazy
                  ></el-image>
                </div>
                <div v-else-if="scope.row.type === 43">
                  <el-button>播放视频</el-button>
                </div>
                <div v-else-if="scope.row.type === 9 || scope.row.type === 48">
                  <el-image
                    v-if="scope.row.content.images"
                    style="width: 100px; height: 100px"
                    :src="scope.row.content.images"
                    :preview-src-list="[scope.row.content.images]"
                    fit="contain"
                    lazy
                  ></el-image>
                  <span>{{ scope.row.content.words }}</span>
                </div>
                <div v-else-if="scope.row.type === 21 || scope.row.type === 22">
                  <div
                    v-if="scope.row.type === 22"
                    style="border-bottom: 1px solid #cccccc; margin-bottom: 5px"
                  >
                    自己：{{ scope.row.content }}
                  </div>
                  <div>
                    <span>对方：</span>
                    <span v-if="scope.row.target.type == 1">
                      {{ scope.row.target.content }}
                    </span>
                    <el-image
                      v-else-if="scope.row.target.type == 2"
                      style="width: 100px; height: 100px"
                      :src="scope.row.target.content"
                      :preview-src-list="[scope.row.target.content]"
                      fit="contain"
                      lazy
                    ></el-image>
                    <el-button v-else-if="scope.row.target.type == 43"
                      >播放视频</el-button
                    >
                    <span v-else>其它消息</span>
                  </div>
                </div>
                <div v-else>其它消息</div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="发布者" width="80">
            <template slot-scope="scope">
              <div style="display: inline-block">
                <el-image
                  style="width: 50px; height: 50px"
                  :src="scope.row.user.head_url"
                  :preview-src-list="[scope.row.user.head_url]"
                  fit="fit"
                  lazy
                ></el-image>
                <div>{{ scope.row.user.user_name }}</div>
                <el-tag type="info" v-if="scope.row.user.user_type">{{
                  scope.row.user.user_type
                }}</el-tag>
                <el-tag type="danger" v-if="scope.row.user.user_status">{{
                  scope.row.user.user_status
                }}</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="60">
          </el-table-column>
          <el-table-column prop="create_time" label="时间" width="130">
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                @click="lahei(scope.row, scope.$index)"
                >拉黑</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        background
        hide-on-single-page
        @current-change="changeTalkPage"
        layout="prev, pager, next"
        :page-size="1"
        prev-text="上一页"
        next-text="下一页"
        v-model="talkPage"
        :total="everyTalkList.length"
      >
      </el-pagination>
      <div class="white"></div>
    </div>

    <div
      v-if="listName == 'questionStatusList'"
      style="max-width: 800px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">智能问答匹配情况</h2>
      <el-table :data="questionStatusList" border stripe>
        <el-table-column prop="total" label="总数"> </el-table-column>
        <el-table-column prop="1" label="未匹配"> </el-table-column>
        <el-table-column prop="2" label="已匹配"> </el-table-column>
        <el-table-column prop="3" label="已审核"> </el-table-column>
        <el-table-column prop="5" label="待定"> </el-table-column>
        <el-table-column prop="6" label="疑难"> </el-table-column>
        <el-table-column prop="4" label="删除"> </el-table-column>
        <el-table-column prop="7" label="二轮核对"> </el-table-column>
        <el-table-column prop="8" label="无需回答"> </el-table-column>
      </el-table>
    </div>

    <div v-if="listName === 'adTotal'">
      <h2>广告位统计</h2>
      <el-table :data="ad_List" border height="60vh">
        <el-table-column label="广告位置" prop="type" align="center">
          <template slot-scope="scope">
            {{ value2show[scope.row.type] || scope.row.type }}
          </template>
        </el-table-column>
        <el-table-column label="正在上架" prop="online" align="center">
          <el-table-column
            label="楼盘名"
            prop="online"
            align="center"
            className="my_cell"
          >
            <template slot-scope="{ row }">
              <div v-for="(item, index) of row.online" :key="index">
                {{ item.estate_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="上架时间"
            prop="online"
            align="center"
            className="my_cell"
          >
            <template slot-scope="{ row }">
              <div v-for="(item, index) of row.online" :key="index">
                {{ item.start_time }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="下架时间"
            prop="online"
            align="center"
            className="my_cell"
          >
            <template slot-scope="{ row }">
              <div v-for="(item, index) of row.online" :key="index">
                {{ item.end_time }}
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="暂未上架" prop="wait" align="center">
          <el-table-column
            label="楼盘名"
            prop="wait"
            align="center"
            className="my_cell"
          >
            <template slot-scope="{ row }">
              <div v-for="(item, index) of row.wait" :key="index">
                {{ item.estate_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="上架时间"
            prop="wait"
            align="center"
            className="my_cell"
          >
            <template slot-scope="{ row }">
              <div v-for="(item, index) of row.wait" :key="index">
                {{ item.start_time }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="下架时间"
            prop="wait"
            align="center"
            className="my_cell"
          >
            <template slot-scope="{ row }">
              <div v-for="(item, index) of row.wait" :key="index">
                {{ item.end_time }}
              </div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="listName === 'adTotal1'">
      <h2>广告曝光量统计</h2>
      <div style="max-width: 1000px; margin: 50px auto">
        <el-table :data="ad_List1">
          <el-table-column label="楼盘名" prop="estate_name"></el-table-column>
          <el-table-column label="曝光量" prop="num"> </el-table-column>
          <el-table-column label="广告类型" prop="position"> </el-table-column>
          <el-table-column label="日期" prop="date"> </el-table-column>
        </el-table>
      </div>
    </div>

    <div
      v-if="listName == 'areaList'"
      style="max-width: 1500px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">常规完整度</h2>
      <div style="display: flex; margin-bottom: 10px">
        <div v-if="userTemp">负责人：{{ userTemp[areaValue] || "" }}</div>
        <input
          type="text"
          @keydown.enter="searchAreaReal"
          placeholder="回车搜索楼盘名称"
          style="margin: 0 50px"
        />
        <el-select
          filterable
          placeholder="选择区域"
          default-first-option
          v-model="areaValue"
          @change="changeArea"
        >
          <el-option
            v-for="(item, index) in areaArr"
            :key="index"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
        <el-date-picker
          style="margin: 0 20px"
          v-model="checkDate1"
          type="date"
          value-format="yyyy-MM-dd"
          @change="getAreaList()"
          placeholder="选择日期"
        >
        </el-date-picker>
      </div>
      <el-table :data="areaList" border stripe>
        <el-table-column prop="real_estate_name" label="楼盘名">
          <template slot-scope="scope">
            <div
              style="font-weight: 900"
              :class="{ cur: scope.row.all_tage != '100%' }"
            >
              {{ scope.row.real_estate_name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="all_tage" label="整体完成度" width="120">
        </el-table-column>
        <el-table-column prop="xs_tage" label="销售状态" width="120">
          <template slot-scope="scope">
            <div :class="{ cur: scope.row['销售状态'] }">
              {{ scope.row.xs_tage }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="yj_tage" label="预计开盘" width="120">
          <template slot-scope="scope">
            <div :class="{ cur: scope.row['预计开盘'] }">
              {{ scope.row.yj_tage }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="jz_tage" label="精装配置表" width="120">
          <template slot-scope="scope">
            <div :class="{ cur: scope.row['精装配置表'] }">
              {{ scope.row.jz_tage }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="dz_tage" label="银行冻资" width="120">
          <template slot-scope="scope">
            <div :class="{ cur: scope.row['银行冻资'] }">
              {{ scope.row.dz_tage }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="xq_tage" label="详情" width="120">
          <template slot-scope="scope">
            <div :class="{ cur: scope.row['详情'] }">
              {{ scope.row.xq_tage }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="wd_tage" label="楼盘问答" width="120">
          <template slot-scope="scope">
            <div :class="{ cur: scope.row['楼盘问答'] }">
              {{ scope.row.wd_tage }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="sp_tage" label="视频" width="120">
          <template slot-scope="scope">
            <div :class="{ cur: scope.row['视频'] }">
              {{ scope.row.sp_tage }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="图库" width="200">
          <template slot-scope="scope">
            <div @click="toEdit(scope.row)" :class="{ cur: scope.row['图库'] }">
              {{ scope.row.tk_tage }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="时间" width="200">
          <template slot-scope="scope">
            <div
              @click="setOneTime(scope.row)"
              v-if="scope.row.time"
              style="color: #0099ff"
            >
              {{ scope.row.time }}
            </div>
            <div @click="setOneTime(scope.row)" v-else style="color: #ccc">
              设为目标
            </div>
            <el-button
              type="primary"
              @click="setOneTime(scope.row, 'clear')"
              v-if="scope.row.time"
              >取消</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- todo：添加下载excel -->
    <div
      v-if="listName == 'zhList'"
      style="max-width: 1780px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">新房专业完整度</h2>
      <div style="display: flex; margin-bottom: 10px">
        <select name="" id="" v-model="getZhListType">
          <option value="住宅">住宅</option>
          <option value="公寓">公寓</option>
        </select>
        <input
          type="text"
          @keydown.enter="searchZhAreaReal"
          placeholder="回车搜索楼盘名称"
          style="margin: 0 50px"
        />
        <el-button
          type="primary"
          style="margin-left: 30px"
          @click="generateExcel"
          >下载excel</el-button
        >
      </div>
      <el-table
        :data="zhList"
        border
        stripe
        @header-click="sortImageNum2"
        @filter-change="filterChange"
      >
        <el-table-column label="序号" width="60">
          <template slot-scope="scope">
            <div>{{ scope.$index + 1 }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="district"
          label="区域"
          width="80"
          :filters="disFilterMap[$store.state.Counter.city]"
          :filter-method="filterZhListDis"
          column-key="district"
        >
        </el-table-column>
        <el-table-column prop="real_estate_name" label="楼盘名" align="center">
        </el-table-column>
        <el-table-column prop="all_tage" label="综合完整度" width="100">
        </el-table-column>
        <el-table-column
          prop="details_tage"
          label="详情完整度"
          width="100"
          :filters="standardsFilter"
          :filter-method="filterZhListStandards"
          column-key="details_tage"
        >
        </el-table-column>
        <el-table-column
          prop="xs"
          label="状态"
          width="80"
          :filters="statusFilter"
          :filter-method="filterZhListStatus"
          column-key="real_status"
        >
        </el-table-column>
        <el-table-column
          prop="rz"
          label="日照"
          width="80"
          :filters="hasFilter"
          :filter-method="filterZhListHas"
          column-key="rz"
        >
        </el-table-column>
        <el-table-column
          prop="hx"
          label="户型"
          width="80"
          :filters="hasFilter"
          :filter-method="filterZhListHas"
          column-key="hx"
        >
        </el-table-column>
        <el-table-column
          prop="fj"
          label="一房一价"
          width="100"
          :filters="hasFilter"
          :filter-method="filterZhListHas"
          column-key="fj"
        >
        </el-table-column>
        <el-table-column
          prop="hp"
          label="航拍"
          width="80"
          :filters="hasFilter"
          :filter-method="filterZhListHas"
          column-key="hp"
        >
        </el-table-column>
        <el-table-column
          prop="ybfvr"
          label="精装VR"
          width="80"
          :filters="hasFilter"
          :filter-method="filterZhListHas"
          column-key="ybfvr"
        >
        </el-table-column>
        <el-table-column
          prop="dynamic"
          label="置业顾问动态"
          width="110"
          :filters="hasFilter"
          :filter-method="filterZhListHas"
          column-key="dynamic"
        >
        </el-table-column>
        <el-table-column
          prop="hxfb"
          label="户型分布"
          width="90"
          :filters="hasFilter"
          :filter-method="filterZhListHas"
          column-key="hxfb"
        >
        </el-table-column>
        <el-table-column
          prop="tabel"
          label="精装配置"
          width="90"
          :filters="hasFilter"
          :filter-method="filterZhListHas"
          column-key="tabel"
        >
        </el-table-column>
        <el-table-column prop="estate" label="图片" width="80">
        </el-table-column>
        <el-table-column prop="video" label="视频" width="80">
        </el-table-column>
        <el-table-column
          prop="sale"
          label="销售"
          :filters="getZhListType == '公寓' ? hasFilter1 : hasFilter"
          :filter-method="
            getZhListType == '公寓' ? filterZhListHas_copy : filterZhListHas
          "
          width="80"
        >
        </el-table-column>
      </el-table>
    </div>

    <div
      v-if="listName == 'sellList'"
      style="max-width: 800px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">2020后公示数据</h2>
      <el-table :data="sellList" border stripe>
        <el-table-column prop="real_estate_name" label="楼盘名">
        </el-table-column>
        <el-table-column prop="date.advance" label="预售时间" width="120">
        </el-table-column>
        <el-table-column prop="rate.house_total" label="房源套数" width="120">
        </el-table-column>
        <el-table-column prop="rate.people_total" label="登记人数" width="120">
        </el-table-column>
        <el-table-column prop="rate.rate_total" label="中签率" width="120">
        </el-table-column>
      </el-table>
    </div>

    <div
      v-if="listName == 'statisticsList'"
      style="max-width: 362px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">销售动态统计</h2>
      <el-table :data="statisticsList" border stripe>
        <el-table-column prop="day" width="120"> </el-table-column>
        <el-table-column prop="openNum" label="预计开盘" width="120">
        </el-table-column>
        <el-table-column prop="dynamicNum" label="销售动态" width="120">
        </el-table-column>
      </el-table>
    </div>

    <div
      v-if="listName == 'pcList'"
      style="max-width: 1300px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">评测合计数据</h2>
      <div style="display: flex; margin-bottom: 10px">
        起始：
        <el-date-picker
          style="margin: 0 20px"
          v-model="checkDate1"
          type="date"
          value-format="yyyy-MM-dd"
          @change="getPcList('pcList')"
          placeholder="选择日期"
        >
        </el-date-picker>
        结束：
        <el-date-picker
          style="margin: 0 20px"
          v-model="checkDate2"
          type="date"
          value-format="yyyy-MM-dd"
          @change="getPcList('pcList')"
          placeholder="选择日期"
        >
        </el-date-picker>
      </div>
      <el-table :data="pcList" border stripe>
        <el-table-column prop="range" label="范围"> </el-table-column>
        <el-table-column prop="日照" label="日照"> </el-table-column>
        <el-table-column prop="户型" label="户型" width="100">
        </el-table-column>
        <el-table-column prop="噪声" label="噪声" width="100">
        </el-table-column>
        <el-table-column prop="景观" label="景观" width="100">
        </el-table-column>
        <el-table-column prop="楼栋" label="楼栋" width="100">
        </el-table-column>
        <el-table-column prop="一房一价" label="一房一价" width="100">
        </el-table-column>
        <el-table-column prop="销售公示" label="销售公示" width="100">
        </el-table-column>
        <el-table-column prop="航拍" label="航拍" width="100">
        </el-table-column>
        <el-table-column prop="航拍标注" label="航拍标注" width="100">
        </el-table-column>
        <el-table-column prop="附近点标注" label="航拍点标注" width="100">
        </el-table-column>
        <el-table-column prop="样板房" label="样板房vr" width="100">
        </el-table-column>
        <el-table-column prop="评论(使用)" label="评论(使用)" width="100">
        </el-table-column>
        <el-table-column prop="评论(未使用)" label="评论(未使用)" width="100">
        </el-table-column>
      </el-table>
    </div>
    <div
      v-if="listName == 'getNewPcList'"
      style="max-width: 1112px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">评测总和</h2>

      <el-table :data="newPcList" border stripe>
        <el-table-column prop="range" label="范围" width="120">
        </el-table-column>
        <el-table-column prop="日照" label="模型" width="120">
        </el-table-column>
        <el-table-column prop="户型" label="户型评测" width="120">
        </el-table-column>
        <el-table-column prop="户型(无评测)" label="户型未评测" width="120">
        </el-table-column>
        <el-table-column prop="一房一价" label="一房一价" width="120">
        </el-table-column>
        <el-table-column prop="航拍" label="航拍跑盘" width="120">
        </el-table-column>
        <el-table-column prop="样板房vr" label="样板房vr"> </el-table-column>
        <el-table-column prop="航拍个数" label="航拍个数" width="120">
        </el-table-column>
        <el-table-column prop="样板房个数" label="样板房个数" width="150">
        </el-table-column>
        <el-table-column prop="航拍标注" label="航拍标注" width="120">
        </el-table-column>
        <el-table-column prop="样板房标注" label="样板房标注" width="120">
        </el-table-column>
        <el-table-column prop="户型分布" label="户型分布" width="120">
        </el-table-column>
        <el-table-column prop="视频" label="视频" width="120">
        </el-table-column>
        <el-table-column prop="图片" label="图片" width="120">
        </el-table-column>
        <el-table-column prop="封面图" label="封面图及标记" width="120">
        </el-table-column>
        <el-table-column prop="交房时间" label="交付时间" width="120">
        </el-table-column>
        <el-table-column prop="规控图" label="规控图" width="120">
        </el-table-column>
        <el-table-column prop="视频图片审核" label="视频图片审核" width="120">
        </el-table-column>
      </el-table>
      <!--<el-table-column prop="噪声" label="噪声" width="120">
        </el-table-column>
        <el-table-column prop="景观" label="景观" width="120">
        </el-table-column>
        <el-table-column prop="楼栋" label="楼栋" width="120">
        </el-table-column> -->
    </div>
    <div
      v-if="listName == 'totalAdList'"
      style="max-width: 1100px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">广告数据统计</h2>
      <div style="display: flex; margin-bottom: 10px">
        起始：
        <el-date-picker
          style="margin: 0 20px"
          v-model="checkDate1"
          type="date"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        >
        </el-date-picker>
        结束：
        <el-date-picker
          style="margin: 0 20px"
          v-model="checkDate2"
          type="date"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        >
        </el-date-picker>
        <el-button @click="totalAd"> 查询 </el-button>
      </div>
      <el-table :data="AdList" border stripe>
        <el-table-column prop="user" label="队员"> </el-table-column>
        <el-table-column prop="num" label="当日完成数量"> </el-table-column>
        <el-table-column prop="total" label="总完成数量" width="120">
        </el-table-column>
        <el-table-column prop="allTotal" label="总数据数量" width="120">
        </el-table-column>
      </el-table>
    </div>

    <div
      v-if="listName == 'ptList'"
      style="max-width: 1300px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">配套合计数据</h2>
      <div style="display: flex; margin-bottom: 10px">
        起始：
        <el-date-picker
          style="margin: 0 20px"
          v-model="checkDate1"
          type="date"
          value-format="yyyy-MM-dd"
          @change="getPcList('ptList')"
          placeholder="选择日期"
        >
        </el-date-picker>
        结束：
        <el-date-picker
          style="margin: 0 20px"
          v-model="checkDate2"
          type="date"
          value-format="yyyy-MM-dd"
          @change="getPcList('ptList')"
          placeholder="选择日期"
        >
        </el-date-picker>
      </div>
      <el-table :data="pcList" border stripe>
        <el-table-column prop="range" label="范围" width="120">
        </el-table-column>
        <el-table-column prop="企业" label="企业" width="120">
        </el-table-column>
        <el-table-column prop="办公" label="办公" width="120">
        </el-table-column>
        <el-table-column prop="厂房" label="厂房" width="120">
        </el-table-column>
        <el-table-column prop="医院" label="医院" width="120">
        </el-table-column>
        <el-table-column prop="学校" label="学校" width="120">
        </el-table-column>
        <el-table-column prop="周边景观" label="景观" width="120">
        </el-table-column>
        <el-table-column prop="商场" label="商场" width="120">
        </el-table-column>
        <el-table-column prop="交通" label="交通" width="120">
        </el-table-column>
        <el-table-column prop="用地性质" label="用地性质" width="120">
        </el-table-column>
        <el-table-column prop="社群问答" label="社群问答" width="120">
        </el-table-column>
      </el-table>
    </div>

    <div
      v-if="listName == 'tjList'"
      style="max-width: 1100px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">匹配统计表格</h2>
      <div style="display: flex; margin-bottom: 10px">
        起始：
        <el-date-picker
          style="margin: 0 20px"
          v-model="tjDate1"
          type="date"
          value-format="timestamp"
          @change="getStatisticalTable('tjList')"
          placeholder="选择日期"
        >
        </el-date-picker>
        结束：
        <el-date-picker
          style="margin: 0 20px"
          v-model="tjDate2"
          type="date"
          value-format="timestamp"
          @change="getStatisticalTable('tjList')"
          placeholder="选择日期"
        >
        </el-date-picker>
      </div>
      <el-table :data="tjList" border stripe>
        <el-table-column prop="user" label="姓名"> </el-table-column>
        <el-table-column prop="match" label="匹配"> </el-table-column>
        <el-table-column prop="cancel" label="取消匹配"> </el-table-column>
        <el-table-column prop="wait" label="待定"> </el-table-column>
        <el-table-column prop="diff" label="疑难"> </el-table-column>
        <el-table-column prop="delete" label="删除"> </el-table-column>
        <el-table-column prop="check" label="已核对"> </el-table-column>
        <el-table-column prop="remark" label="修改"> </el-table-column>
        <el-table-column prop="check2" label="二轮核对"> </el-table-column>
      </el-table>
    </div>

    <div
      v-if="listName == 'QlList'"
      style="max-width: 660px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">群聊条数查询</h2>
      <div style="display: flex; margin-bottom: 10px">
        <el-date-picker
          style="margin: 0 20px"
          v-model="checkDate1"
          type="date"
          value-format="yyyy-MM-dd"
          @change="getQlList()"
          placeholder="选择日期"
        >
        </el-date-picker>
      </div>
      <el-table :data="QlList" border stripe>
        <el-table-column prop="user_name" label="负责人"> </el-table-column>
        <el-table-column prop="count2" label="群聊条数" width="120">
        </el-table-column>
        <el-table-column prop="count1" label="私聊条数" width="120">
        </el-table-column>
        <el-table-column prop="count" label="总计条数" width="120">
        </el-table-column>
        <el-table-column prop="tage" label="完成度" width="120">
        </el-table-column>
      </el-table>
    </div>

    <div
      v-if="listName == 'maxList'"
      style="max-width: 400px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">2021年最</h2>
      <el-table :data="maxList" border stripe>
        <el-table-column prop="type" label="最"> </el-table-column>
        <el-table-column prop="real_estate_name" label="楼盘名" width="200">
        </el-table-column>
        <el-table-column prop="shuju" label="数据" width="120">
        </el-table-column>
      </el-table>
    </div>

    <div
      v-if="listName == 'shareNumList'"
      style="max-width: 600px; margin: 50px auto"
    >
      <el-table :data="shareNumList" border stripe>
        <el-table-column prop="user_name" label="姓名"> </el-table-column>
        <el-table-column prop="real_estate_name" label="楼盘名" width="200">
        </el-table-column>
        <el-table-column prop="num" label="总分享"> </el-table-column>
        <el-table-column prop="art" label="文章页面"> </el-table-column>
        <el-table-column prop="notart" label="其它页面"> </el-table-column>
      </el-table>
    </div>

    <div
      v-if="listName == 'valueSortList'"
      style="display: flex; justify-content: center"
    >
      <div style="width: 600px">
        <h2 style="text-align: center; margin: 20px 0">
          产业评测排序:<span v-if="valueType">{{ valueMap[valueType] }}</span>
        </h2>
        <el-table :data="valueSortList" border stripe>
          <el-table-column prop="index" label="排名" width="50">
          </el-table-column>
          <el-table-column prop="real_estate_name" label="楼盘名">
          </el-table-column>
          <el-table-column prop="score" label="分数" width="50">
          </el-table-column>
          <el-table-column prop="value" label="价值"> </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                @click="goValueMap(scope.row, scope.$index)"
                >地图</el-button
              >
              <el-button
                size="mini"
                type="primary"
                @click="getValueSortOfOneEstate(scope.row, scope.$index)"
                >明细</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="width: 500px; margin-left: 50px">
        <h2 style="text-align: center; margin: 20px 0">
          {{ valueSortEstateName }}
        </h2>
        <el-table :data="valueSortListOfEstate" border stripe>
          <el-table-column prop="location_name" label="名称"> </el-table-column>
          <el-table-column prop="location_size" label="等级"> </el-table-column>
          <el-table-column prop="school_type" label="二级类"> </el-table-column>
          <el-table-column prop="dis" label="距离"> </el-table-column>
          <el-table-column prop="value" label="价值"> </el-table-column>
        </el-table>
      </div>
    </div>

    <div
      v-if="listName == 'matchRecordList'"
      style="max-width: 1000px; margin: 50px auto"
    >
      <h2 style="text-align: center; margin: 20px 0">问答匹配审核</h2>
      <span>总共还剩下：{{ [restreson[0]] }}</span>
      <el-date-picker
        v-model="wenda"
        @change="checkMatchRecord()"
        value-format="yyyy-MM-dd"
        type="date"
        placeholder="选择日期"
      >
      </el-date-picker>
      <span>当前日期完成：{{ [restreson[1]] }}</span>
      <el-table :data="matchRecordList" border stripe>
        <el-table-column prop="input" label="问题"> </el-table-column>
        <el-table-column prop="output" label="匹配"> </el-table-column>
        <el-table-column prop="help" label="帮助"> </el-table-column>
        <el-table-column prop="create_time" label="时间"> </el-table-column>
        <el-table-column label="操作" width="400">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="setMatchRecord(scope.row, scope.$index, 1)"
              >正确</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="setMatchRecord(scope.row, scope.$index, 2)"
              >匹配错误</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="setMatchRecord(scope.row, scope.$index, 3)"
              >无需回答</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="setMatchRecord(scope.row, scope.$index, 4)"
              >不是问题</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div
      v-if="listName == 'assignCustomer'"
      style="max-width: 1300px; margin: 50px 200px"
    >
      <h2 style="text-align: center; margin: 20px 0">分配客户情况</h2>
      <div style="display: flex; margin-bottom: 10px">
        <el-select
          filterable
          placeholder="选择楼盘"
          default-first-option
          :remote-method="searchEstate"
          remote
          v-model="estateValue"
        >
          <el-option
            v-for="(item, index) in matchEstates"
            :key="index"
            :label="item.real_estate_name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-button @click="getGiveClientInfo(estateValue)">查询</el-button>
      </div>
      <el-table :data="assignCustomer" border stripe>
        <el-table-column prop="date" label="日期" width="200">
        </el-table-column>
        <el-table-column prop="total" label="当天分配客户"> </el-table-column>
        <el-table-column
          prop="sale"
          label="置业顾问姓名和分到的客户数量"
          width="400"
        >
          <template slot-scope="scope">
            <div v-for="(sale, index) in scope.row.sales" :key="index">
              {{ sale.user_name }} : {{ sale.num }}个
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="listName == 'testReply'">
      <el-select
        v-model="chooseHotId"
        filterable
        placeholder="选择楼盘"
        default-first-option
        :remote-method="searchEstate"
        remote
        clearable
      >
        <el-option
          v-for="(item, index) in matchEstates"
          :key="index"
          :label="item.real_estate_name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-input
        style="width: 200px"
        v-model="testReplyWord"
        placeholder="要回复的答案类"
      ></el-input>
      <el-button
        type="primary"
        @click="sendTestReply(testReplyWord, chooseHotId)"
        >发送</el-button
      >
    </div>
    <div v-if="ifrecommendrealestate">
      <el-select
        filterable
        placeholder="选择楼盘"
        default-first-option
        :remote-method="searchEstate"
        remote
        v-model="recommandEstate"
      >
        <el-option
          v-for="(item, index) in matchEstates"
          :key="index"
          :label="item.real_estate_name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <button @click="setThisRealestate()">上传此楼盘</button>
    </div>

    <div class="normal" v-if="listName == 'setTopicLabel'">
      选择类目：
      <div class="input-box" v-for="(label, index) in topicLabels" :key="index">
        <el-select
          v-model="topicLabels[index]"
          filterable
          allow-create
          default-first-option
          :placeholder="index + 1 + '级类目'"
          @change="onTopicLabelChange($event, index)"
        >
          <el-option
            v-for="item in topicLabelOptions[index]"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </div>
    </div>

    <div v-if="listName == 'checkAutoReply'">
      <input type="text" placeholder="输入问题" v-model="judgeQuestion" />
      <el-select
        v-model="judgeQuestionEstate"
        filterable
        placeholder="搜索楼盘"
        default-first-option
        :remote-method="searchEstate"
        remote
      >
        <el-option
          v-for="(item, index) in matchEstates"
          :key="index"
          :label="item.real_estate_name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-button type="primary" @click="checkAutoReply">检查</el-button>
    </div>
    <el-dialog title="购房通公示" :visible.sync="dialogTableVisible" center>
      <el-table :data="noticeData" border stripe>
        <el-table-column
          property="name"
          label="楼盘名"
          align="center"
        ></el-table-column>
        <el-table-column
          property="status_name"
          label="状态"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button @click="getGFTcontent(scope)">抓取</el-button>
          </template>
        </el-table-column>
        <el-table-column
          property="type"
          label="来源"
          align="center"
        ></el-table-column>
      </el-table>
    </el-dialog>
    <div class="white"></div>
  </div>
</template>

<script>
// import AllpoiList from './filejson.json';
import { AMapManager } from "vue-amap";
import adPosition from "../config/adPosition";
const { show2value, value2show } = adPosition;
import NewOperateTeam from "@/page/newOperateTeam/index.vue";
let amapManager = new AMapManager();
export default {
  name: "Other",
  components: {
    NewOperateTeam,
  },
  data() {
    return {
      candidateLoading: false,
      batchDialogVisible: false,
      batchSubmitting: false,
      batchName: '',
      batchCandidates: [],
      selectedLands: [],
      oldFirst: false,
      canViewPerformanceMonitor: false,
      show2value,
      value2show,
      seeNewoperate: true,
      seeSecoperate: true,
      newOperateIds: [
        "1886839isfa",
        "48fa6e9n0n40",
        "48q4jibqhyps",
        "4ktcx8v9w0lc",
      ],
      secOperateIds: ["4fdv5non0r28", "4jchajd5p5a8", "492dwn83nc3k"],
      judgeQuestion: "",
      judgeQuestionEstate: "",
      updataImage_text: "",
      updataImage_type: "",
      showSale: false, //显示销售分享排名
      ax: {},
      maxHeight: 0,
      dialogTableVisible: false,
      noticeData: [],
      guwenList: [],
      commentdd1: "",
      commentdd2: "",
      commentdd3: "",
      commentdd4: "",
      commentdd13: [],
      commentWordList: {},
      loupanCheck: "楼盘",
      restreson: [],
      wenda: "",
      recommandEstate: "",
      ifrecommendrealestate: false,
      poiInformations: [],
      imageName: "",
      imageSrc: "",
      videoSrc: "",
      videoCover: "",

      tjList: [],

      realInfoList: [],

      advanceList: [],

      estateHits: [],

      msgNumList: [],

      estateScore: [],

      listName: "",

      homePageHits: [],
      estatePageHits: [],
      twoHomePageHits: [],
      twoEstatePageHits: [], //二手楼盘页点击
      secKeys: [],
      news: [],
      currentNews: null,

      estateRateList: [],

      salerStatus: [], // 销售活动数据分析

      visitData: [],
      baseVisitData: [], // 小程序整体访问情况，微信统计的

      checkSaleAd1: [],
      checkDate: "", // 看哪个月的销售付费记录

      search_word: "",
      salesmanList: [],
      allSaleName: [],

      estateImageNum: [],
      imageNumSortMap: {},
      imageNumSortMap2: [],

      shareTop: [],
      sharePublic: [],
      shareWeekTop: [],
      checkDate1: "",
      checkDate2: "", //指定时间访问

      tjDate1: "",
      tjDate2: "",

      color: "",

      dblist: [],
      baseList: [], //搜索楼盘
      showdblist: [],
      searchText: "",
      showRealSearch: false,
      valueRealId: "",
      resultName: "",
      resultStr: "", //生成分享路径
      userId: "", //顾问id
      imgName2: "", //户型编号
      colType: "选房", //选房日照房价楼栋
      shouyeType: "正在公示", //首页正在公示 登记 。。
      tabbarStr: "买房问答", //买房/讨论/土拍/学区
      articleShares: [],
      articleTitle: "",
      pageNum: 0, //分页请求
      searchText: "",

      realStatus: "在售待首开",
      priceType: "200万+", //总价楼盘
      priceList: [
        "全部",
        "100万内",
        "100万+",
        "200万+",
        "300万+",
        "400万+",
        "500万+",
        "600万+",
        "700万+",
        "800万+",
        "900万+",
        "1000万+",
        "待首开",
      ],
      redList: "",
      isLoading: false,
      redObj: {
        estate_id: "",
        money: "",
        start_time: "",
        deal_time: "",
      },
      priceRealList: [],
      real_estate_id: [],
      yjMonth: "",
      monthList: [], //预计开盘
      saleList: [], //销售4000+

      checkList: [], //话题审核

      salesList: [], //顾问加分

      inviteList: [], //运营加分
      szInviteList: [], //运营加分

      sunHouse: [], //日照户型

      salePut: [], //销售上传

      HzTitle: [], //杭州公示

      checkAnsTime: "",

      ZJReal: [],

      oldPriceList: [], //2-3万
      apartList: [], //4室

      serType: "全部",
      serList: ["全部", "顾问", "非顾问"],
      codeImg: "", //二维码
      hotingList: [],
      current: "",
      operation: "",
      operations: [
        {
          en: "operate",
          ch: "新运营小队",
        },
        // {
        //   en: "operate",
        //   ch: "运营小队",
        // },
        {
          en: "market",
          ch: "销售小队",
        },
        {
          en: "content",
          ch: "内容小队",
        },
        {
          en: "data",
          ch: "数据小队",
        },
        {
          en: "innovate",
          ch: "创新小队",
        },
        {
          en: "business",
          ch: "商务小队",
        },
        {
          en: "xinghao",
          ch: "用户运营",
        },
        {
          en: "safety",
          ch: "安全监控",
        },
        {
          en: "zukeCenter",
          ch: "小鸡租客",
        },
        {
          en: "experience",
          ch: "经验池",
        },
        {
          en: "feedback",
          ch: "意见反馈",
        },
        {
          en: "zuwoCenter",
          ch: "小鸡租窝",
        },
        // {
        //   en: "authority",
        //   ch: "内部权限",
        // },
      ],

      areaValue: "余杭区",
      areaFilterList: [
        {
          text: "余杭区",
          value: "余杭区",
        },
        {
          text: "滨江区",
          value: "滨江区",
        },
        {
          text: "萧山区",
          value: "萧山区",
        },
        {
          text: "钱塘区",
          value: "钱塘区",
        },
        {
          text: "拱墅区",
          value: "拱墅区",
        },
        {
          text: "西湖区",
          value: "西湖区",
        },
        {
          text: "临安区",
          value: "临安区",
        },
        {
          text: "富阳区",
          value: "富阳区",
        },
        {
          text: "上城区",
          value: "上城区",
        },
        {
          text: "临平区",
          value: "临平区",
        },
      ],
      scoreType: "",
      matchEstates: [],
      chooseHotId: "",
      tableSearch: "",
      userSearch: "",

      zoom: 15, // 地图缩放级别
      center: [120.051238, 30.228232], // 地图中心点
      amapManager, // 地图管理对象
      plugin: [
        {
          //地图类型，卫星地图和普通地图
          pName: "MapType",
          defaultType: 0,
        },
      ],
      topicLnglat: "",
      district: [],

      yuJiUrl: "", //预计开盘表格

      houseList: [],

      sortList: [], //排行
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      value1: "",
      type: "新房",
      value: "日照",
      purpose: "",
      uploadNum: 0,
      estateImgCheck: [], // 二手房
      hangImgCheck: [],

      adCloseList: [],
      closeDay: "",

      GsList: [],

      userList: [], //解禁

      codeType: "",
      codeTypeList: [
        "排行榜",
        "半径找房",
        "地铁找房",
        "选房pk",
        "学区找房",
        "买房问答",
        "百科",
        "正在公示",
        "正在登记",
        "摇号查询",
        "预计开盘",
        "新房榜单",
        "二手房榜单",
        "二手房砍价",
        "板块排行榜",
        "小学排行榜",
        "初中排行榜",
        "学区板块详情",
        "智能找房",
        "土拍/土拍详情",
        "活动页面",
        "找群",
        "购房资格",
        "落户资格",
        "无房资格",
        "房屋权属",
        "房屋继承",
        "直播列表",
        "楼市报告",
        "更多话题",
        "楼市文章",
      ],
      posterType: "",
      szPosterTypeList: ["每周拿证公示"],
      hzPosterTypeList: ["每日楼市", "投票选房", "比价表"],
      building_name: "",
      mpCode: "",

      messList: [],
      dateType: "今天",
      dateList: ["今天", "昨天"],

      payVisible: false,
      payUser: {},
      labelWidth: "40%",
      salePayList: [],
      saleAdType: "",

      saleJoinData: [],
      showButton: false,
      spiderData: [],
      waitMatchList: [],
      hadMatchList: [],
      matchListSearchText: "",
      currentAddress: {},
      currentMulti: {},

      checkUserType: "",

      yuyueList: [],
      logList: [],

      newsList: [],
      addList: [],

      salesMsgNum: [],

      QunType: [
        "楼盘群",
        // "板块群",
        // "总价群",
        // "达人群",
        // "区域群",
        "话题群",
        // "专题群",
        // "所有群",
        // "销售聊天",
      ],
      searchType: "楼盘群",
      interval: "",
      searchName: "",
      qunList: [],
      records: [], //销售聊天记录
      content: "",
      chooseList: [], //已选
      sendWay: "假用户消息",
      suiji: "随机用户",
      sjUser: "", //随机用户

      friedList: [],
      mainGroup: "",
      subgroup: "",

      artList: [], //投放文章
      artSearch: "", //搜索文章

      yushouList: [], //苏州预售楼盘
      estateSortObj: null,
      estateSortId: "",

      phoneUsers: [],

      areaArr: [
        "余杭区",
        "西湖区",
        "临安区",
        "萧山区",
        "滨江区",
        "富阳区",
        "钱塘区",
        "临平区",
        "上城区",
        "拱墅区",
      ],
      filterDistrits: [],

      talkRecord: [],
      talkUserMap: {},

      statisticsList: [],

      checkTalks: [],
      checkTalksDate: "",
      checkTalksNum: 0,

      needList: [], //临时表格
      userType: "",

      nameSearchUsers: [],

      fakeSaleAd: [],
      fakeSaleAdEstate: "",

      everyTalkDate: "",
      everyTalkList: [],
      showEveryOver: false,
      partTalkList: [],
      talkPage: 1,
      questionStatusList: [],
      gsMap: {
        area: "板块",
        real_estate_name: "楼盘名称",
        building: "开盘楼栋",
        square: "面积",
        house_total: "套数",
        piece: "价格",
        rate_total: "最近中签率",
        no_rate: "无房比例",
        capital: "冻资验资",
        regDate: "登记时间",
      },
      gsWMap: {
        house_total: 50,
        piece: 95,
        rate_total: 85,
        no_rate: 70,
        regDate: 105,
      },
      areaList: [],
      userTemp: {
        余杭区: "丑八怪",
        西湖区: "丑八怪",
        临安区: "丑八怪",

        萧山区: "小青",
        滨江区: "小青",
        富阳区: "小青",

        钱塘区: "大芸",
        临平区: "大芸",
        上城区: "大芸",
        拱墅区: "大芸",
      },
      zhList: [],
      ZhValue: "",
      QlList: [],
      maxList: [],
      assignCustomer: [],
      estateValue: "",
      sellList: [],
      pcList: [],
      ptList: [],
      newPcList: [],
      valueMap: {
        industry: "产业",
        company: "企业",
        office: "办公大厦",
        government: "政府办公",
        daogua: "倒挂",
        harmful: "不利",
      },
      locationMap: {
        total: "总分",
        market: "商业",
        traffic: "交通",
        school: "教育",
        hospital: "医疗",
        scenery: "景观",
        public: "公建",
      },
      valueType: "",
      valueBigType: "estate",
      valueOtherType: "配套",
      locationType: "",
      valueSortList: [],
      valueSortListOfEstate: [],
      currentValueClass: "",
      valueSortEstateName: "",
      usUserList: [],
      usUser: "全部",
      interest: {}, // 编辑银行利率
      essay: [], // 编辑公众号
      hasFilter: [
        { text: "有", value: "有" },
        { text: "无", value: "无" },
      ],
      hasFilter1: [
        { text: "达标", value: "达标" },
        { text: "不达标", value: "不达标" },
      ],
      disFilterMap: {
        杭州: [
          { text: "余杭区", value: "余杭区" },
          { text: "西湖区", value: "西湖区" },
          { text: "临安区", value: "临安区" },
          { text: "萧山区", value: "萧山区" },
          { text: "滨江区", value: "滨江区" },
          { text: "富阳区", value: "富阳区" },
          { text: "钱塘区", value: "钱塘区" },
          { text: "临平区", value: "临平区" },
          { text: "上城区", value: "上城区" },
          { text: "拱墅区", value: "拱墅区" },
        ],
        苏州: [
          { text: "工业园区", value: "工业园区" },
          { text: "吴江区", value: "吴江区" },
          { text: "高新区", value: "高新区" },
          { text: "吴中区", value: "吴中区" },
          { text: "相城区", value: "相城区" },
          { text: "姑苏区", value: "姑苏区" },
          { text: "昆山市", value: "昆山市" },
          { text: "太仓市", value: "太仓市" },
          { text: "张家港市", value: "张家港市" },
          { text: "常熟市", value: "常熟市" },
        ],
      },
      statusFilter: [
        { text: "在售", value: "在售" },
        { text: "待首开", value: "待首开" },
      ],
      standardsFilter: [
        { text: "达标", value: "达标" },
        { text: "不达标", value: "不达标" },
      ],

      testReplyWord: "",
      matchRecordList: [],

      commentEstateId: "",
      commentAreaId: "",
      commentTypes: [
        // "样板房评测",
        // "楼盘评测",
        "3D选房评测",
        "配套评测",
        "投资价值评测",
        // "规划分析",
        "VR航拍评测",
        "户型评测",
        "板块评测",
      ],
      databaseTypes: {
        "3D选房评测": "楼盘选房",
        配套评测: "周边配套",
        投资价值评测: "楼盘价值",
        VR航拍评测: "楼盘现状",
        户型评测: "户型",
        板块评测: "板块",
      },
      commentType: "",
      commentAparts: "",
      commentApart: "",
      commentUsers: [],
      commentUserId: "",
      commentWord: "",
      matchAreas: [],
      filter: {},

      agentEstateId: "",
      shareNumList: [],

      getZhListType: "住宅",
      inviteListUsers: [],
      AdList: [],
      redBagList: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() + 24 * 3600 * 1000;
        },
      },
      ad_List: [],
      ad_List1: [],
      erp_id: "",
      xhLogList: [],
      xhLogMaxId: "",
      pyqValue: "",
      xHTalkList: [],
      xHGSListFilters: {
        name: [],
        geo_name: [],
      },
      xHTalkListFilters: {
        name: [],
        label: [],
        geo_name: [],
      },
      xHGSList: [],
      teamList: [],

      error_platform: "android",
      talkSelectGroup: "",

      topicLabels: [""],
      topicLabelOptions: [[], []],
      topicLabelBackId: "15o04327pgl",
      baseLabelOptions: [],
      topicLabelMap: {},

      landStatusState: "待出让",
      landStatusBatch: "",

      groupWaterList: [],
      groupWaterFilter: {
        name: [],
        geo_name: [],
      },
      channelWaterList: [],
      channelWaterFilter: {
        name: [],
        geo_name: [],
      },
      bindPriceList: [],
      bindPriceEstateId: "",
      commentFlag: false, //楼盘点评 评论按钮是否禁用

      redDot: 0,
      mpCode2: "",
      areaTable: [
        "上城",
        "拱墅",
        "西湖",
        "滨江",
        "临平",
        "萧山",
        "余杭",
        "钱塘",
        "富阳",
        "临安",
        "桐庐",
        "淳安",
        "建德",
      ],
      zxData: [],
      showZxTable: false,
      zxDataTime: [],
      showZxConsult: false,
      zxConsultTime: [],
      zxConsult: [],
      pointData: {},
    };
  },
  mounted() {
    this.maxHeight = window.innerHeight - 350;
  },
  activated() {
    this.getRedDot();
    this.getCheckRedPoint();
    this.init();
    this.$store.commit("SET_CITY", "杭州");

    sessionStorage.setItem("city", "杭州");
  },
  methods: {
    // 打开时重新加载候选，避免沿用已被其它批次占用的地块。
    async openCreateBatch() {
      this.candidateLoading = true
      try {
        const res = await this.$axios.get(this.$url_prefix + 'land/batch/candidates')
        if (!res.data.success) throw new Error(res.data.msg || '获取地块失败')
        this.batchName = res.data.data.name
        this.batchCandidates = res.data.data.lands
        this.selectedLands = []
        this.batchDialogVisible = true
        await this.$nextTick()
        this.$refs.candidateTable.clearSelection()
        this.batchCandidates.forEach(land => this.$refs.candidateTable.toggleRowSelection(land, true))
      } catch (error) {
        this.$message.error(error.message || '获取地块失败')
      } finally {
        this.candidateLoading = false
      }
    },
    // 请求只等待批次建立，后台评分无需停留本页。
    async createBatch() {
      if (this.batchSubmitting || !this.batchName.trim() || !this.selectedLands.length) return
      this.batchSubmitting = true
      try {
        const res = await this.$axios.post(this.$url_prefix + 'land/batch/create', {
          name: this.batchName.trim(),
          landIds: this.selectedLands.map(land => land.id)
        })
        if (!res.data.success) throw new Error(res.data.msg || '创建失败')
        this.batchDialogVisible = false
        this.$message.success('批次已创建，后台处理结果将发送到钉钉信息监控群')
      } catch (error) {
        this.$message.error(error.message || '创建失败，请重新打开弹窗确认后再操作')
      } finally {
        this.batchSubmitting = false
      }
    },
    modifyZXData(row, column, cell) {
      const key = column.property;
      const index = this.zxConsult.findIndex((x) => x.date == row.date);
      const item = this.zxConsult[index];
      const keyMap = {
        talk: "咨询",
        phone: "电话",
      };
      if (item && keyMap[key]) {
        this.$prompt(`当前：${item[key]}`, `修改${item.date}${keyMap[key]}`, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputValue: "",
        })
          .then(({ value }) => {
            let multi = parseInt(value);
            if (multi) {
              item[key] = multi;
            } else {
              this.$message.error("请填写正确的数字");
            }
          })
          .catch((err) => {
            console.log("取消修改", err);
          });
      }
    },
    async getZXConsult() {
      let that = this;
      let result = [];
      let chosed = Number(
        `${that.zxConsultTime[0].split("-")[0]}${
          that.zxConsultTime[0].split("-")[1]
        }${that.zxConsultTime[0].split("-")[2]}`
      );
      if (chosed < 20241128) {
        that.zxConsult = [];
        that.$message.warning("装修活动2024年11月28日上线");
        return;
      }
      that.$open();
      that.zxConsult = [];
      await that.$axios
        .post(that.$url_prefix + "fitment/get/brand/statistics", {
          startTime: that.zxConsultTime[0],
          endTime: that.zxConsultTime[1],
        })
        .then((res) => {
          console.log("zxData", res.data);
          if (res.data && res.data.data) {
            result = res.data.data;
            for (let i = 0; i < result.length; i++) {
              result[i].new_ad_exposure = Math.ceil(result[i].new_ad_exposure);
            }
            that.zxConsult = result.reverse();
          } else that.zxConsult = [];
          that.$close();
        })
        .catch((err) => {
          that.$message.error("获取数据失败，请稍后再试！");
          that.$close();
        });
    },
    async getZXData() {
      let that = this;
      let result = [];
      let chosed = Number(
        `${that.zxDataTime[0].split("-")[0]}${
          that.zxDataTime[0].split("-")[1]
        }${that.zxDataTime[0].split("-")[2]}`
      );
      if (chosed < 20241128) {
        that.zxData = [];
        that.$message.warning("装修活动2024年11月28日上线");
        return;
      }
      that.$open();
      that.zxData = [];
      await that.$axios
        .post(that.$url_prefix + "fitment/activity/ad", {
          startTime: that.zxDataTime[0],
          endTime: that.zxDataTime[1],
        })
        .then((res) => {
          console.log("zxData", res.data);
          if (res.data && res.data.data && res.data.data.data) {
            result = res.data.data.data;
            for (let i = 0; i < result.length; i++) {
              result[i].new_ad_exposure = Math.ceil(result[i].new_ad_exposure);
            }
            that.zxData = result.reverse();
          } else that.zxData = [];
          that.$close();
        })
        .catch((err) => {
          that.$message.error("获取数据失败，请稍后再试！");
          that.$close();
        });
    },
    drawPoster2(e) {
      switch (e) {
        case 1:
          this.DWSame(
            "/static/images/img_dailynews3.png",
            "second/deal/poster/data",
            2018
          );
          break;
        case 2:
          this.DWSame(
            "/static/images/img_dailynews4.png",
            "second/add/poster/data",
            2018
          );
          break;
        default:
          // 默认情况，可以是一些错误处理或者不做任何事情
          break;
      }
    },
    async DWSame(bgImg, path, tableHeight) {
      console.log(12);
      let that = this;
      let data = [];
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 1); // 这一行实际上没有改变日期，因为减去0天
      const optionsDate = { year: "numeric", month: "long", day: "numeric" };
      const optionsTime = {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
      };
      let date =
        currentDate.toLocaleDateString("zh-CN", optionsDate) + " " + "23:00:00";
      let res = await that.$axios.get(that.$url_prefix + path);

      if (res.data.success) {
        console.log(res);
      }
      let chartData = res.data.result;
      let width = 750;
      let canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = tableHeight;
      let context = canvas.getContext("2d");

      let bg = await new Image();
      bg.src = bgImg;
      bg.onload = async function () {
        await context.drawImage(bg, 0, 0, width, tableHeight);
        const text = "统计时间：";
        context.fillStyle = "#6F3C12";
        context.font = "34px Source Han Sans-Regular";
        const textWidth = context.measureText(`${text}${date}`).width;
        context.fillText(`${text}${date}`, 42, 250);
        that.partTable(context, chartData);
        that.mpCode2 = canvas.toDataURL("image/jpeg");
        that.$previewRefresh();
      };
    },
    async partTable(cxt, chartData) {
      let tableTop = 94;
      let totalWidth = 0;
      let totalWidth2 = 0;
      console.log(chartData.day.totalNum);
      // 今日成交套数
      cxt.font = "70px PingFang SC-Medium";
      totalWidth += cxt.measureText(chartData.day.totalNum).width;
      let width1 = cxt.measureText(chartData.day.totalNum).width;
      cxt.font = "30px PingFang SC-Regular";
      totalWidth += cxt.measureText(" 套").width;
      cxt.font = "70px PingFang SC-Medium";
      cxt.fillStyle = "#333";
      cxt.fillText(chartData.day.totalNum, 187.5 - totalWidth / 2, 400);
      cxt.font = "30px PingFang SC-Regular";
      cxt.fillStyle = "#333";
      cxt.fillText(" 套", 187.5 - totalWidth / 2 + width1, 400);
      // 本月成交套数
      cxt.font = "70px PingFang SC-Medium";
      totalWidth2 += cxt.measureText(chartData.month.totalNum).width;
      let width2 = cxt.measureText(chartData.month.totalNum).width;
      cxt.font = "30px PingFang SC-Regular";
      totalWidth2 += cxt.measureText(" 套").width;
      cxt.font = "70px PingFang SC-Medium";
      cxt.fillStyle = "#333";
      cxt.fillText(chartData.month.totalNum, 562.5 - totalWidth2 / 2, 385);
      cxt.font = "30px PingFang SC-Regular";
      cxt.fillStyle = "#333";
      cxt.fillText(" 套", 562.5 - totalWidth2 / 2 + width2, 385);
      for (let i = 0; i < this.areaTable.length; i++) {
        let dealNum = "";
        const match = chartData.day.district.find(
          (item) => item.name === this.areaTable[i]
        );
        if (match) {
          dealNum = match.num;
        } else {
          dealNum = "/";
        }
        cxt.fillStyle = "#333";
        cxt.font = "32px PingFang SC-Regular";
        cxt.textAlign = "center";
        cxt.fillText(dealNum, 375, 625 + tableTop * i);
      }
      for (let i = 0; i < this.areaTable.length; i++) {
        let dealNum2 = "";
        const match = chartData.month.district.find(
          (item) => item.name === this.areaTable[i]
        );
        if (match) {
          dealNum2 = match.num;
        } else {
          dealNum2 = "/";
        }
        cxt.fillStyle = "#333";
        cxt.font = "32px PingFang SC-Regular";
        cxt.textAlign = "center";
        cxt.fillText(dealNum2, 615, 625 + tableTop * i);
      }
    },
    async getRedDot() {
      try {
        let loginId = "";
        let res1 = await this.$axios.get(
          this.$url_prefix + "requirement/users"
        );
        if (res1.data.success) {
          loginId = res1.data.data.allUsers[0].id;
        }
        let res = await this.$axios.post(
          this.$url_prefix + "requirement/redDot",
          {
            user_id: loginId,
          }
        );
        if (res.data.success) {
          this.redDot = res.data.result[0] ? res.data.result[0].unRead : 0;
        }
      } catch (e) {
        console.log("getRedDot ~ e:", e);
      }
    },
    async getCheckRedPoint() {
      try {
        let res = await this.$axios.post(this.$url_prefix + "audit/status");
        this.pointData = res.data;
        console.log("获取红点返回", res);
      } catch (error) {
        console.log(error);
      }
    },
    downloadExcel(typeTitle) {
      let data = [];
      let ths = [];
      let keys = [];

      if (typeTitle === "4室户型") {
        data = this.apartList;
        ths = ["楼盘名", "区域", "板块", "户型", "面积", "是否评测"];
        keys = [
          "real_estate_name",
          "district",
          "area_name",
          "house_style",
          "allRoomSquare",
          "hasPc",
        ];
      } else if (typeTitle === "2-3万楼盘") {
        data = this.oldPriceList;
        ths = ["楼盘名", "板块", "价格", "预计开盘"];
        keys = ["real_estate_name", "area_name", "priceStr", "expect"];
      } else if (typeTitle === "90方楼盘") {
        data = this.houseList;
        ths = ["楼盘名", "区域", "板块", "具体户型"];
        keys = ["real_estate_name", "district", "area_name", "apart"];
      }

      let table = "<table>";
      let row = "<tr>";
      for (let i = 0; i < ths.length; i++) {
        row += "<th>" + ths[i] + "</th>";
      }
      table += row + "</tr>";
      for (let i = 0; i < data.length; i++) {
        let td = "<tr>";
        for (let key of keys) {
          if (key === "expect") {
            if (data[i].expect && data[i].expect.date) {
              td += `<td style="vnd.ms-excel.numberformat:yyyy-mm">${data[i].expect.date} </td>`;
            } else {
              td += `<td></td>`;
            }
          } else {
            td += `<td>${data[i][key] || ""}</td>`;
          }
        }
        td += "</tr>";
        table += td;
      }

      let excelFile =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
        "xmlns:x='urn:schemas-microsoft-com:office:excel' xmlns='http://www.w3.org/TR/REC-html40'>";
      excelFile +=
        '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
      excelFile +=
        '<meta http-equiv="content-type" content="application/vnd.ms-excel';
      excelFile += '; charset=UTF-8">';
      excelFile += "<head>";
      excelFile += "<!--[if gte mso 9]>";
      excelFile += "<xml>";
      excelFile += "<x:ExcelWorkbook>";
      excelFile += "<x:ExcelWorksheets>";
      excelFile += "<x:ExcelWorksheet>";
      excelFile += "<x:Name>";
      excelFile += "sheet";
      excelFile += "</x:Name>";
      excelFile += "<x:WorksheetOptions>";
      excelFile += "<x:DisplayGridlines/>";
      excelFile += "</x:WorksheetOptions>";
      excelFile += "</x:ExcelWorksheet>";
      excelFile += "</x:ExcelWorksheets>";
      excelFile += "</x:ExcelWorkbook>";
      excelFile += "</xml>";
      excelFile += "<![endif]-->";
      excelFile += "</head>";
      excelFile += "<body>";
      excelFile += table;
      excelFile += "</body>";
      excelFile += "</html>";
      let uri =
        "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8,base64," +
        encodeURIComponent(excelFile);
      let link = document.createElement("a");
      link.href = uri;
      let download = `${typeTitle}_${(new Date().getTime() % 1000) + 1}.xlsx`;
      link.download = download;
      link.click();
      this.$close();
    },
    toUpdatePropertyDealData() {
      let input = document.createElement("input");
      input.type = "file";
      input.multiple = "multiple";
      input.addEventListener("change", this.updatePropertyDealData);
      input.click();
    },
    toSchdule() {
      this.$router.push({ path: "realEstateSchedule" });
    },
    ToaerialSurvey() {
      this.$router.push({ path: "aerialSurvey" });
    },
    async updatePropertyDealData(event) {
      let keyMap = {
        单元号: "unit",
        坐落: "address",
        城区: "district",
        小区: "estate_name",
        幢号: "build",
        "建筑面积(㎡)": "area",
        "总价(万)_1": "total_deal_price",
        房屋用途: "purpose",
        房源编码: "source_id",
        楼层: "floor",
        签约日期: "deal_date",
        签约经纪公司: "deal_company",
      };
      function excelDateToJSDate(serial) {
        var utc_days = Math.floor(serial - 25569);
        var utc_value = utc_days * 86400;
        var date_info = new Date(utc_value * 1000);

        // 返回一个格式化的日期字符串，例如 "2023-12-09"
        return date_info.toISOString().split("T")[0];
      }
      for (let file of event.target.files) {
        try {
          let list = await this.$readExcel(file);
          list = list.map((x) => {
            let obj = {};
            for (let key in keyMap) {
              obj[keyMap[key]] = x[key];
            }

            try {
              obj.deal_date = excelDateToJSDate(obj.deal_date);
            } catch (err) {
              //
            }

            if (!obj.total_deal_price) {
              obj.total_deal_price = Math.round(x["总价(万)"] / 100) / 100;
            }

            if (!obj.source_id) {
              obj.source_id = `${obj.deal_date.replace(/-/g, "")}-${obj.area}-${
                obj.total_deal_price
              }`;
            }

            return obj;
          });
          console.log("list", list);
          try {
            let add_num = 0;
            let size = 1000;
            let page = Math.ceil(list.length / size);
            for (let i = 0; i < page; i++) {
              console.log("page", i);
              const arr = list.slice(i * size, (i + 1) * size);
              let res = await this.$axios.post(
                this.$url_prefix + "uploadPropertyDealData",
                {
                  list: arr,
                }
              );
              add_num += res.data.add_num;
            }

            this.$message({
              type: "success",
              message: "上传成功" + add_num,
            });
          } catch (err) {
            console.log("err", err);
            this.$message.error("上传失败");
          }
        } catch (err) {
          console.log("read file error", err);
        }
      }
    },
    toCountSharevisite() {
      this.$router.push({
        path: "/countSharevisit",
      });
    },
    toEstateAsManage() {
      this.$router.push({
        path: "/estateAsManage",
      });
    },
    toHaterIdentify() {
      this.$router.push({
        path: "/haterIdentify",
      });
    },
    toEmotionRecord() {
      this.$router.push({
        path: "/emotionRecord",
      });
    },
    toPointsMall() {
      this.$router.push({
        path: "/pointsMall",
      });
    },
    toTaskAudit() {
      this.$router.push({
        path: "/taskaudit",
      });
    },
    comparingCustomers(event) {
      let that = this;
      if (!that.real_estate_id) {
        that.$message.error("未选择楼盘");
        return;
      }

      let file = event.target.files[0];
      that.$readExcel(file).then(async function (persons) {
        let phoneSet = new Set();
        persons.forEach((person) => {
          const phone = person["电话"] || person["手机号码"];
          console.log("phone", phone);
          if (phone) phoneSet.add(String(phone).trim());
        });
        const phoneList = Array.from(phoneSet);
        phoneSet = null;
        const size = 200;
        that.$open();
        const step = Math.ceil(phoneList.length / size);
        for (let i = 0; i < step; i++) {
          try {
            let res = await that.$axios.post(
              that.$url_prefix + "comparingCustomers",
              {
                phone_list: phoneList.slice(i * size, i * size + size),
                estate_id: that.real_estate_id,
                oldFirst: that.oldFirst,
              },
              {
                timeout: 180 * 10000,
              }
            );
            console.log("comparingCustomers", res);
            if (res.data.success && res.data.data && res.data.data.excel) {
              window.open(that.$base_url + res.data.data.excel, "_blank");
            }
          } catch (err) {
            console.error("comparingCustomers fail", i, err);
          }
        }
        that.$close();
      });
    },
    selectRZ() {
      this.listName = "seleceRZList";
    },
    addRZSort() {
      this.$axios.get().then();
    },
    sumList(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总数";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += "";
        } else {
          sums[index] = data.length;
        }
      });
      return sums;
    },
    // 跳转活动红包页
    GoToRedPacket() {
      this.$router.push("/RedPacket");
    },
    GoToRedPacketAudit() {
      this.$router.push("/redpacketAudit");
    },
    GoToRedPacketStatistics() {
      this.$router.push("/RedPacketStatistics");
    },
    GoToErrRedPacket() {
      this.$router.push("/ErrRedPacket");
    },
    GoToBusinessPlanTrail() {
      this.$router.push("/businessPlanTrail");
    },
    routerPushTo(path) {
      this.$router.push(path);
    },
    toFangdongHouseModify() {
      this.$router.push({
        path: "/uploadFangdongHouseModify",
        query: {
          page: 1,
        },
      });
    },

    toGuwenHoutai() {
      this.$router.push("/guwenHoutaikb");
    },

    GoToRoutineTrail() {
      this.$router.push("/routineTrail");
    },
    getXHTalkList() {
      this.$open();
      this.$axios
        .get(this.$url_prefix + "xinghao/analyse/trend/create", {
          params: {
            start_date: this.ax.start_time,
            end_date: this.ax.end_time,
          },
        })
        .then((res) => {
          this.$close();
          this.xHTalkList = res.data.data;
          let nameList = {};
          let laberList = {};
          let geoList = {};
          for (let item of res.data.data) {
            if (nameList[item.name]) {
            } else {
              nameList[item.name] = {
                text: item.name,
                value: item.name,
              };
            }
            if (laberList[item.label]) {
            } else {
              laberList[item.label] = {
                text: item.label,
                value: item.label,
              };
            }
            if (geoList[item.geo_name]) {
            } else {
              geoList[item.geo_name] = {
                text: item.geo_name,
                value: item.geo_name,
              };
            }
          }
          this.xHTalkListFilters.name = Object.values(nameList);
          this.xHTalkListFilters.label = Object.values(laberList);
          this.xHTalkListFilters.geo_name = Object.values(geoList);
          console.log(res, "res");
        })
        .catch((err) => {
          this.$close();
        });
    },
    getXHGSList() {
      this.$open();
      this.$axios
        .get(this.$url_prefix + "xinghao/analyse/trend/water", {
          params: {
            start_date: this.ax.start_time,
            end_date: this.ax.end_time,
          },
        })
        .then((res) => {
          this.$close();
          this.xHGSList = res.data.data;
          let nameList = {};
          let geoList = {};
          for (let item of res.data.data) {
            if (nameList[item.name]) {
            } else {
              nameList[item.name] = {
                text: item.name,
                value: item.name,
              };
            }
            if (geoList[item.geo_name]) {
            } else {
              geoList[item.geo_name] = {
                text: item.geo_name,
                value: item.geo_name,
              };
            }
          }
          console.log(Object.values(nameList));
          this.xHGSListFilters.name = Object.values(nameList);
          this.xHGSListFilters.geo_name = Object.values(geoList);
          console.log(res, this.xHGSListFilters, "res");
        })
        .catch((err) => {
          this.$close();
        });
    },
    getGroupWater() {
      this.$open();
      this.$axios
        .get(this.$url_prefix + "xinghao/analyse/group/water", {
          params: {
            start_date: this.ax.start_time,
            end_date: this.ax.end_time,
          },
        })
        .then((res) => {
          this.$close();
          this.groupWaterList = res.data.data;
          let nameList = {};
          let geoList = {};
          for (let item of res.data.data) {
            if (nameList[item.name]) {
            } else {
              nameList[item.name] = {
                text: item.name,
                value: item.name,
              };
            }
            if (geoList[item.geo_name]) {
            } else {
              geoList[item.geo_name] = {
                text: item.geo_name,
                value: item.geo_name,
              };
            }
          }
          this.groupWaterFilter.name = Object.values(nameList);
          this.groupWaterFilter.geo_name = Object.values(geoList);
        })
        .catch((err) => {
          this.$close();
        });
    },
    getChannelWater() {
      this.$open();
      this.$axios
        .get(this.$url_prefix + "xinghao/analyse/channel/water", {
          params: {
            start_date: this.ax.start_time,
            end_date: this.ax.end_time,
          },
        })
        .then((res) => {
          this.$close();
          this.channelWaterList = res.data.data;
          let nameList = {};
          let geoList = {};
          for (let item of res.data.data) {
            if (nameList[item.name]) {
            } else {
              nameList[item.name] = {
                text: item.name,
                value: item.name,
              };
            }
            if (geoList[item.geo_name]) {
            } else {
              geoList[item.geo_name] = {
                text: item.geo_name,
                value: item.geo_name,
              };
            }
          }
          this.channelWaterFilter.name = Object.values(nameList);
          this.channelWaterFilter.geo_name = Object.values(geoList);
        })
        .catch((err) => {
          this.$close();
        });
    },
    searchPYQPerson(e) {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "moments/search", {
          params: {
            nickname: e.target.value,
          },
        })
        .then((res) => {
          that.$close();
          that.personArr = res.data.data;
          console.log(res, e.target.value, "res");
        })
        .catch(() => {
          that.$close();
        });
    },
    selcectCheWei() {
      this.$router.push("/PackPaces");
    },
    getAdTotal1() {
      this.listName = "adTotal1";
      this.$axios.get(this.$url_prefix + "getAdTotal").then((res) => {
        this.ad_List1 = res.data.data;
        console.log(res.data.data);
      });
    },
    getRedEvbag() {
      this.listName = "redEvbag";
      this.redList = "table";
      this.$axios
        .get(this.$url_prefix + "RedEnvelopeInfo")
        .then((res) => {
          console.log(res);
          this.redBagList = res.data.data;
        })
        .catch((error) => {});
    },
    changeRedBag(row) {
      this.redObj = row;
      this.redList = "inputRedChange";
    },
    saveRed(type) {
      let map = {
        新增: "giveRedEnvelope",
        修改: "updateRedEnvelope",
      };
      console.log(this.redObj);
      this.$axios
        .get(this.$url_prefix + map[type], {
          params: {
            data: JSON.stringify(this.redObj),
          },
        })
        .then((res) => {
          console.log(res, "resd");
          if (res.data.success) {
            this.listName = "";
            this.redList = "";
            this.$message("上传成功");
          } else {
            this.$message(res.data.msg);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message.error("上传失败");
        });
    },
    totalAd() {
      this.listName = "totalAdList";
      this.$open();
      if (this.checkDate1 && this.checkDate2) {
        this.$axios
          .get(this.$url_prefix + "getTotalList", {
            params: {
              current: this.checkDate2,
              before: this.checkDate1,
            },
          })
          .then((res) => {
            console.log(res);
            this.AdList = res.data.data;
            this.$close();
          })
          .catch(() => {
            this.$close();
          });
      } else {
        this.$axios
          .get(this.$url_prefix + "getTotalList")
          .then((res) => {
            console.log(res);
            this.AdList = res.data.data;
            this.$close();
          })
          .catch(() => {
            this.$close();
          });
      }
    },
    filterChange(selection) {
      for (let key in selection) {
        this.filter[key] = selection[key];
      }
    },
    //生成excel保存到本地
    generateExcel() {
      let filterList = this.zhList.filter((item) => {
        for (let k in this.filter) {
          let f = this.filter[k];
          let v = item[k];
          //排除

          if (f instanceof Array && f.length === 0) {
            continue;
          }
          if (v === undefined) continue;
          //特殊处理
          if (k === "details_tage") {
            if (f.length === 1) {
              if (!this.filterZhListStandards(f[0], item)) {
                // console.log("过滤掉：", k, f, v)
                return false;
              }
            }
          } else {
            let vs = v.split(" ");
            v = vs[vs.length - 1];
            if (f.indexOf(v) === -1) {
              // console.log("过滤掉：", k, f, v)
              return false;
            }
          }
        }
        return true;
      });
      console.log("专业完整度过滤后", filterList.length, "条");
      const data = filterList;
      let ths = ["区域", "楼盘名"];
      let outKeys = ["district", "real_estate_name"];
      let table = "<table>";
      //生成表头
      let row = "<tr>";
      for (let i = 0; i < ths.length; i++) {
        row += "<th>" + ths[i] + "</th>";
      }
      table += row + "</tr>";

      for (let i = 0; i < data.length; i++) {
        let td = "<tr>";
        for (let key of outKeys) {
          td += `<td>${data[i][key]}</td>`;
        }
        td += "</tr>";
        table += td;
      }
      let excelFile =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
        "xmlns:x='urn:schemas-microsoft-com:office:excel' xmlns='http://www.w3.org/TR/REC-html40'>";
      excelFile +=
        '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
      excelFile +=
        '<meta http-equiv="content-type" content="application/vnd.ms-excel';
      excelFile += '; charset=UTF-8">';
      excelFile += "<head>";
      excelFile += "<!--[if gte mso 9]>";
      excelFile += "<xml>";
      excelFile += "<x:ExcelWorkbook>";
      excelFile += "<x:ExcelWorksheets>";
      excelFile += "<x:ExcelWorksheet>";
      excelFile += "<x:Name>";
      excelFile += "sheet";
      excelFile += "</x:Name>";
      excelFile += "<x:WorksheetOptions>";
      excelFile += "<x:DisplayGridlines/>";
      excelFile += "</x:WorksheetOptions>";
      excelFile += "</x:ExcelWorksheet>";
      excelFile += "</x:ExcelWorksheets>";
      excelFile += "</x:ExcelWorkbook>";
      excelFile += "</xml>";
      excelFile += "<![endif]-->";
      excelFile += "</head>";
      excelFile += "<body>";
      excelFile += table;
      excelFile += "</body>";
      excelFile += "</html>";
      let uri =
        "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8,base64," +
        encodeURIComponent(excelFile);
      let link = document.createElement("a");
      link.href = uri;
      let download = `专业完整度_${data.length}条_${new Date()
        .toLocaleDateString()
        .replaceAll("/", "_")}.xls`;
      link.download = download;
      link.click();
    },
    toadd() {
      this.interest.list.push({});
    },
    perserve() {
      let that = this;
      let obj = that.interest;
      obj.update_time = obj.update_time.trim();
      if (!obj.update_time) {
        that.$message.error("请填写更新时间");
        return;
      }
      for (let i = 0; i < obj.list.length; i++) {
        let x = obj.list[i];
        for (let key in x) {
          x[key] = x[key].trim();
          if (!x[key]) {
            delete x[key];
          }
        }
        let len = Object.keys(x).length;
        if (len === 0) {
          obj.list.splice(i, 1);
          i--;
        } else if (len < 5) {
          that.$message.error("请填写完整");
          return;
        }
      }
      let param = {
        db: "WpBackupModel",
        model: "edit",
        item: JSON.stringify({
          id: "8ac6w0f28d",
          data: JSON.stringify(obj),
        }),
      };
      that.$axios
        .post(that.$url_prefix + "updateData", param)
        .then(function (res) {
          that.$message({
            type: "success",
            message: "保存成功",
          });
          that.listName = "";
        })
        .catch(function (res) {
          console.log("上传失败", res);
        });
    },
    tobank() {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "queryOneById", {
          params: {
            id: "8ac6w0f28d",
            db: "WpBackupModel",
          },
        })
        .then(function (res) {
          console.log("query backup res", res);
          let data = res.data.data.data;
          that.interest = JSON.parse(data);
          that.changeListName("interest");
        })
        .catch(function (res) {
          console.log("query backup fail", res);
        });
    },
    toEssayAdd() {
      this.essay.push("");
    },
    getAdTotal() {
      this.listName = "adTotal";
      this.$axios.get(this.$url_prefix + "queryAd").then((res) => {
        this.ad_List = res.data.data;
      });
    },
    essayPerserve() {
      let that = this;
      let city = this.$store.state.Counter.city;
      let essay = that.essay;
      essay = essay.map((x) => {
        return x && x.trim();
      });
      essay = essay.filter((x) => x);
      let idMap = {
        杭州: "1u32x4rkg54",
        苏州: "1g06s8a7goe",
      };
      let dbMap = {
        杭州: "WpBackupModel",
        苏州: "SzBackupModel",
      };
      let param = {
        db: dbMap[city],
        model: "edit",
        item: JSON.stringify({
          id: idMap[city],
          data: JSON.stringify(essay),
        }),
      };
      that.$axios
        .post(that.$url_prefix + "updateData", param)
        .then(function (res) {
          that.$message({
            type: "success",
            message: "保存成功",
          });
          that.listName = "";
        })
        .catch(function (res) {
          console.log("上传失败", res);
        });
    },
    toessay() {
      let that = this;
      let city = this.$store.state.Counter.city;
      that.listName = "essay";
      let idMap = {
        杭州: "1u32x4rkg54",
        苏州: "1g06s8a7goe",
      };
      let dbMap = {
        杭州: "WpBackupModel",
        苏州: "SzBackupModel",
      };
      that.$axios
        .get(that.$url_prefix + "queryOneById", {
          params: {
            id: idMap[city],
            db: dbMap[city],
          },
        })
        .then(function (res) {
          let data = res.data.data.data;
          that.essay = JSON.parse(data);
          console.log("query backup res", that.essay);
        })
        .catch(function (res) {
          console.log("query backup fail", res);
        });
    },
    init() {
      let that = this;
      if (!that.current) {
        that.$axios
          .get(that.$url_prefix + "getUserInfo")
          .then((res) => {
            let user = res.data.data;
            that.erp_id = user.id;
            sessionStorage.setItem("user_info_id", user.id);
            console.log(res);
            if (user) {
              let map = {
                运营: "operate",
                内容: "content",
                数据: "data",
                创新: "innovate",
                销售: "market",
                商务: "business",
                猩号: "xinghao",
              };
              console.log(user.group);
              let group = user.group.split("|");
              that.canViewPerformanceMonitor = group.includes("创新");
              let othertype = sessionStorage.getItem("user_other_type");
              if (user.userType && user.userType.includes("租房")) {
                that.subgroup = "租房";
              }
              if (othertype == "新房运营") {
                console.log("新房运营成员");
                that.seeSecoperate = false;
              } else if (othertype == "二手房运营") {
                console.log("二手运营成员");
                that.seeNewoperate = false;
              }
              console.log(1541352, group);
              if (group.length > 1) {
                let operations = [];
                group.forEach((item) => {
                  operations.push({
                    en: map[item],
                    ch: item + "小队",
                  });
                });
                if (group.includes("创新")) {
                  that.mainGroup = "创新";
                  that.current = map["创新"];
                  that.operation = that.current;
                  that.userType = user.userType || "";
                  console.log(that.operations, that.mainGroup, that.current);
                } else {
                  that.operations = operations;
                  that.mainGroup = "创新";
                  that.current = map[group[0]] || "";
                  that.operation = that.current;
                  that.userType = user.userType || "";
                  that.operations.push({
                    en: "experience",
                    ch: "经验池",
                  });
                  that.operations.push({
                    en: "feedback",
                    ch: "问题反馈",
                  });
                  console.log(that.operations, that.mainGroup, that.current);
                }
              } else {
                that.mainGroup = user.group;
                that.current = map[user.group] || "";
                that.operation = that.current;
                that.userType = user.userType || "";
                if (user.group != "创新") {
                  that.mainGroup = "创新";
                  that.operations = [
                    {
                      en: map[user.group],
                      ch: user.group,
                    },
                  ];
                  that.operations.push({
                    en: "experience",
                    ch: "经验池",
                  });
                  that.operations.push({
                    en: "feedback",
                    ch: "问题反馈",
                  });
                }
              }
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      }
    },

    houseTypeTools() {
      this.$router.push({ path: "apartment" });
    },
    getAdvanceList() {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "getAdvanceList")
        .then((res) => {
          that.advanceList = res.data.data;
          that.listName = "advanceList";
          console.log("get advance back", res);
        })
        .catch((err) => {
          console.log("get advance fail", err);
        });
    },

    szYuShouList() {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "szYuShouList")
        .then((res) => {
          that.yushouList = res.data.data;
          that.changeListName("yushouList");
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    matchAdvance() {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "matchAdvance")
        .then((res) => {
          that.$message({
            type: "success",
            message: "更新成功",
          });
        })
        .catch((err) => {
          that.$message.error("更新失败");
        });
    },
    matchOneAdvance(event, advanceId) {
      let that = this;
      let value = event.target.value || "";
      value = value.trim();
      if (!value || !advanceId) {
        that.$message.error("请填写楼盘id");
        return;
      }
      that.$axios
        .get(that.$url_prefix + "matchOneAdvance", {
          params: {
            advanceId: advanceId,
            estate_id: value,
          },
        })
        .then((res) => {
          that.$message({
            type: "success",
            message: "更新成功",
          });
          event.target.value = "";
          that.szYuShouList();
        })
        .catch((err) => {
          that.$message.error("更新失败");
        });
    },

    changeCurrent(label) {
      this.current = label;
      if (this.current == "zukeCenter") {
        this.$router.push({ path: "/zukeCenter" });
      }
      if (this.current == "zuwoCenter") {
        this.$router.push({ path: "/zuwoCenter" });
      }
      if (this.current == "experience") {
        this.$router.push({ path: "/addExperience" });
      }
    },
    toZuwoCenter() {
      this.$router.push({ path: "/zuwoCenter" });
    },

    //选择图片
    chooseImage(event) {
      let that = this;
      if (!this.imageName) {
        this.$message.error("先填写图片名称");
        return;
      }
      let option = {
        file: event.target.files[0],
        full_name: this.imageName,
      };
      console.log(event, "option");
      that
        .$uploadImage(option)
        .then(function (res) {
          if (!res) {
            that.$message.error("上传失败");
            return;
          }
          const imageSrc = res;
          const input = document.createElement("input");
          input.setAttribute("readonly", "readonly");
          document.body.appendChild(input);
          input.setAttribute("value", imageSrc);
          input.select();
          if (document.execCommand("copy")) {
            that.$message({
              type: "success",
              message: "上传成功, 链接已复制到剪切板",
            });
          } else {
            that.$message({
              type: "info",
              message: "上传成功, 请手动复制链接",
            });
          }
          that.$nextTick(() => {
            document.body.removeChild(input);
            that.imageSrc = imageSrc;
            that.imageName = "";
          });
        })
        .catch(function (res) {
          that.$message.error("上传失败");
        });
    },
    //选择图片
    chooseImage3(event) {
      let that = this;
      let option = {
        file: event.target.files[0],
        head_name: "chat",
      };
      that
        .$uploadImage(option)
        .then(function (res) {
          console.log("upload back", res);
          if (!res) {
            console.log("upload fail");
            return;
          }
          that.imageSrc = res;
          that.$previewRefresh();
        })
        .catch(function (res) {
          console.log("upload fail", res);
        });
    },
    //选择视频
    async chooseVideo(event) {
      let that = this;
      let option = {
        file: event.target.files[0],
        head_name: "chat",
        fileType: "video",
      };
      that.videoSrc = await that.$uploadImage(option);
      console.log("that.videoSrc", that.videoSrc);
      let str = "?x-oss-process=video/snapshot,t_2000,f_jpg,w_0,h_0,m_fast";
      let option1 = {
        dataURL: await that.$drawVideoCover(that.videoSrc + str),
        head_name: "chat",
      };
      that.videoCover = await that.$uploadImage(option1);
    },
    showEstateHits(type) {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getEstateHits", {
          params: {
            date: that.checkDate1,
            type: type,
          },
        })
        .then((res) => {
          that.estateHits = res.data.data;
          that.checkDate1 = res.data.date;
          that.listName = "estateHits";
          console.log("get Hits back", res);
          that.$close();
        })
        .catch((err) => {
          console.log("get Hits fail", err);
          that.$close();
        });
    },
    showMsgNum(type) {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getMsgNum", {
          params: {
            date: that.checkDate1,
            user_type: type,
          },
        })
        .then((res) => {
          that.msgNumList = res.data.data;
          that.checkDate1 = res.data.date;
          that.listName = "msgNumList";
          that.checkUserType = type;
          console.log("get Hits back", res);
          that.$close();
        })
        .catch((err) => {
          console.log("get Hits fail", err);
          that.$close();
        });
    },

    showEstateSort() {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "checkLocScore")
        .then((res) => {
          that.estateScore = res.data.data.slice(0, 50);
          that.listName = "estateScore";
          that.baseEstateScore = res.data.data;
          console.log("get Hits back", res);
        })
        .catch((err) => {
          console.log("get Hits fail", err);
        });
    },
    sortEstate(col) {
      let key = col.property.replace("loc_base.", "");
      if (key && key !== "real_estate_name") {
        this.baseEstateScore.sort((a, b) => {
          return b.loc_base[key] - a.loc_base[key];
        });
        this.estateScore = this.baseEstateScore.slice(0, 50);
      }
    },

    showPageHits(type) {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "getDayHits", {
          params: {
            type: type,
          },
        })
        .then((res) => {
          let list = res.data.data.map((x) => {
            let data = x.data;
            data.date = x.date;
            return data;
          });
          if (type == "首页") {
            that.homePageHits = list;
            that.listName = "homePageHits";
          } else if (type == "楼盘页面") {
            that.estatePageHits = list;
            that.listName = "estatePageHits";
          } else if (type == "二手房首页") {
            that.twoHomePageHits = list;
            that.secKeys = res.data.keys;
            that.secKeys.unshift("date");
            that.listName = "twoHomePageHits";
          } else if (type == "二手楼盘首页") {
            that.twoEstatePageHits = list;
            that.secKeys = res.data.keys;
            that.secKeys.unshift("date");
            that.listName = "twoEstatePageHits";
          }
        })
        .catch((err) => {
          console.log("get Hits fail", err);
        });
    },

    talkNum() {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "getTalkNum")
        .then((res) => {
          console.log("get talk back", res);
          that.talkTemp = res.data.data;
          that.listName = "talkTemp";
        })
        .catch((err) => {
          console.log("get talk fail", err);
        });
    },

    beforeClick() {
      let that = this;
      that.pageNum -= 1;
      that.showNews();
    },
    nextClick() {
      let that = this;
      that.pageNum += 1;
      that.showNews();
    },
    showNews() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getGovNews", {
          params: {
            pageNum: that.pageNum,
          },
        })
        .then((res) => {
          console.log("getGovNews", res);
          that.news = res.data.data;
          that.listName = "news";
          that.$close();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },
    searchGovNews() {
      let that = this;
      if (!that.searchText) {
        that.pageNum = 0;
        that.showNews();
        return;
      }
      that.$open();
      that.$axios
        .get(that.$url_prefix + "searchGovNews", {
          params: {
            searchText: that.searchText,
          },
        })
        .then((res) => {
          console.log("searchGovNews", res);
          if (res.data.msg) {
            that.$message.error(res.data.msg);
            that.pageNum = 0;
            that.showNews();
          } else {
            that.news = res.data.data;
          }
          that.listName = "news";
          that.$close();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },

    getEstateRate() {
      this.$router.push("/recentLottery");
      // let that = this;
      // that.$open();
      // that.$axios
      //   .get(that.$url_prefix + "getEstateRate")
      //   .then((res) => {
      //     that.estateRateList = res.data.data;
      //     console.log("estateRateList", that.estateRateList);
      //     that.listName = "estateRate";
      //     that.$close();
      //   })
      //   .catch((err) => {
      //     that.$close();
      //     console.log("err", err);
      //   });
    },

    showSalerStatus() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "checkSales", {
          params: {
            who: that.usUser,
          },
        })
        .then(function (res) {
          that.salerStatus = res.data.data;
          that.usUserList = res.data.usUserList || [];
          console.log("salerStatus", that.salerStatus);
          that.listName = "salerStatus";
          that.$close();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },
    getEstateGS(state) {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getRealByState", {
          params: {
            state: state,
            need: "后台",
          },
        })
        .then((res) => {
          console.log(state, res.data);
          let realInfoList = res.data.data;
          for (let i = 0; i < realInfoList.length; i++) {
            let one = realInfoList[i];
            let obj = {
              real_estate_name: one.real_estate_name,
            };
            if (one.label2) {
              let label2 = JSON.parse(one.label2);
              if (label2.area_label) {
                obj.area = label2.area_label.split("|").join("\n");
              }
            }
            let sell = one.currentSell;
            if (sell) {
              let piece = (sell && sell.piece) || [];
              obj.piece = piece
                .filter((x) => x.ing)
                .map((x) => x.type + (x.price1 || x.price))
                .join("\n");

              if (sell.rate && sell.rate.house_no) {
                obj["no_rate"] =
                  Math.round(
                    (sell.rate.house_no / sell.rate.house_total) * 100
                  ) + "%";
              }

              let register = sell.date && sell.date.register;
              if (register && register.start_date) {
                obj["regDate"] = register.start_date + "到" + register.end_date;
              }

              if (sell.info && sell.info.capital) {
                obj.capital =
                  (sell.info.freeze ? "冻资：" : "验资：") + sell.info.capital;
              }

              obj.rate_total = sell.rate_total;
              obj.house_total = sell.house_total;
              if (sell.info) {
                obj.building = sell.info.building;
                obj.square = sell.info.square;
              }
            }
            realInfoList[i] = obj;
          }
          that.realInfoList = realInfoList;
          that.listName = state === "正在公示" ? "gsList" : "djList";
          that.$close();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },
    getEstateText(state) {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "getEstateText", {
          params: {
            state: state,
          },
        })
        .then((res) => {
          let value = res.data.data;
          if (value) {
            const input = document.createElement("textarea");
            input.setAttribute("readonly", "readonly");
            document.body.appendChild(input);
            input.innerHTML = value;
            input.select();
            if (document.execCommand("copy")) {
              that.$message({
                type: "success",
                message: "内容已复制到剪切板，去粘贴吧",
              });
            } else {
              that.$message.error("复制内容失败，请重试");
            }
            that.$nextTick(() => {
              document.body.removeChild(input);
            });
          } else {
            that.$message.error("无内容，请确认");
          }
        })
        .catch((err) => {
          that.$message.error("网络异常，请联系管理员");
          console.log("err", err);
        });
    },

    // 更新所有户型的计算结果
    updateAll() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "queryApartmentListData")
        .then(function (res) {
          console.log("查询返回", res);
          that.$close();
        })
        .catch(function (res) {
          console.log("查询失败", res);
          that.$close();
        });
    },

    getVisitData() {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "analysisVisit", {
          params: {
            date: that.checkDate2,
          },
        })
        .then(function (res) {
          that.visitData = res.data.data;
          that.baseVisitData = res.data.data;
          that.listName = "visitData";
          console.log("visitData", res.data.data);
        });

      let data = {
        dataContent: "WpRealEstateModel",
      };
      that.$axios
        .get(that.$url_prefix + "getDataByModel", {
          params: data,
        })
        .then(function (res) {
          console.log("WpRealEstateModel", res.data.data);
          let tempList = res.data.data;
          that.dblist = tempList;
          that.baseList = JSON.parse(JSON.stringify(tempList));
          that.showdblist = [];
        })
        .catch(function (res) {
          console.log(res);
        });
    },
    sortVisit(col) {
      let key = col.property;
      if (key && key !== "page_name" && key !== "share_path") {
        this.baseVisitData.sort((a, b) => {
          return b[key] - a[key];
        });
        this.visitData = this.baseVisitData;
      }
    },
    searchReal() {
      let filter = this.searchText;
      console.log("filter", filter);
      if (filter === "" || filter === null) {
        this.showdblist = [];
        this.baseList = [];
      } else {
        this.showdblist = [];
        this.baseList = [];
        for (let index in this.dblist) {
          for (let value in this.dblist[index]) {
            if ((this.dblist[index][value] + " ").indexOf(filter) > -1) {
              this.baseList.push(
                JSON.parse(JSON.stringify(this.dblist[index]))
              );
              break;
            }
          }
        }
        this.showdblist = JSON.parse(JSON.stringify(this.baseList)).slice(0, 3);
        console.log("showdblist", this.showdblist);
      }
    },
    //页面分享路径
    findFX(col) {
      console.log("col", col);
      this.resultName = col.page_name;
      this.showRealSearch = false;
      this.resultStr = col.share_path;
      let nameList = [
        "楼盘",
        "个人空间",
        "户型评测列表",
        "某个户型评测",
        "选日楼价",
        "图库",
        "VR全景展示",
      ];
      if (nameList.indexOf(this.resultName) > -1) {
        this.showRealSearch = true;
      }
    },
    //生成路径
    getShareLoad() {
      let nameList = [
        "楼盘",
        "个人空间",
        "户型评测列表",
        "某个户型评测",
        "选日楼价",
        "图库",
        "VR全景展示",
        "公示/登记/摇号/预计",
        "买房/讨论/土拍/学区",
      ];
      let name = this.resultName;
      let id = this.valueRealId;
      console.log("name", name);
      if (nameList.indexOf(name) > -1) {
        if (name === "楼盘") {
          this.resultStr = "/pages/qwa/index?R=" + id;
        } else if (name === "个人空间") {
          this.resultStr =
            "/pages/cards/index?userId=" +
            this.userId +
            "&name_id=" +
            id +
            "&from=名片分享&selfPage=1";
        } else if (name === "户型评测列表") {
          this.resultStr = "/pages/qwa/index?QTR=" + id + "&R=" + id;
        } else if (name === "某个户型评测") {
          this.resultStr =
            '/pages/qwa/index?realIds={"real_estate_id":"' +
            id +
            '","imgName2":"' +
            this.imgName2 +
            '"}&R=' +
            id;
        } else if (name === "选日楼价") {
          let col = "";
          if (this.colType === "选房") {
            col = "col1";
          } else if (this.colType === "日照") {
            col = "col2";
          } else if (this.colType === "一房一价") {
            col = "col3";
          } else {
            col = this.colType === "楼栋" ? "col4" : "col5";
          }
          this.resultStr =
            '/pages/qwa/index?build={"id":"' +
            id +
            '","LM":"' +
            col +
            '"}&L=col&R=' +
            id;
        } else if (name === "图库") {
          this.resultStr =
            "/pages/qwa/index?image_R=" +
            id +
            "&imgLanmu=区位图|区位图&R=" +
            id +
            "&shareType=";
        } else if (name === "VR全景展示") {
          this.resultStr = "/pages/qwa/index?ar=" + id + "&R=" + id + "";
        } else if (name === "公示/登记/摇号/预计") {
          this.resultStr =
            '/pages/index/index?detailLabel={"label":"' +
            this.shouyeType +
            '","from":"首页标签"}';
        } else if (name === "买房/讨论/土拍/学区") {
          this.resultStr = "/pages/index/index?barlanmu=" + this.tabbarStr;
        }
        console.log("this.resultStr", this.resultStr);
      }
    },

    getCheckSaleAd1() {
      let that = this;
      console.log("that.checkDate", that.checkDate);
      if (that.checkDate) {
        that.$axios
          .get(that.$url_prefix + "analysisSalePay", {
            params: {
              date: that.checkDate,
            },
          })
          .then(function (res) {
            if (res.data.data.length == 0) {
              that.$message.error("没有记录");
            }
            that.checkSaleAd1 = res.data.data;
            that.listName = "checkSaleAd1";
            console.log("checkSaleAd", res.data.data);
          });
      } else {
        that.$message.error("请选择查看的月份");
      }
    },
    searchSaleName() {
      let that = this;
      if (that.search_word) {
        that.$axios
          .get(that.$url_prefix + "searchSale", {
            params: {
              search: that.search_word,
            },
          })
          .then((res) => {
            that.salesmanList = res.data.data;
          });
      }
    },
    chooseSaleName(search) {
      let that = this;
      if (search) {
        that.$axios
          .get(that.$url_prefix + "getSalesName", {
            params: {
              search: search,
            },
          })
          .then((res) => {
            that.allSaleName = res.data.data;
          });
      }
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        let prop = column.property;
        if (prop == "time") {
          sums[index] = "合计";
        } else if (prop == "money") {
          let num = 0;
          data.forEach((one) => {
            num += one.money;
          });
          sums[index] = num;
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },

    checkEstateImageNum() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "checkEstateImageNum")
        .then(function (res) {
          that.estateImageNum = res.data.data;
          that.listName = "estateImageNum";
          that.filterDistrits = that.areaArr.map((x) => {
            return {
              text: x,
              value: x,
            };
          });
          that.$close();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },
    sortImageNum(col) {
      let key = col.property;
      if (key && key !== "real_estate_name") {
        if (!this.imageNumSortMap[key]) {
          this.estateImageNum.sort((a, b) => {
            return b[key] - a[key];
          });
        } else {
          this.estateImageNum.sort((a, b) => {
            return a[key] - b[key];
          });
        }
        this.imageNumSortMap[key] = !this.imageNumSortMap[key];
      }
    },
    essayGetGongZong() {
      let that = this;
      let city = "杭州";
      let essay = that.essay;
      essay = essay.map((x) => {
        return x && x.trim();
      });
      let idMap = {
        杭州: "2ev0o3b9pmt",
      };
      let dbMap = {
        杭州: "WpBackupModel",
      };
      let param = {
        db: dbMap[city],
        model: "edit",
        item: JSON.stringify({
          id: idMap[city],
          data: JSON.stringify(essay),
        }),
      };
      that.$axios
        .post(that.$url_prefix + "updateData", param)
        .then(function (res) {
          that.$message({
            type: "success",
            message: "保存成功",
          });
          that.listName = "";
        })
        .catch(function (res) {
          console.log("上传失败", res);
        });
    },
    sortImageNum2(col) {
      let key = col.property;
      if (key == "all_tage" || key == "xs" || key == "estate") {
        if (!this.imageNumSortMap2[key]) {
          if (key == "all_tage" || key == "estate") {
            this.zhList.sort((a, b) => {
              return parseInt(b[key]) - parseInt(a[key]);
            });
          } else {
            this.zhList.sort((a, b) => {
              return a.create_time.localeCompare(b.create_time);
            });
          }
        } else {
          if (key == "all_tage" || key == "estate") {
            this.zhList.sort((a, b) => {
              return parseInt(a[key]) - parseInt(b[key]);
            });
          } else {
            this.zhList.sort((a, b) => {
              return b.create_time.localeCompare(a.create_time);
            });
          }
        }
        this.imageNumSortMap2[key] = !this.imageNumSortMap2[key];
      }
    },

    getShareTop(type, area, scoreType) {
      let that = this;
      that.showSale = true;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getShareTop", {
          params: {
            date: that.checkDate1,
            type: type,
            area: area,
            scoreType: scoreType,
          },
        })
        .then(function (res) {
          console.log(res);
          that.shareTop = res.data.data;
          that.checkDate1 = res.data.date;
          let obj = {};
          for (var i = 0; i < that.shareTop.length; i++) {
            if (!obj[that.shareTop[i].district]) {
              obj[that.shareTop[i].district] = 1;
              that.district.push({
                text: that.shareTop[i].district,
                value: that.shareTop[i].district,
              });
            }
          }
          console.log(obj);
          console.log(that.district);
          that.listName =
            type === "群聊违规"
              ? "shareTop3"
              : type === "销售"
              ? "shareTop"
              : "shareTop2";
          that.$close();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },

    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },

    getShareWeekTop() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getShareWeekTop")
        .then(function (res) {
          that.shareWeekTop = res.data.data;
          console.log("shareWeekTop", that.shareWeekTop);
          that.listName = "shareWeekTop";
          that.$close();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },

    getEssayData() {
      let that = this;
      that.$axios.get(that.$url_prefix + "getSharePublic").then(function (res) {
        that.sharePublic = res.data.data;
        that.changeListName("sharePublic");
      });
    },

    getQlwgRecord() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getQlwgRecord", {
          params: {
            date: that.checkDate1,
          },
        })
        .then((res) => {
          console.log("getMoments", res.data.data);
          that.shareTop = res.data.data;
          that.listName = "shareTop3";
          that.$close();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },

    getMoments() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getMoments", {})
        .then((res) => {
          console.log("getMoments", res);
          that.$close();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },

    getWkMessage() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getWkMessage", {
          params: {
            dateType: that.dateType,
          },
        })
        .then((res) => {
          console.log("getWkMessage", res.data);
          that.messList = res.data.data;
          that.listName = "messList";
          that.$close();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },

    findFried() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "findFried")
        .then((res) => {
          console.log("res", res.data);
          that.friedList = res.data.data;
          that.listName = "friedList";
          that.$close();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },

    // getGiveTime() {
    //   let that = this
    //   that.$axios.get(that.$url_prefix + 'getDeliveryTime').then(function(res) {
    //     console.log(res)
    //   })
    // },

    addNewChat() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "addNewChat", {
          params: {
            title: that.content,
            bind: that.chooseList[0].id,
          },
        })
        .then((res) => {
          console.log("res", res.data);
          that.$close();
          if (!res.data.success) {
            that.$message({
              type: "warning",
              message: "创建失败" + res.data.msg,
            });
            return;
          }
          that.$message({
            type: "success",
            message: "创建成功",
          });
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
          that.$message({
            type: "warning",
            message: "创建失败" + err,
          });
        });
    },

    showQun(way) {
      this.listName = "qunList";
      this.sendWay = way;
    },
    addQun(data) {
      let that = this;
      if (that.sendWay === "假用户消息" || that.sendWay === "创建小群") {
        that.chooseList = [data];
      } else {
        if (that.chooseList.findIndex((x) => x.id == data.id) == -1) {
          that.chooseList.push(data);
        }
      }
    },
    deletOne(index) {
      this.chooseList.splice(index, 1);
    },
    searchQun(e) {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "searchQun", {
          params: {
            type: that.searchType,
            search: that.searchName,
            id: e,
          },
        })
        .then((res) => {
          console.log("searchQun", res.data);
          that.qunList = res.data.data;
          that.$close();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },
    sendQunMessage(type) {
      let that = this;
      let range = that.chooseList.map((x) => {
        return (x = x.id);
      });
      if (that.sendWay === "假用户消息") {
        if (!range.length) {
          that.$message({
            type: "warning",
            message: "请选择楼盘/销售",
          });
          return;
        }
      }
      if (!range.length) {
        let temp = {
          楼盘群: 3,
          板块群: 4,
          总价群: 5,
          达人群: 6,
          区域群: 7,
          话题群: 15,
          专题群: 10,
          所有群: "all",
        };
        range = [temp[that.searchType]];
      }
      that.$open();
      let videoparam = JSON.stringify({
        video: that.videoSrc,
        backImg: that.videoCover,
      });
      let obj = {
        range: range,
        content:
          type == 1 ? that.content : type == 2 ? that.imageSrc : videoparam,
        sendWay: that.sendWay,
        type: type,
        searchType: that.searchType,
      };
      if (that.sendWay === "假用户消息" && that.suiji === "当前用户") {
        obj.sjUser = that.sjUser;
      }
      if (
        that.sendWay === "假用户消息" &&
        that.searchType == "话题群" &&
        that.suiji === "发帖用户"
      ) {
        obj.sjUser = that.chooseList[0].sender;
      }
      that.$axios
        .post(that.$url_prefix + "sendQunMessage", obj)
        .then((res) => {
          that.$close();
          if (!res.data.success) {
            that.$message({
              type: "warning",
              message: "发送失败 请检查",
            });
            that.$close();
            return;
          }
          that.sjUser = res.data.data || "";
          that.$message({
            type: "success",
            message: "发送成功",
          });
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },
    showArticleShare(id, title) {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "showArticleShare", {
          params: {
            article_id: id,
          },
        })
        .then((res) => {
          console.log("res", res);
          that.articleShares = res.data.data;
          that.listName = "articleShares";
          that.articleTitle = title;
          if (that.articleShares.length == 0) {
            that.$message.error("没有分享的人");
          }
        });
    },

    onPageClick(temp, info) {
      let that = this;
      let path;
      if (
        [
          "入驻审核",
          "中介审核",
          "头像审核",
          "房源审核",
          "举报审核",
          "聊天举报",
          "专家入驻",
          "业主群审核",
          "拿证审核",
          "群聊申诉",
          "APP进群审核",
          "APP建群审核",
          "APP举报审核",
          "APP申诉",
          "销售大群审核",
          "APP反馈",
        ].includes(temp)
      ) {
        let item = {
          from: temp,
          info: info,
        };
        let routeData = that.$router.resolve({
          path: "sale",
          query: item,
        });
        window.open(routeData.href, "_self");
      } else if (temp === "最近留言" || temp === "留言举报") {
        let routeData = that.$router.resolve({
          path: "drawWarn",
          query: {
            type: temp,
          },
        });
        window.open(routeData.href, "_self");
      } else if (temp === "问答管理") {
        path = "/question";
      } else if (temp === "楼盘集合") {
        path = "/RealTable";
      } else if (temp === "楼市提问") {
        path = "/CheckAsk";
      } else if (temp === "内容运营") {
        path = "/MeiTi";
      } else if (temp === "资料审核") {
        path = "/verify";
      } else if (temp === "旅游地图") {
        path = "/tourlistMap";
      } else if (temp === "小区入驻审核") {
        path = "/communityCheck";
      } else if (temp === "小区区长设置") {
        path = "/districtMayor";
      } else if (temp === "定位数据") {
        path = "/communityLocationData";
      } else if (temp === "投诉列表") {
        path = "/communityComplaintList";
      } else if (temp === "新房图片审核") {
        path = "/newHousePic";
      } else if (temp === "给顾问加分") {
        path = "/check";
      } else if (temp === "追踪预计开盘") {
        path = "/tEOpening";
      } else if (temp === "楼盘评论数") {
        path = "/proComments";
      } else if (temp === "客源管理") {
        path = "/Customer";
      } else if (temp === "自动问答") {
        path = "/AutoReply";
      } else if (temp === "评价审核") {
        path = "/CheckVoice";
      } else if (["猩号灌水", "猩号炒频道", "猩号炒群"].includes(temp)) {
        path = "/xHGuanS";
      } else if (temp === "分配客户") {
        path = "/CustomerDistribution";
      } else if (temp === "分配客户审核") {
        path = "/assignCustomerReviews";
      } else if (temp === "任务管理") {
        path = "/Task";
      } else if (temp === "发空间说") {
        path = "/XHTrend";
      } else if (temp === "猩号APP数据") {
        path = "/xHAppData";
      } else if (temp === "猩号空间管理") {
        path = "/ChatGroup";
      } else if (temp === "需求中心") {
        path = "/requirement";
      } else if (temp === "频道管理") {
        path = "/channel";
      } else if (temp === "新盘点击量排名") {
        path = "/estateClick";
      } else if (temp === "顾问回答审核加分") {
        path = "/addScore";
      } else if (temp === "微控平台登录通道1" || temp === "微控平台登录通道2") {
        path = "/loginWay1";
      } else if (temp === "置业顾问分享话题的人数和排名") {
        path = "/sharePAS";
      } else if (temp === "朋友圈加分失败" || temp === "朋友圈加分") {
        path = "/addScoreFail";
      } else if (temp === "查看朋友圈邀请") {
        path = "/inviteFri";
      } else if (
        temp === "搜索某人朋友圈" ||
        temp === "朋友圈统计" ||
        temp === "发布朋友圈"
      ) {
        path = "/PYQ";
      } else if (
        temp === "客服评价" ||
        temp === "搜索解禁" ||
        temp === "话题文章置顶" ||
        temp === "回复楼盘提问" ||
        temp === "群聊灌水"
      ) {
        path = "/cF";
      } else if (temp === "建议反馈") {
        path = "/judgeReview";
      } else if (temp === "内容审核") {
        path = "/TrendCheck";
      } else if (temp === "留言审核") {
        path = "/TalkCheck";
      } else if (temp === "运营助手") {
        path = "/OperationsAssistant";
      } else if (temp === "楼盘管理") {
        path = "/estate-manager";
      } else if (temp === "智能评价" || temp === "智能标题") {
        path = "/intelligenceComment";
      } else if (temp === "智能文章") {
        path = "/intelligenceArticle";
      } else if (temp === "上传楼盘详情审核") {
        that.$router.push({
          path: "/propertyReview",
          query: { type: "新房" },
        });
      } else if (temp === "新增配套审核") {
        path = "/location";
      } else if (temp === "拆迁地图数据") {
        path = "/demolitionMapData";
      } else if (temp === "楼盘评测视频") {
        path = "/estateEvaluationVideo";
      } else if (temp === "楼盘评测文章") {
        path = "/estateReviewArticle";
      } else if (temp === "公众号管理") {
        that.$router.push({
          path: "/shanghai/publicAccount",
          query: { city: "杭州" },
        });
      } else if (temp == "导入小程序数据") {
        path = "/MiniProgramData";
      } else if (temp == "行情评论") {
        path = "/marketComment";
      } else if (temp == "置业顾问管理") {
        that.$router.push({
          path: "/shanghai/guwenManage",
          query: { from: "数据" },
        });
      } else if (temp === "智能话题管理") {
        that.$router.push({
          path: "/topicRecord",
        });
      } else if (temp === "看房笔记数据看板") {
        that.$router.push({
          path: "/noteInfo",
        });
      } else if (temp === "补贴楼盘数据看板") {
        that.$router.push({
          path: "/millionInfo",
        });
      } else if (temp === "成交数据") {
        this.$router.push({
          path: "/estateDealData",
        });
      }
      if (path) {
        let routeData;
        if (path !== "/requirement") {
          routeData = that.$router.resolve({
            path: path,
            query: {
              type: temp,
            },
          });
        } else {
          routeData = that.$router.resolve({
            path: path,
          });
        }
        window.open(routeData.href, "_self");
      }
    },

    judgeCellColor(param) {
      let { row, column, rowIndex, columnIndex } = param;
      let colorList = ["#ffffff", "#eeeeee"];
      let obj = {
        "background-color": colorList[rowIndex % 2],
        color: "black",
      };
      let border = "1px solid #cccccc";
      if (columnIndex == 0) {
        obj["border-left"] = border;
      }
      if (Array.isArray(param.row)) {
        obj["border-top"] = border;
      }
      obj["border-right"] = border;
      obj["border-bottom"] = border;
      return obj;
    },
    headerrow() {
      let obj = {
        "background-color": "#FFCC00",
        color: "black",
      };
      return obj;
    },
    delAsk(index) {
      let that = this;
      let item = that.salesList[index];
      let obj = {
        id: item.id,
        status: "DELETE",
      };
      let param = {
        db: "WpVoiceModel",
        model: "edit",
        item: JSON.stringify(obj),
      };
      that.$axios
        .post(that.$url_prefix + "updateData", param)
        .then((res) => {
          that.salesList.splice(index, 1);
          that.$message({
            type: "success",
            message: "删除问题成功",
          });
        })
        .catch((err) => {
          console.log("删除问题失败", err);
        });
    },
    topicChoose() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getTopic")
        .then((res) => {
          that.checkList = res.data.data;
          console.log("checkList", that.checkList);
          that.listName = "topicList";
          that.$close();
          if (that.checkList.length === 0) {
            that.$message.error("没有待审核的话题");
          }
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },
    pass(item) {
      console.log("pass", item);
      let that = this;
      let obj = {
        id: item.id,
        user_id: item.user_id,
        words: item.words,
        images: item.images,
        lnglat: item.lnglat || "",
        status: "IN",
      };
      let param = {
        db: "WpTopicModel",
        model: "edit",
        item: JSON.stringify(obj),
      };
      that.$axios
        .post(that.$url_prefix + "updateData", param)
        .then(function (res) {
          console.log("pass back");
          that.$axios
            .get(that.$url_prefix + "addContributeScore", {
              params: {
                user_id: item.user_id,
                add_score: 100,
                type: "gx",
              },
            })
            .then(function (obj) {
              console.log("加积分返回", obj);
            })
            .catch(function (obj) {
              console.log("加积分失败", obj);
            });
          that.sendMessage(item.user_id, "topicPass");
        })
        .catch(function (res) {
          console.log(res);
        });
    },
    refuse(item) {
      console.log("refuse", item);
      let that = this;
      let obj = {
        id: item.id,
        status: "OUT",
        message: item.note || "",
      };
      let param = {
        db: "WpTopicModel",
        model: "edit",
        item: JSON.stringify(obj),
      };
      that.$axios
        .post(that.$url_prefix + "updateData", param)
        .then(function (res) {
          console.log("refuse back");
          that.sendMessage(item.user_id, "topicRefuse", item.note);
        })
        .catch(function (res) {
          console.log(res);
        });
    },
    sendMessage(user_id, message_type, reason) {
      let that = this;
      that.$axios
        .post(that.$url_prefix + "sendTemplateMessage", {
          user_id: user_id,
          message_type: message_type,
          refuse_reason: reason,
        })
        .then(function (res) {
          console.log("发送通知返回", res);
          that.topicChoose();
        })
        .catch(function (res) {
          console.log("发送通知失败", res);
        });
    },
    searchGsReal() {
      let that = this;
      that.$axios.get(that.$url_prefix + "searchGsReal").then((res) => {
        console.log("GsReal", res.data.data);
        that.GsList = res.data.data;
        that.changeListName("GsList");
      });
    },

    // 解禁
    unUserStatus() {
      let that = this;
      that.$axios.get(that.$url_prefix + "unUserStatus").then((res) => {
        console.log("data", res.data.data);
        that.userList = res.data.data;
        that.listName = "userList";
      });
    },
    unStatus(data) {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "unStatus", {
          params: {
            id: data.id,
          },
        })
        .then((res) => {
          console.log("success");
          that.unUserStatus();
        });
    },

    // 楼盘预约
    getYuyueInfo() {
      let that = this;
      that.$axios.get(that.$url_prefix + "getYuyueInfo").then((res) => {
        console.log("data", res.data.data);
        that.yuyueList = res.data.data;
        that.listName = "yuyueList";
      });
    },

    // 销售动态
    noNewsOrImages(type) {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "noNewsOrImages", {
          params: {
            type: type || "",
          },
        })
        .then((res) => {
          console.log("data", res.data.data);
          that.newsList = res.data.data;
          that.listName = "newsList";
        });
    },
    // 每天新增
    addNews(type) {
      let that = this;
      that.$axios.get(that.$url_prefix + "addNews").then((res) => {
        console.log("data", res.data.data);
        that.addList = res.data.data;
        that.listName = "addList";
      });
    },
    delImage2() {
      // 删除
      this.imageSrc = "";
    },
    delVideo() {
      this.videoSrc = "";
      this.videoCover = "";
    },

    getSalePut() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getSalePut")
        .then((res) => {
          console.log("res", res.data);
          that.salePut = res.data.data;
          that.listName = "salePut";
          that.$close();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },

    getAreaShare() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getAreaShare")
        .then((res) => {
          that.inviteList = res.data.data;
          let templist = [];
          that.inviteList.forEach((x) => {
            for (let key in x.temp) {
              if (!templist.includes(key)) {
                templist.push(key);
              }
            }
          });
          that.listName = "inviteList";
          that.inviteListUsers = templist;
          that.$close();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },

    getInvite() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "seekSomeInvites")
        .then((res) => {
          that.inviteList = res.data.data;
          let templist = [];
          that.inviteList.forEach((x) => {
            for (let key in x.temp) {
              if (!templist.includes(key)) {
                templist.push(key);
              }
            }
          });
          that.listName = "inviteList";
          that.inviteListUsers = templist;
          that.$close();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },

    getSzInvite() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "ourShareDetail", {
          params: {
            date: that.checkDate1,
          },
        })
        .then((res) => {
          console.log("ourShareDetail", res.data);
          that.szInviteList = res.data.data;
          that.listName = "szInviteList";
          that.$close();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },

    getSunHouse(purpose) {
      let that = this;
      that.$open();
      if (purpose === "详情") {
        that.$axios
          .get(that.$url_prefix + "getSunHouse", {
            params: {
              type: that.type,
              date: that.checkDate1,
              value: that.value,
              purpose: purpose,
            },
          })
          .then((res) => {
            console.log("res", res.data);
            that.sunHouse = res.data.data;
            that.changeListName("sunHouse");
            that.uploadNum = res.data.data.length;
            that.$close();
          })
          .catch((err) => {
            that.$close();
            console.log("err", err);
          });
      } else if (purpose === "统计") {
        that.$axios
          .get(that.$url_prefix + "getSunHouse", {
            params: {
              type: that.type,
              value: that.value,
              start: that.value1[0],
              end: that.value1[1],
              purpose: purpose,
            },
          })
          .then((res) => {
            console.log("res", res.data);
            that.changeListName("sunHouse");
            that.uploadNum = res.data.data;
            that.$close();
          })
          .catch((err) => {
            that.$close();
            console.log("err", err);
            console.log("value1", that.value1);
          });
      }
    },

    examine(row, type) {
      let item = {
        id: row.id,
        type: type,
      };
      this.$router.push({
        name: "saleInfo",
        params: item,
      });
    },

    toEdit(row) {
      let item = {
        id: row.id,
        current: "img",
      };
      this.$router.push({
        name: "real-estate",
        params: item,
      });
    },

    getEstateZJ() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getPriceReal", {
          params: {
            search: that.priceType,
            status: that.realStatus,
          },
        })
        .then((res) => {
          let pList = res.data.data;
          for (let i = 0; i < pList.length; i++) {
            let one = pList[i];
            if (one.piece) {
              let str = "";
              for (let j = 0; j < one.piece.length; j++) {
                if (str) {
                  str = str + "\n";
                }
                str = str + one.piece[j].type + one.piece[j].price;
              }
              one["priceStr"] = str;
            }
            one.label2 = JSON.parse(one.label2);
            one["subway"] =
              (one.label2.station_dis || "") + (one.label2.subway_num || "");
          }
          that.priceRealList = pList;
          console.log("pList", pList);
          that.listName = "priceReal";
          that.$close();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },

    getyuji() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getYujiReal")
        .then((res) => {
          that.listName = "yujiExcel";
          console.log("res.data", res.data);
          let data = res.data.data || [];
          if (data.length > 0) {
            that.yjMonth = data[0];
          }
          that.monthList = data;
          that.$close();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },
    yujiExcel(sale) {
      let that = this;
      if (!that.yjMonth) {
        return;
      }
      that.$open();
      that.$axios
        .get(that.$url_prefix + "yujiExcel", {
          params: {
            month: that.yjMonth,
            sale: sale || "",
          },
        })
        .then((res) => {
          console.log("res", res.data);
          that.needList = res.data.data || [];
          if (sale == "1") {
            that.saleList = res.data.data || [];
          } else {
            let url = that.$base_url + res.data.url;
            console.log("url", url);
            that.yuJiUrl = url;
            window.open(url);
          }
          that.$close();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },

    getHzTitle() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "searchHzTitle")
        .then((res) => {
          console.log("res", res.data);
          that.HzTitle = res.data.data;
          that.listName = "HzTitle";
          that.$close();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },

    getZJRecent() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getZJRecent")
        .then((res) => {
          let pList = res.data.data;
          that.ZJReal = pList;
          console.log("pList", pList);
          that.listName = "ZJReal";
          that.$close();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },

    getOldPrice() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getOldPrice", {})
        .then((res) => {
          let pList = res.data.data;
          that.oldPriceList = pList;
          console.log("pList", pList);
          that.listName = "oldPriceList";
          that.$close();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },

    getApartList() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getApartList", {})
        .then((res) => {
          let data = res.data.data;
          console.log("data", data);
          that.apartList = data;
          that.listName = "apartList";
          that.$close();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },

    getHouse() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getHouse", {})
        .then((res) => {
          let pList = res.data.data;
          that.houseList = pList;
          that.houseList.forEach((item) => {
            if (item.base_info) item.apart = JSON.parse(item.base_info).apart;
          });
          console.log("pList", pList);
          that.listName = "houseList";
          that.$close();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },

    getEstateSort() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getEstateSort", {})
        .then((res) => {
          let pList = res.data.data;
          that.sortList = pList;
          console.log("pList", pList);
          that.listName = "sortList";
          that.$close();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },

    getHotingList() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getHotingList")
        .then((res) => {
          console.log("res", res.data);
          that.hotingList = res.data.data;
          that.changeListName("hotingList");
          that.$close();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },
    judgeHotColor(param) {
      let { rowIndex, columnIndex, row, column } = param;
      let num = row.property[column.property];
      if (num === 3) {
        return {
          "background-color": "orange",
        };
      } else if (num === 4) {
        return {
          "background-color": "red",
          color: "white",
        };
      }
    },
    areaFilter(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    searchEstate(search) {
      let that = this;
      if (search) {
        that.$axios
          .get(that.$url_prefix + "searchEstateName", {
            params: {
              type: "全部",
              search: search,
            },
          })
          .then((res) => {
            that.matchEstates = res.data.data;
            that.estateValue = search;
          });
      }
    },
    searchArea(search) {
      let that = this;
      if (search) {
        that.$axios
          .get(that.$url_prefix + "searchAreaName", {
            params: {
              search: search,
            },
          })
          .then((res) => {
            that.matchAreas = res.data.data;
          });
      }
    },

    onNearbyClick() {
      let that = this;
      let item = { operation: "check" };
      let routeData = that.$router.resolve({
        name: "location",
        query: item,
      });
      window.open(routeData.href, "_self");
    },

    showTopicLoc(item) {
      let lnglat = item.lnglat;
      this.topicLnglat = "";
      if (lnglat) {
        this.center = lnglat.split("|");
        this.topicLnglat = lnglat;
        this.$message({
          type: "success",
          message: "切换位置成功",
        });
      } else {
        this.$message.error("没有位置");
      }
    },

    getAdCloseFinish() {
      let that = this;
      let limit = "";
      let day = parseInt(that.closeDay);
      if (day && day > 0) {
        limit = day;
      }
      that.$axios
        .get(that.$url_prefix + "adCloseFinish", {
          params: {
            limit: limit,
          },
        })
        .then((res) => {
          let list = res.data.data;
          if (list.length === 0) {
            that.$message.error("暂无即将到期的展位");
          }
          console.log("adCloseFinish", res.data.data);
          that.adCloseList = list;
          that.listName = "adCloseList";
        })
        .catch((err) => {
          console.log("getAdCloseFinish err");
        });
    },

    getMpCode() {
      let that = this;
      that.$open();
      let city = this.$store.state.Counter.city;
      let apiMap = {
        杭州: "getMpCode",
        苏州: "getSzMpCode",
      };
      that.$axios
        .get(that.$url_prefix + apiMap[city], {
          params: {
            toPage: that.codeType || "",
          },
        })
        .then((res) => {
          that.$close();
          if (res.data.success) {
            that.mpCode = res.data.data;
          } else {
            that.$message.error("获取小程序码失败");
          }
        })
        .catch((err) => {
          that.$close();
          that.$message.error("获取小程序码失败");
          console.log("getMpCode err", err);
        });
    },

    // getTodayPoster() {
    //   let that = this;
    //   that.$open();
    //   that.$axios
    //     .post(that.$url_prefix + "getTodayPoster")
    //     .then(res => {
    //       that.$close();
    //       if (res.data.success) {
    //         that.mpCode = res.data.data;
    //       } else {
    //         that.$message.error("获取登记海报失败");
    //       }
    //     })
    //     .catch(err => {
    //       that.$close();
    //       that.$message.error("获取登记海报失败");
    //       console.log("getTodayPoster err", err);
    //     });
    // },

    getAreaList(value) {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getAreaList")
        .then((res) => {
          that.$close();
          let data = res.data.data;
          if (value) {
            data = data.filter((x) => x.real_estate_name.includes(value));
          }
          if (that.areaValue) {
            data = data.filter(
              (x) => x.district && x.district.includes(that.areaValue)
            );
          }
          if (that.checkDate1) {
            data = data.filter(
              (x) => x.time && x.time.includes(that.checkDate1.split(" ")[0])
            );
          }
          that.areaList = data;
          that.listName = "areaList";
        })
        .catch((err) => {
          that.$close();
          that.$message.error("获取失败");
        });
    },
    searchAreaReal(e) {
      let that = this;
      let value = e.target.value;
      that.areaValue = "";
      that.getAreaList(value);
    },
    changeArea(value) {
      this.areaValue = value;
      this.getAreaList();
    },
    setOneTime(row, clear) {
      let that = this;
      that.$open();
      that.$axios
        .post(that.$url_prefix + "setOneTime", {
          id: row.id,
          clear: clear,
        })
        .then((res) => {
          that.$close();
          that.getAreaList();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },

    getSellList(value) {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getSellList")
        .then((res) => {
          that.$close();
          that.sellList = res.data.data;
          that.changeListName("sellList");
        })
        .catch((err) => {
          that.$close();
          that.$message.error("获取失败");
        });
    },

    getPcList(value) {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getPcList", {
          params: {
            start: that.checkDate1,
            end: that.checkDate2,
            type: value,
          },
        })
        .then((res) => {
          that.$close();
          that.pcList = res.data.data;

          that.changeListName(value);
        })
        .catch((err) => {
          that.$close();
          that.$message.error("获取失败");
        });
    },
    getNewPcList() {
      let that = this;
      that.$open();
      console.log(1);
      that.$axios
        .post(that.$url_prefix + "getNewPcList", {})
        .then((res) => {
          that.$close();
          console.log(res.data.data);
          that.newPcList = res.data.data;
          that.changeListName("getNewPcList");
        })
        .catch((err) => {
          that.$close();
          that.$message.error("获取失败");
        });
    },
    getZhList(value) {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getZhList", {
          params: {
            build_type: that.getZhListType,
          },
        })
        .then((res) => {
          that.$close();
          console.log(res);
          let data = res.data.data;
          if (value) {
            data = data.filter((x) => x.real_estate_name.includes(value));
          }
          if (that.ZhValue) {
            data = data.filter(
              (x) => x.district && x.district.includes(that.ZhValue)
            );
          }
          that.zhList = data;
          that.changeListName("zhList");
        })
        .catch((err) => {
          that.$close();
          that.$message.error("获取失败");
        });
    },

    getStatisticalTable(value) {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "questionHistory", {
          params: {
            start_time: that.tjDate1,
            end_time: that.tjDate2,
          },
        })
        .then((res) => {
          console.log(res);
          that.$close();
          that.tjList = res.data.data;
          that.changeListName(value);
        })
        .catch((err) => {
          that.$close();
          that.$message.error("获取失败");
        });
    },

    searchZhAreaReal(e) {
      let that = this;
      let value = e.target.value;
      that.ZhValue = "";
      that.getZhList(value);
    },
    changeZhArea(value) {
      this.ZhValue = value;
      this.getZhList();
    },

    getQlList() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getQlList", {
          params: {
            time: that.checkDate1,
          },
        })
        .then((res) => {
          that.$close();
          that.QlList = res.data.data;
          that.listName = "QlList";
        })
        .catch((err) => {
          that.$close();
          that.$message.error("获取失败");
        });
    },

    getMaxList() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getMaxList")
        .then((res) => {
          that.$close();
          that.maxList = res.data.data;
          that.listName = "maxList";
        })
        .catch((err) => {
          that.$close();
          that.$message.error("获取失败");
        });
    },
    getGiveClientInfo(value) {
      let that = this;
      // let estate = that.matchEstates.filter(x=>{
      //   return x.real_estate_name == that.estateValue
      // })
      // console.log(value,that.estateValue);

      this.$axios
        .get(that.$url_prefix + "getGiveClientInfo", {
          params: {
            estate_id: value,
          },
        })
        .then((res) => {
          console.log(res);
          let data = res.data.data;
          // if (value) {
          //   data = data.filter(x => x.real_estate_name.includes(value));
          // }
          that.assignCustomer = data;
        });
    },

    // searchEstatesList(e) {
    //   let that = this;
    //   let value = e.target.value;
    //   that.estateValue = "";
    //   that.getGiveClientInfo(value);
    // },
    toHangPai() {
      this.$router.push({ path: "hangpai" });
    },
    toPoiManage() {
      this.$router.push({ path: "/poiManage" });
    },

    checkErp() {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "checkErp")
        .then((res) => {
          if (res.data.data) {
            that.$message.error("正在运行，请勿更新!");
          } else {
            that.$message({
              type: "success",
              message: "可以上传",
            });
          }
        })
        .catch((err) => {
          that.$message.error("请求失败");
        });
    },

    getStatisticsData() {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "recentlyStatistics")
        .then(function (res) {
          console.log(res.data.data);
          that.changeListName("statisticsList");
          that.statisticsList = res.data.data;
        });
    },

    toCheckImage(type) {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "toCheckImage", {
          params: {
            type: type,
          },
        })
        .then((res) => {
          that.$close();
          console.log("toCheckImage", res);
          let list = res.data.data;
          if (list.length === 0) {
            that.$message.error("暂无待审核的图片");
            return;
          }
          if (type === "楼盘") {
            that.estateImgCheck = res.data.data;
            that.changeListName("estateImgCheck");
          } else if (type === "房源") {
            that.hangImgCheck = res.data.data;
            that.changeListName("hangImgCheck");
          }
        })
        .catch((err) => {
          that.$close();
          console.log("toCheckImage err", err);
          that.$message.error("请求失败");
        });
    },

    toIndexPage() {
      this.$router.push({
        path: "/indexPage",
      });
    },
    toOpinion() {
      this.$router.push({
        path: "/opinion",
      });
    },
    onSaleAdTypeChange() {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "getAdUser", {
          params: {
            type: that.saleAdType,
          },
        })
        .then((res) => {
          console.log("res", res);
          that.salePayList = res.data.data;
        })
        .catch((err) => {
          that.$message.error("请求失败");
        });
    },
    getGuwenFuwu() {
      this.$axios
        .get(this.$url_prefix + "guwenChat", {
          params: {
            id: this.commentEstateId,
            start_time: this.ax.start_time,
            end_time: this.ax.end_time,
          },
        })
        .then((res) => {
          console.log(res);
          this.guwenList = res.data.data;
        })
        .catch(() => {});
    },
    setToShow(user) {
      let that = this;
      if (that.saleAdType) {
        that.payUser = user;
        that.payVisible = true;
      } else {
        that.$message.error("请选择类别");
      }
    },
    setSalePay() {
      let that = this;
      let user = that.payUser;
      let obj = {
        user_id: user.id,
        way: user.way,
      };
      obj.money = parseInt(user.money);
      obj.start_time = user.start_time;
      obj.end_time = user.end_time;
      if (!obj.start_time) {
        that.$message.error("请选择起始日期");
        return;
      }
      if (!obj.end_time) {
        that.$message.error("请选择结束日期");
        return;
      }
      if (!obj.money) {
        that.$message.error("请填写金额");
        return;
      }
      if (obj.money < 0) {
        that.$message.error("金额不能是负数");
        return;
      }
      if (!obj.way) {
        that.$message.error("请选择付款方式");
        return;
      }
      obj.type = that.saleAdType;
      console.log("obj", obj);
      that.$axios.post(that.$url_prefix + "setSalePay", obj).then((res) => {
        if (res.data.success) {
          that.salePayList = res.data.data;
          that.$message({
            type: "success",
            message: "付费成功",
          });
          that.payVisible = false;
          that.payUser = {};
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    cancelSalePay(index) {
      let that = this;
      let onepay = (onepay = that.salePayList[index]);
      let out_money = parseInt(onepay.outMoney) || 0;
      let tip = `确定取消：${onepay.user_name}${onepay.start_time}的订单，退款${out_money}元吗？`;
      that
        .$confirm(tip, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          that.$axios
            .get(that.$url_prefix + "cancelSalePay", {
              params: {
                _id: onepay._id,
                out_money: Math.abs(out_money),
              },
            })
            .then((res) => {
              that.salePayList.splice(index, 1);
              that.$message({
                type: "success",
                message: "退订成功",
              });
            })
            .catch((err) => {
              console.log("cancel fail", err);
              that.$message.error("退订失败，请检查网络");
            });
        })
        .catch((err) => {
          console.log("cancel", err);
        });
    },
    modSalePay(index) {
      let that = this;
      let onepay = that.salePayList[index];
      let start_time = onepay.start_time;
      let end_time = onepay.end_time;
      let tip = `确定将日期修改为：${start_time}至${end_time}吗？`;
      that
        .$confirm(tip, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          that.$axios
            .get(that.$url_prefix + "modSalePay", {
              params: {
                _id: onepay._id,
                start_time: start_time,
                end_time: end_time,
              },
            })
            .then((res) => {
              if (res.data.success) {
                that.salePayList = res.data.data;
                that.$message({
                  type: "success",
                  message: "修改成功",
                });
              } else {
                that.$message.error(res.data.msg);
              }
            })
            .catch((err) => {
              console.log("修改日期失败", err);
              that.$message.error("修改日期失败，请检查网络");
            });
        })
        .catch((err) => {
          console.log("cancel", err);
        });
    },

    getSaleJoinData() {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "getSaleJoinData")
        .then((res) => {
          that.listName = "saleJoinData";
          that.saleJoinData = res.data.data;
        })
        .catch((err) => {
          that.$message.error("查询失败");
        });
    },

    checkOldSpider() {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "getDayHits", {
          params: {
            type: "二手房爬虫",
          },
        })
        .then((res) => {
          console.log("res", res);
          that.spiderData = res.data.data.map((x) => {
            let data = x.data;
            data.date = x.date;
            return data;
          });
          that.listName = "spiderData";
        })
        .catch((err) => {
          that.$message.error("请求失败");
        });
    },

    toMatchEstateName(fresh) {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "getWaitMatchName")
        .then((res) => {
          let list = res.data.data;
          if (!list.length) {
            that.$message.error("没有了");
          }
          let map = {};
          list = list.map((x) => {
            map[x] = 1;
            return {
              name: x,
              match: "",
            };
          });
          if (!fresh) {
            if (this.waitMatchList.length) {
              for (let i = 0; i < this.waitMatchList.length; i++) {
                if (!map[this.waitMatchList[i].name]) {
                  this.waitMatchList.splice(i, 1);
                  i--;
                }
              }
            } else {
              that.waitMatchList = list;
            }
          } else {
            that.waitMatchList = list;
          }
          that.changeListName("waitMatchList");
        })
        .catch((err) => {
          that.$message.error("请求失败");
        });
    },
    getEstateNameMatchList() {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "getEstateNameMatchList")
        .then((res) => {
          let list = res.data.data;
          that.hadMatchList = list;
          that.changeListName("hadMatchList");
        })
        .catch((err) => {
          that.$message.error("请求失败");
        });
    },
    cancelMatch(item) {
      this.$axios
        .post(this.$url_prefix + "cancelMatchName", {
          match_oid: item._id,
        })
        .then((res) => {
          if (res.data.success) {
            let index = this.hadMatchList.findIndex(
              (x) => x.estate_name === item.estate_name
            );
            if (index > -1) {
              this.hadMatchList.splice(index, 1);
            }
          } else {
            this.$message.error("请求失败");
          }
        })
        .catch((err) => {
          this.$message.error("请求失败");
        });
    },
    setMatchName() {
      let that = this;
      let list = this.waitMatchList.filter((x) => x.match);
      list.forEach((x) => (x.match = x.match.trim()));
      list = list.filter((x) => x.match);
      that.$axios
        .post(that.$url_prefix + "setMatchName", {
          list: JSON.stringify(list),
        })
        .then((res) => {
          that.toMatchEstateName();
        })
        .catch((err) => {
          that.$message.error("请求失败");
        });
    },
    showAddress(name) {
      this.$axios
        .get(this.$url_prefix + "getEstateAddress", {
          params: {
            estate_name: name,
          },
        })
        .then((res) => {
          console.log("res", res);
          this.currentAddress = {
            name: name,
            list: res.data.data,
          };
        });
    },
    startMultiMatch(name) {
      this.currentMulti = {
        name: name,
        list: [
          { name: "", id: "" },
          { name: "", id: "" },
        ],
      };
    },
    addMultiMatchOne() {
      this.currentMulti.list.push({ name: "", id: "" });
    },
    saveMultiMatch() {
      let obj = JSON.parse(JSON.stringify(this.currentMulti));
      let list = obj.list.filter((x) => x.name.trim() && x.id.trim());
      if (list.length < 2) {
        this.$message.error("请填完整");
        return;
      }
      list.forEach((x) => {
        x.name = x.name.trim();
        x.id = x.id.trim();
      });
      let match = list.map((x) => x.name + "," + x.id).join(";");
      this.$axios
        .post(this.$url_prefix + "setMatchName", {
          list: JSON.stringify([
            {
              name: obj.name,
              match: match,
            },
          ]),
        })
        .then((res) => {
          this.toMatchEstateName();
        })
        .catch((err) => {
          this.$message.error("请求失败");
        });
    },

    toMapPage(type, area) {
      let item = {
        type,
        area,
      };
      this.$router.push({
        name: "location-image",
        params: item,
      });
    },

    getLogs() {
      let that = this;
      that.$axios.get(that.$url_prefix + "getLogs").then((res) => {
        that.logList = res.data.data;
        that.listName = "logList";
      });
    },

    getXHLogs(maxId) {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "xinghao/getErrorLogs", {
          params: {
            platform: that.error_platform,
            maxId: maxId || "",
          },
        })
        .then((res) => {
          console.log("xhLogList", res.data.data);
          that.xhLogList = res.data.data;
          that.xhLogMaxId = that.xhLogList[that.xhLogList.length - 1]._id;
          console.log("that.xhLogMaxId", that.xhLogMaxId);
          that.listName = "xhLogList";
        });
    },

    getSalesMsgNum() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getSalesMsgNum", { timeout: 60 * 1000 })
        .then((res) => {
          that.$close();
          that.salesMsgNum = res.data.data;
          that.listName = "salesMsgNum";
        })
        .catch((err) => {
          that.$close();
          that.$message.error("请求失败");
        });
    },

    setChatSales() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "setChatSales")
        .then((res) => {
          that.$close();
          that.$message({
            type: "success",
            message: "操作成功",
          });
        })
        .catch((err) => {
          that.$close();
          that.$message.error("操作失败");
        });
    },

    setEstateSort(id) {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "queryOneById", {
          params: {
            id: id,
            db: "WpBackupModel",
          },
        })
        .then((res) => {
          console.log("res", res);
          let back = res.data.data;
          that.estateSortObj = {
            id: back.id || "",
            name: back.name,
            list: [],
          };
          if (back.data) {
            that.estateSortObj.list = JSON.parse(back.data);
          }
          that.changeListName("setEstateSort");
        })
        .catch((err) => {
          console.log("err", err);
          that.$message.error("请求失败");
        });
    },
    addEstateToSort(id) {
      let item = this.matchEstates.find((x) => x.id === id);
      let old = this.estateSortObj.list.find((x) => x.id === id);
      if (old) {
        this.$message.error("重复添加");
      } else if (item) {
        this.estateSortObj.list.push({
          name: item.real_estate_name,
          id: item.id,
        });
      }
    },
    setToTop(index) {
      let that = this;
      if (index) {
        let item = that.estateSortObj.list.splice(index, 1)[0];
        that.estateSortObj.list.unshift(item);
      }
    },
    moveOut(index) {
      let that = this;
      that.estateSortObj.list.splice(index, 1)[0];
    },
    saveEstateSort() {
      let that = this;
      let obj = {
        id: that.estateSortObj.id,
        data: JSON.stringify(that.estateSortObj.list),
      };
      let param = {
        db: "WpBackupModel",
        model: "edit",
        item: JSON.stringify(obj),
      };
      that.$axios
        .post(that.$url_prefix + "updateData", param)
        .then((res) => {
          that.$message({
            type: "success",
            message: "保存成功",
          });
          that.estateSortObj = null;
          that.listName = "";
        })
        .catch((err) => {
          console.log("err", err);
          that.$message.error("保存失败");
        });
    },
    givePhoneUsers() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "givePhoneUsers")
        .then((res) => {
          that.$close();
          that.phoneUsers = res.data.data;
          that.listName = "phoneUsers";
        })
        .catch((err) => {
          that.$close();
          that.$message.error("请求失败");
        });
    },

    checkTalkRecord() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getCallNum")
        .then((res) => {
          that.$close();
          that.talkRecord = res.data.data;
          // that.talkUserMap = res.data.userMap;
          that.listName = "talkRecord";
        })
        .catch((err) => {
          that.$close();
          that.$message.error("请求失败");
        });
    },

    filterEstate(value, row, col) {
      return value === row[col.property];
    },

    toGetOneDayTalk(group) {
      this.talkSelectGroup = group;
      this.changeListName("checkTalks");
      if (group === "运营") {
        this.changeTopicLabel(true);
      }
    },
    getOneDayTalk() {
      let that = this;
      that.$open();
      that.checkTalks = [];
      if (that.loupanCheck == "楼盘") {
        that.$axios
          .get(that.$url_prefix + "getOneDayTalk", {
            params: {
              date: that.checkTalksDate,
              group: this.talkSelectGroup,
            },
          })
          .then((res) => {
            that.$close();
            that.checkTalks = res.data.data;
            let total = 0;
            that.checkTalks.forEach((x) => {
              total += x.msgList.length;
            });
            that.checkTalksNum = total;
            console.log("getOneDayTalk res", res);
          })
          .catch((err) => {
            that.$close();
            console.log("getOneDayTalk err", err);
          });
      } else {
        that.$axios
          .get(that.$url_prefix + "getQuestion", {
            params: {
              date: that.checkTalksDate,
            },
          })
          .then((res) => {
            that.$close();
            that.checkTalks = res.data.data;
            let total = 0;
            that.checkTalks.forEach((x) => {
              total += x.length;
            });
            that.checkTalksNum = total;
            console.log("getOneDayTalk res", res);
          })
          .catch((err) => {
            that.$close();
            console.log("getOneDayTalk err", err);
          });
      }
    },

    toCheckTalk() {
      this.listName = "checkEveryTalk";
    },
    checkEveryTalk(recent, user_id) {
      let that = this;
      that.$open();
      let params = {};
      if (recent) {
        params.recent = recent;
      } else if (user_id) {
        params.user_id = user_id;
      } else {
        params.date = that.everyTalkDate;
      }
      that.$axios
        .get(that.$url_prefix + "checkEveryTalk", {
          params: params,
        })
        .then((res) => {
          that.$close();
          console.log("checkEveryTalk res", res);
          let list = res.data.data;
          let result = [];
          let count = 0;
          let part = [];
          let limit = 100;
          for (let i = 0; i < list.length; i++) {
            count += list[i].msgList.length;
            part.push(list[i]);
            if (count > limit) {
              result.push(part);
              part = [];
              count = 0;
            }
          }
          if (part.length) {
            result.push(part);
          }
          that.everyTalkList = result;
          console.log("result", result);
          if (recent && result.length) {
            that.showEveryOver = true;
          } else {
            that.showEveryOver = false;
          }
          this.changeTalkPage(1);
        })
        .catch((err) => {
          that.$close();
          console.log("checkEveryTalk err", err);
        });
    },
    changeTalkPage(talkPage) {
      if (talkPage) {
        this.talkPage = talkPage;
      } else {
        talkPage = this.talkPage;
      }
      this.partTalkList = this.everyTalkList[talkPage - 1] || [];
      document.getElementById("talk_title").scrollIntoView();
    },
    lahei(row, index) {
      let that = this;
      if (row.user.user_status === "黑名单") {
        return;
      }
      that
        .$confirm(`确定拉黑“${row.user.user_name}？”`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          that.$axios
            .get(that.$url_prefix + "unStatus", {
              params: {
                id: row.user_id,
                status: "拉黑",
              },
            })
            .then((res) => {
              that.everyTalkList.forEach((x) => {
                x.forEach((y) => {
                  y.msgList.forEach((z) => {
                    if (z.user_id === row.user_id) {
                      z.user.user_status = "黑名单";
                      z.status = "删除";
                    }
                  });
                });
              });
              that.$message({
                type: "success",
                message: "操作成功",
              });
            })
            .catch((err) => {
              that.$message.error("操作失败");
            });
        })
        .catch((err) => {
          console.log("取消删除", err);
        });
    },
    setAllCheck() {
      let that = this;
      that
        .$confirm("确定此前的消息全部已审核？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          that.$axios
            .get(that.$url_prefix + "setAllTalkCheck")
            .then((res) => {
              that.$message({
                type: "success",
                message: "操作成功",
              });
            })
            .catch((err) => {
              that.$message.error("操作失败");
            });
        })
        .catch((err) => {
          console.log("取消删除", err);
        });
    },
    toCheckWeiguiTalk() {
      this.listName = "checkEveryTalk";
      this.checkEveryTalk("weigui");
    },
    searchUser(e) {
      let that = this;
      let value = e.target.value;
      if (value) {
        that.$open();
        that.$axios
          .get(that.$url_prefix + "searchUserByName", {
            params: {
              search: value,
            },
          })
          .then((res) => {
            console.log("res", res);
            that.$close();
            if (res.data.data.length) {
              that.nameSearchUsers = res.data.data;
            } else {
              that.$message.error("未找到此用户");
            }
          })
          .catch((err) => {
            that.$close();
            that.$message.error("搜索失败");
          });
      }
    },

    toSetFakeSaleAd() {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "getFakeSaleAd")
        .then((res) => {
          that.listName = "fakeSaleAd";
          that.fakeSaleAd = res.data.data;
          console.log("fakeSaleAd", that.fakeSaleAd);
        })
        .catch((err) => {
          that.$message.error("请求失败");
        });
    },
    setFakeSaleAd(user) {
      let that = this;
      if (!that.fakeSaleAdEstate) {
        that.$message.error("请选择楼盘");
        return;
      }
      that.$axios
        .get(that.$url_prefix + "setFakeSaleAd", {
          params: {
            estate_id: that.fakeSaleAdEstate,
            user_id: user.id,
          },
        })
        .then((res) => {
          that.$message({
            type: "success",
            message: "设置成功",
          });
          that.toSetFakeSaleAd();
        })
        .catch((err) => {
          that.$message.error("设置失败");
        });
    },
    downFakeSaleAd(item) {
      let that = this;
      that
        .$confirm("确定下架" + item.real_estate_name, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          that.$axios
            .get(that.$url_prefix + "downFakeSaleAd", {
              params: {
                estate_id: item.id,
              },
            })
            .then((res) => {
              that.$message({
                type: "success",
                message: "设置成功",
              });
              that.toSetFakeSaleAd();
            })
            .catch((err) => {
              that.$message.error("设置失败");
            });
        })
        .catch((err) => {
          console.log("取消删除", err);
        });
    },

    questionSituation() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "questionSituation")
        .then((res) => {
          that.$close();
          that.changeListName("questionStatusList");
          that.questionStatusList = res.data.data;
        })
        .catch((err) => {
          that.$close();
        });
    },

    chooseQuse() {
      this.$router.push({
        path: "/chooseQuse",
      });
    },

    drawPoster() {
      if (this.posterType === "每日楼市") {
        this.marketPoster();
      }
      if (this.posterType === "每周拿证公示") {
        this.publicityPoster();
      }
    },
    async marketPoster() {
      let that = this;
      let list1 = [];
      let list2 = [];
      let res = await that.$axios.get(that.$url_prefix + "getTodayPosterData");
      console.log("poster", res.data);
      list1 = res.data.list1;
      list2 = res.data.list2;
      let moreH = res.data.moreH;
      let fs = 20,
        w1 = 100,
        w2 = 210,
        w3 = 150,
        w4 = 210,
        lh = 50,
        tw = 350,
        mr = 2,
        rectColor = "#FCA704",
        cellColor = "#FFF4DD",
        side = 20;
      let head = ["区域", "楼盘名", "均价", "推荐销售"];
      let width = w1 + w2 + w3 + w4 + side * 4;
      let height =
        (list1.length + list2.length + 4) * lh +
        670 -
        side * 2 +
        fs * 1.3 * moreH * 2;
      let canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      let context = canvas.getContext("2d");
      let sx = side * 2;
      let sy = side * 4;
      // context.strokeStyle = '#cccccc';
      context.font = fs * 1.5 + 'px "msyh"';

      let img = new Image();
      img.src = "../../static/images/xiaojixuanfanglogo.png";
      img.onload = function () {
        context.drawImage(img, 15, 15, 42, 42);
      };

      context.fillStyle = rectColor;
      context.fillRect(0, 0, width, height);
      context.fillStyle = "#ffffff";
      context.fillRect(
        side,
        side * 3 + fs * 5 + 96,
        width - side * 2,
        height - side * 4 - fs * 6 - 100
      );

      context.font = "bold " + (fs + 8) + 'px "msyh"';
      context.textAlign = "left";
      context.fillStyle = "#ffffff";
      context.fillText("小鸡选房", 60, 45);

      let date = new Date();
      let timeStr =
        date.getFullYear() +
        "年" +
        (Number(date.getMonth()) + 1) +
        "月" +
        date.getDate() +
        "日";
      console.log(timeStr);
      context.fillStyle = "#ffffff";
      context.textAlign = "center";
      context.fillText(timeStr, width / 2, sy + fs * 3 + 97);

      sy = sy + fs + 68;
      context.font = "bold " + fs * 4 + 'px "msyh"';
      context.textAlign = "center";
      context.fillStyle = "#ffffff";
      context.fillText("每日楼市", width / 2, sy);

      sy += lh * 2;

      let wMap = {
        0: w1,
        1: w2,
        2: w3,
        3: w4,
      };
      let keyMap = {
        0: "area",
        1: "name",
        2: "price",
        3: "sale",
      };
      sy += 52;
      if (list1.length > 0) {
        context.fillStyle = "#000000";
        context.textAlign = "left";
        context.font = fs * 2 + 'px "msyh"';
        context.fillText(
          "正在公示楼盘" + "(" + list1.length + ")",
          side * 2,
          sy + (lh + fs) / 2
        );
        let hsx = sx;
        let allH = 0;
        for (let i = 0; i < head.length; i++) {
          let str = head[i];
          let cw = str.length * fs + fs;
          let w = wMap[i];
          context.beginPath();
          context.rect(hsx, sy + lh + 10, w, lh);
          // context.stroke();
          context.fillStyle = cellColor;
          context.fill();
          context.fillStyle = "#000000";
          context.textAlign = "center";
          context.font = fs * 1.3 + 'px "msyh"';
          context.fillText(
            str,
            hsx + w / 2,
            sy + lh + (lh + fs * 1.3) / 2 - mr + 10
          );

          context.fillStyle = "#000000";
          let pH = 0;
          for (let k = 0; k < list1.length; k++) {
            let value = list1[k][keyMap[i]];
            if (k > 0) {
              pH += (list1[k - 1]["price"].length - 1) * fs * 1.3;
            }
            if (!i && list1[k]["price"].length > 1) {
              allH += list1[k]["price"].length - 1;
            }
            context.beginPath();
            context.rect(
              hsx,
              sy + lh * (k + 2) + pH,
              w,
              lh + (list1[k]["price"].length - 1) * fs * 1.3 + 10
            );
            // context.stroke();
            if (value) {
              context.font = fs + 'px "msyh"';
              if (keyMap[i] === "price") {
                for (let j = 0; j < value.length; j++) {
                  context.fillText(
                    value[j],
                    hsx + w / 2,
                    sy +
                      lh * (k + 2) +
                      (lh + fs) / 2 -
                      mr +
                      fs * 1.3 * j +
                      pH +
                      10
                  );
                }
              } else {
                context.fillText(
                  value,
                  hsx + w / 2,
                  sy + lh * (k + 2) + (lh + fs) / 2 - mr + pH + 10
                );
              }
            }
          }

          hsx += w;
        }

        sy += lh * (list1.length + 3) + allH * fs * 1.3;
      }

      if (list2.length > 0) {
        context.fillStyle = "#000000";
        context.font = fs * 2 + 'px "msyh"';
        context.textAlign = "left";
        context.fillText(
          "正在登记楼盘" + "(" + list2.length + ")",
          side * 2,
          sy + (lh + fs) / 2 + 2
        );
        let hsx = sx;
        let allH = 0;
        for (let i = 0; i < head.length; i++) {
          let str = head[i];
          let cw = str.length * fs + fs;
          let w = wMap[i];
          context.beginPath();
          context.rect(hsx, sy + lh + 10, w, lh);
          // context.stroke();
          context.fillStyle = cellColor;
          context.fill();
          context.fillStyle = "#000000";
          context.textAlign = "center";
          context.font = fs * 1.3 + 'px "msyh"';
          context.fillText(
            str,
            hsx + w / 2,
            sy + lh + (lh + fs * 1.3) / 2 - mr + 10
          );

          context.fillStyle = "#000000";
          let pH = 0;
          for (let k = 0; k < list2.length; k++) {
            let value = list2[k][keyMap[i]];
            if (k > 0) {
              pH += (list2[k - 1]["price"].length - 1) * fs * 1.3;
            }
            if (!i && list2[k]["price"].length > 1) {
              allH += list2[k]["price"].length - 1;
            }
            context.beginPath();
            context.rect(
              hsx,
              sy + lh * (k + 2) + pH,
              w,
              lh + (list2[k]["price"].length - 1) * fs * 1.3 + 10
            );
            // context.stroke();
            if (value) {
              context.font = fs + 'px "msyh"';
              if (keyMap[i] === "price") {
                for (let j = 0; j < value.length; j++) {
                  context.fillText(
                    value[j],
                    hsx + w / 2,
                    sy +
                      lh * (k + 2) +
                      (lh + fs) / 2 -
                      mr +
                      fs * 1.3 * j +
                      pH +
                      10
                  );
                }
              } else {
                context.fillText(
                  value,
                  hsx + w / 2,
                  sy + lh * (k + 2) + (lh + fs) / 2 - mr + pH + 10
                );
              }
            }
          }

          hsx += w;
        }

        sy += lh * (list2.length + 3) + allH * fs * 1.3;
      }
      context.fillStyle = "#FFF4DD";
      context.fillRect(side, height - side * 2 - 184, width - side * 2, 194);
      sy += 90;
      sx += 200;
      context.font = "bold " + fs * 1.5 + 'px "msyh"';
      context.textAlign = "start";
      context.fillStyle = "#FF6D00";
      context.fillText("扫码了解更多数据", sx - 108, height - side * 2 - 104);
      sy += fs * 2;
      context.font = fs * 1.49 + 'px "msyh"';
      context.fillStyle = "#FF6D00";
      context.fillText("小鸡选房 为家而生", sx - 112, height - side * 2 - 64);

      let codeSrc;
      try {
        codeSrc = (
          await this.$axios.get(that.$url_prefix + "getMpCode", {
            params: {},
          })
        ).data.data;
      } catch (err) {
        console.log("get code image fail", err);
        this.$message.error("获取小程序码失败");
        return;
      }
      if (!codeSrc) {
        console.log("get code image fail");
        this.$message.error("获取小程序码失败");
        return;
      }
      let codeImage = new Image();
      codeImage.onload = function () {
        context.drawImage(
          codeImage,
          sx + 216,
          height - side * 2 - 164,
          160,
          160
        );
        that.mpCode = canvas.toDataURL("image/jpeg");
        that.$previewRefresh();
      };
      codeImage.onerror = function (err) {
        console.log("load code image err", err);
      };
      codeImage.src = codeSrc;
    },

    async publicityPoster() {
      let that = this;
      let list1 = [];
      let list2 = [];
      let res = await that.$axios.get(
        that.$url_prefix + "getAdvancePosterData"
      );
      console.log("poster", res.data);
      list1 = res.data.data;
      let fs = 20,
        w1 = 100,
        w2 = 210,
        w3 = 150,
        w4 = 210,
        lh = 50,
        tw = 350,
        mr = 2,
        rectColor = "#FCA704",
        cellColor = "#FFF4DD",
        side = 20;
      let head = ["区域", "楼盘名", "均价", "公示日期"];
      let width = w1 + w2 + w3 + w4 + side * 4;
      let height = list1.length * lh + 770 - side * 2;
      let canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      let context = canvas.getContext("2d");
      let sx = side * 2;
      let sy = side * 4;
      // context.strokeStyle = '#cccccc';
      context.font = fs * 1.5 + 'px "msyh"';

      let img = new Image();
      img.src = "../../static/images/xiaojixuanfanglogo.png";
      img.onload = function () {
        context.drawImage(img, 15, 15, 42, 42);
      };

      context.fillStyle = rectColor;
      context.fillRect(0, 0, width, height);
      context.fillStyle = "#ffffff";
      context.fillRect(
        side,
        side * 3 + fs * 5 + 96,
        width - side * 2,
        height - side * 4 - fs * 6 - 100
      );

      context.font = "bold " + (fs + 8) + 'px "msyh"';
      context.textAlign = "left";
      context.fillStyle = "#ffffff";
      context.fillText("小鸡找房", 60, 45);

      let date = new Date();
      let timeStr =
        date.getFullYear() +
        "年" +
        (Number(date.getMonth()) + 1) +
        "月" +
        date.getDate() +
        "日";
      console.log(timeStr);
      context.fillStyle = "#ffffff";
      context.textAlign = "center";
      context.fillText(timeStr, width / 2, sy + fs * 3 + 97);

      sy = sy + fs + 68;
      context.font = "bold " + fs * 4 + 'px "msyh"';
      context.textAlign = "center";
      context.fillStyle = "#ffffff";
      context.fillText("每周拿证公示", width / 2, sy);

      sy += lh * 2;

      let wMap = {
        0: w1,
        1: w2,
        2: w3,
        3: w4,
      };
      let keyMap = {
        0: "district",
        1: "real_estate_name",
        2: "piece",
        3: "date",
      };
      sy += 52;
      if (list1.length > 0) {
        context.fillStyle = "#000000";
        context.textAlign = "left";
        context.font = fs * 2 + 'px "msyh"';
        context.fillText(
          "正在公示楼盘" + "(" + list1.length + ")",
          side * 2,
          sy + (lh + fs) / 2
        );
        let hsx = sx;
        let allH = 0;
        for (let i = 0; i < head.length; i++) {
          let str = head[i];
          let cw = str.length * fs + fs;
          let w = wMap[i];
          context.beginPath();
          context.rect(hsx, sy + lh + 10, w, lh);
          // context.stroke();
          context.fillStyle = cellColor;
          context.fill();
          context.fillStyle = "#000000";
          context.textAlign = "center";
          context.font = fs * 1.3 + 'px "msyh"';
          context.fillText(
            str,
            hsx + w / 2,
            sy + lh + (lh + fs * 1.3) / 2 - mr + 10
          );

          context.fillStyle = "#000000";
          let pH = 0;
          for (let k = 0; k < list1.length; k++) {
            let value = list1[k][keyMap[i]];
            let a = 0;
            if (k > 0) {
              pH += list1[k - 1]["piece"].length - 1;
            }
            if (i === 2 && value.length === 0) {
              value = list1[k].bPiece;
              a = 1;
            }
            if (!i && list1[k]["piece"].length > 1) {
              allH += list1[k]["piece"].length - 1;
            }
            context.beginPath();
            context.rect(
              hsx,
              sy + lh * (k + 2) + pH,
              w,
              lh + (list1[k]["piece"].length - 1) * fs * 1.3 + 10
            );
            // context.stroke();
            if (value) {
              context.font = fs + 'px "msyh"';
              if (i === 2) {
                if (a === 0) {
                  if (value[0] != 0) {
                    context.fillText(
                      value[0],
                      hsx + w / 2,
                      sy + lh * (k + 2) + (lh + fs) / 2 - mr + pH + 10
                    );
                  } else {
                    context.fillText(
                      "/",
                      hsx + w / 2,
                      sy + lh * (k + 2) + (lh + fs) / 2 - mr + pH + 10
                    );
                  }
                } else {
                  if (value[0] && value[0].price1) {
                    context.fillText(
                      value[0].price1,
                      hsx + w / 2,
                      sy + lh * (k + 2) + (lh + fs) / 2 - mr + pH + 10
                    );
                  } else {
                    context.fillText(
                      "/",
                      hsx + w / 2,
                      sy + lh * (k + 2) + (lh + fs) / 2 - mr + pH + 10
                    );
                  }
                }
              } else {
                context.fillText(
                  value,
                  hsx + w / 2,
                  sy + lh * (k + 2) + (lh + fs) / 2 - mr + pH + 10
                );
              }
            }
          }

          hsx += w;
        }
        sy += lh * (list1.length + 3) + allH * fs * 1.3;
      }

      context.fillStyle = "#FFF4DD";
      context.fillRect(side, height - side * 2 - 184, width - side * 2, 194);
      sy += 90;
      sx += 200;
      context.font = "bold " + fs * 1.5 + 'px "msyh"';
      context.textAlign = "start";
      context.fillStyle = "#FF6D00";
      context.fillText("扫码了解更多数据", sx - 108, height - side * 2 - 104);
      sy += fs * 2;
      context.font = fs * 1.49 + 'px "msyh"';
      context.fillStyle = "#FF6D00";
      context.fillText("小鸡找房 为家而生", sx - 112, height - side * 2 - 64);

      let codeSrc;
      try {
        codeSrc = (
          await this.$axios.get(that.$url_prefix + "getSzMpCode", {
            params: {},
          })
        ).data.data;
      } catch (err) {
        console.log("get code image fail", err);
        this.$message.error("获取小程序码失败");
        return;
      }
      if (!codeSrc) {
        console.log("get code image fail");
        this.$message.error("获取小程序码失败");
        return;
      }
      let codeImage = new Image();
      codeImage.onload = function () {
        context.drawImage(
          codeImage,
          sx + 216,
          height - side * 2 - 164,
          160,
          160
        );
        that.mpCode = canvas.toDataURL("image/jpeg");
        that.$previewRefresh();
      };
      codeImage.onerror = function (err) {
        console.log("load code image err", err);
      };
      codeImage.src = codeSrc;
    },

    async voteRoomPoster(event) {
      let that = this;
      if (that.posterType === "投票选房") {
        let canvas = document.createElement("canvas");
        let context = canvas.getContext("2d");
        canvas.width = 1500;
        canvas.height = 2612;
        if (!event.target.files[0]) {
          console.log("没有选择图片");
          return;
        }
        let file = event.target.files[0];
        if (!file.type.includes("image")) {
          alert("请确认图片格式");
          return;
        }
        let reader = new FileReader();
        let posterImg = new Image();
        let img = new Image();
        posterImg.src = "static/images/voteRoom.png";
        posterImg.onload = function () {
          context.drawImage(posterImg, 0, 0, 1500, 2612);
        };
        let codeSrc;
        try {
          codeSrc = (
            await this.$axios.get(that.$url_prefix + "getMpCode", {
              params: {},
            })
          ).data.data;
        } catch (err) {
          console.log("get code image fail", err);
          this.$message.error("获取小程序码失败");
          return;
        }
        if (!codeSrc) {
          console.log("get code image fail");
          this.$message.error("获取小程序码失败");
          return;
        }
        let codeImage = new Image();
        codeImage.onload = function () {
          context.drawImage(codeImage, 894, 2133, 324, 324);
        };
        codeImage.onerror = function (err) {
          console.log("load code image err", err);
        };
        codeImage.src = codeSrc;
        reader.onload = function (e) {
          img.src = this.result;
          img.onload = function () {
            context.drawImage(img, 192, 686, 1114, 1387);
            that.mpCode = canvas.toDataURL("image/jpeg");
            that.$previewRefresh();
          };
        };
        reader.readAsDataURL(file);
      } else if (that.posterType === "比价表") {
        let canvas = document.createElement("canvas");
        let context = canvas.getContext("2d");
        canvas.width = 1500;
        canvas.height = 2668;
        if (!event.target.files[0]) {
          console.log("没有选择图片");
          return;
        }
        let file = event.target.files[0];
        if (!file.type.includes("image")) {
          alert("请确认图片格式");
          return;
        }
        let reader = new FileReader();
        let posterImg = new Image();
        let img = new Image();
        posterImg.src = "static/images/parity_ratio.jpg";
        posterImg.onload = function () {
          context.drawImage(posterImg, 0, 0, 1500, 2668);
        };

        let codeSrc;
        try {
          codeSrc = (
            await this.$axios.get(that.$url_prefix + "getMpCode", {
              params: {},
            })
          ).data.data;
        } catch (err) {
          console.log("get code image fail", err);
          this.$message.error("获取小程序码失败");
          return;
        }
        if (!codeSrc) {
          console.log("get code image fail");
          this.$message.error("获取小程序码失败");
          return;
        }

        let codeImage = new Image();
        codeImage.onload = function () {
          context.drawImage(codeImage, 874, 2062, 368, 368);
        };
        codeImage.onerror = function (err) {
          console.log("load code image err", err);
        };
        context.font = "italic bold " + 104 + 'px "msyh"';
        context.textAlign = "center";
        context.fillStyle = "#ffffff";
        let sy = 140;
        let limit = 1002;
        let textRows = that.apiUtil(context, that.building_name, 2, limit);
        if (textRows.length == 1) {
          sy = 382;
        } else if (textRows.length == 2) {
          sy = 272;
        }
        for (let i = 0; i < textRows.length; i++) {
          context.fillText(textRows[i], 750, sy + i * 120, limit);
        }
        codeImage.src = codeSrc;
        reader.onload = function (e) {
          img.src = this.result;
          img.onload = function () {
            context.drawImage(img, 180, 778, 1164, 1200);
            that.mpCode = canvas.toDataURL("image/jpeg");
            that.$previewRefresh();
          };
        };
        reader.readAsDataURL(file);
      }
    },

    apiUtil(context, words, line, limit) {
      let oneRow = "";
      let textRows = [];
      for (let i = 0, len = words.length; i < len; i++) {
        if (words[i] === "\n") {
          if (textRows.length === line - 1) {
            textRows.push(oneRow + "...");
            oneRow = "";
            break;
          } else {
            textRows.push(oneRow);
            oneRow = "";
            if (!words[i + 1]) {
              break;
            }
          }
        } else {
          let tempT = oneRow + words[i];
          let passWidth = context.measureText(tempT).width;
          if (passWidth > limit) {
            if (textRows.length === line - 1) {
              textRows.push(oneRow.slice(0, oneRow.length - 1) + "...");
              oneRow = "";
              break;
            } else {
              if (words[i + 1]) {
                textRows.push(oneRow);
                oneRow = words[i];
              } else {
                textRows.push(oneRow + words[i]);
                oneRow = "";
                break;
              }
            }
          } else {
            oneRow += words[i];
          }
        }
      }
      if (textRows.length < line && oneRow) {
        textRows.push(oneRow);
      }
      return textRows;
    },
    getGongZong() {
      this.listName = "getGongZong";
      let that = this;
      let city = "杭州";
      let idMap = {
        杭州: "2ev0o3b9pmt",
      };
      let dbMap = {
        杭州: "WpBackupModel",
      };
      that.$axios
        .get(that.$url_prefix + "queryOneById", {
          params: {
            id: idMap[city],
            db: dbMap[city],
          },
        })
        .then(function (res) {
          let data = res.data.data.data;
          that.essay = JSON.parse(data);
          console.log("query backup res", that.essay);
        })
        .catch(function (res) {
          console.log("query backup fail", res);
        });
    },
    getWarterImage() {
      let src = this.getFullUrl("watermark_xjxf1.png");
      return new Promise((resolve) => {
        let image = new Image();
        image.setAttribute("crossOrigin", "Anonymous");
        image.onload = () => {
          resolve(image);
        };
        image.src = src;
      });
    },
    getFullUrl(img_name) {
      let src = `/hangzhou/img/${img_name}`;
      if (this.$url_prefix.includes("http")) {
        src = `https://xiaoji-hangzhou.oss-cn-hangzhou.aliyuncs.com/img/${img_name}`;
      }
      return src;
    },

    changeValueMap() {
      if (this.valueBigType === "estate") {
        this.valueMap = {
          industry: "产业",
          company: "企业",
          office: "办公大厦",
          government: "政府办公",
          daogua: "倒挂",
          harmful: "不利",
        };
      } else {
        this.valueMap = {
          total: "总分",
          market: "商业",
          traffic: "交通",
          company: "企业",
          office: "办公大厦",
          government: "政府办公",
          school: "教育",
          hospital: "医疗",
          scenery: "景观",
          public: "文化展览",
          harmful: "不利",
        };
      }
    },
    updateEstateValue(type) {
      let that = this;
      console.log(type, this.valueType);
      let api = "updateEstateValue";
      let params = {
        type: that.valueType,
      };
      if (type === "score") {
        params = {
          type: "score",
        };
      } else {
        if (!that.valueType) {
          that.$message.error("请选择类别");
          return;
        }
      }
      if (type === "sort") {
        api = "getEstateValueSort";
        if (that.valueBigType === "area") {
          api = "getAreaValueSort";
        }
      }
      params.valueBigType = that.valueBigType;
      that.$open();
      that.$axios
        .get(that.$url_prefix + api, {
          params: params,
        })
        .then((res) => {
          that.$close();
          if (type === "sort") {
            that.valueSortList = res.data.data;
            that.changeListName("valueSortList");
            this.currentValueClass = "value";
          } else {
            that.$message({
              type: "success",
              message: "操作成功",
            });
          }
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
          that.$message.error("操作失败");
        });
    },
    goValueMap(item) {
      console.log("goValueMap", item);
      this.$router.push({
        name: "location-image",
        params: {
          type: "value",
          estate_id: item.estate_id,
          valueType: item.type,
        },
      });
    },
    goEstateValueMap(type, other_type) {
      this.$router.push({
        name: "EstateValueMap",
        params: {
          valueType: type,
          valueBigType: this.valueBigType,
          valueOtherType: other_type,
          locationType: this.locationType,
        },
      });
    },
    handleCommand(city) {
      // 调用Vuex的mutation来更新城市状态
      this.$store.commit("SET_CITY", city);
      if (city === "上海") {
        sessionStorage.setItem("city", city);
        this.$router.push({
          path: "shanghai/homePage",
        });
      } else {
        sessionStorage.setItem("city", city);
      }
      // console.log(city)
    },
    getOtherValueScore(type) {
      this.$axios
        .get(this.$url_prefix + "getOtherValueScore", {
          params: {
            type: type,
            locationType: this.locationType,
          },
        })
        .then((res) => {
          res.data.data.forEach((item, i) => {
            item.index = i + 1;
          });
          this.valueSortList = res.data.data;
          this.currentValueClass = this.valueOtherType;
          this.changeListName("valueSortList");
        });
    },
    getValueSortOfOneEstate(item) {
      let type = item.type;
      let api = "getValueSortOfOneEstate";
      if (this.valueBigType === "area") {
        api = "getValueSortOfOneArea";
      }
      if (this.currentValueClass === "配套") {
        type = "loc_" + type;
      }
      if (this.currentValueClass === "规划") {
        api = "getPlanSortOfOneEstate";
      }
      this.$axios
        .get(this.$url_prefix + api, {
          params: {
            estate_id: item.estate_id,
            area_id: item.area_id,
            type: type,
          },
        })
        .then((res) => {
          console.log("res", res);
          this.valueSortEstateName =
            item.real_estate_name + ":" + res.data.data.length;
          this.valueSortListOfEstate = res.data.data;
        });
    },
    toUpdatePOI(type) {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "getEstatesNoPoi", {
          params: {
            type: type,
          },
        })
        .then((res) => {
          let list = res.data.data;
          if (type === "新房") {
            list = list.filter(
              (x) => x.build_type === "住宅" || x.build_type === "别墅"
            );
          }
          that.$open();
          that.updatePOI(list);
        })
        .catch((res) => {
          console.log("fail", res);
        });
    },
    async updatePOI(list) {
      let that = this;
      if (list.length === 0) {
        that.$close();
        console.log("jieshu");
        return;
      }
      let theOne = list.splice(0, 1)[0];
      let center = theOne.lnglat.split("-")[0].split("|");
      let result = [];
      let map = {
        餐饮服务: "餐饮",
        医疗保健服务: "医疗",
        体育休闲服务: "娱乐",
        购物服务: "商业",
        科教文化服务: "文化",
        风景名胜: "景观",
        金融保险服务: "金融",
        政府机构及社会团体: "公建",
        交通设施服务: "交通",
        生活服务: "生活",
      };
      for (let key in map) {
        let index = 1;
        while (true) {
          let arr = await this.searchMap(key, center, index);
          result = result.concat(arr);
          index++;
          if (arr.length < 50) {
            break;
          }
        }
      }
      result = result.map((x) => {
        return {
          name: x.name,
          dis: x.distance,
          type: x.type.split(";")[0],
          lnglat: x.location.lng + "|" + x.location.lat,
        };
      });
      if (result.length) {
        that.$axios
          .post(that.$url_prefix + "updatepoiList", {
            estate_id: theOne.id,
            poiList: result,
          })
          .then((res) => {
            that.updatePOI(list);
            console.log("list.length", list.length);
          })
          .catch((err) => {
            console.log("err", err);
            that.updatePOI(list);
          });
      } else {
        that.updatePOI(list);
      }
    },
    searchMap(type, center, index) {
      let city = this.$store.state.Counter.city;
      return new Promise((resolve, reject) => {
        let placeSearch = new AMap.PlaceSearch({
          city: city,
          citylimit: true,
          pageSize: 50,
          pageIndex: index,
          type: type,
        });
        placeSearch.searchNearBy("", center, 1000, function (status, result) {
          if (status === "complete") {
            resolve(result.poiList.pois);
          } else {
            resolve([]);
          }
        });
      });
    },
    async combineImg(event) {
      async function loadImg(file) {
        return new Promise((resolve) => {
          let reader = new FileReader();
          let img = new Image();
          reader.onload = function (e) {
            img.src = this.result;
            img.onload = function () {
              resolve(img);
            };
          };
          reader.readAsDataURL(file);
        });
      }

      let that = this;
      if (!event.target.files[0]) {
        console.log("没有选择图片");
        return;
      }
      let files = event.target.files;
      let images = [];
      for (let i = 0; i < files.length; i++) {
        let file = files[i];
        if (!file.type.includes("image")) {
          continue;
        }
        let img = await loadImg(file);
        images.push(img);
      }

      let width = 0;
      let height = 0;
      images.forEach((img) => {
        width = img.width + width;
        if (img.height > height) {
          height = img.height;
        }
      });

      let cvs = document.createElement("canvas");
      cvs.width = width;
      cvs.height = height;
      let ctx = cvs.getContext("2d");

      ctx.fillStyle = "#FFF";
      ctx.fillRect(0, 0, width, height);

      let sx = 0;
      images.forEach((img, i) => {
        ctx.drawImage(img, sx, 0);
        sx += img.width;
      });

      that.mpCode = cvs.toDataURL("image/jpeg");
      that.$previewRefresh();
    },

    ignoreAdvance(id) {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "passAdvance", {
          params: {
            id: id,
          },
        })
        .then((res) => {
          that.szYuShouList();
        });
    },
    filterZhListHas(value, row, column) {
      const property = column["property"];
      return row[property].includes(value);
    },
    filterZhListHas_copy(value, row, column) {
      const property = column["property"];
      let num =
        row[property].split("个")[0] == "无"
          ? 0
          : row[property].split("个")[0] * 1;
      switch (value) {
        case "达标":
          if (num >= 3) {
            return true;
          } else {
            return false;
          }
        case "不达标":
          if (num < 3) {
            return true;
          } else {
            return false;
          }
      }
    },
    filterZhListDis(value, row, column) {
      return row.district === value;
    },
    filterZhListStatus(value, row, column) {
      return row.real_status === value;
    },
    filterZhListStandards(value, row, column) {
      if (value) {
        let city = this.$store.state.Counter.city;
        let limit = 85;
        if (city !== "杭州") {
          limit = 70;
        }
        if (this.getZhListType == "公寓") {
          limit = 80;
        }
        if (value === "达标") {
          return parseInt(row.details_tage) >= limit;
        } else {
          return parseInt(row.details_tage) < limit;
        }
      }
    },

    toTestReply() {
      this.changeListName("testReply");
    },
    // 跳转猩号表情管理
    toEmoticon() {
      this.$router.push({
        path: "/Emoticon",
      });
    },
    // estateLabel(){

    // },
    sendTestReply(label, estate_id) {
      let that = this;
      if (!label) {
        return;
      }
      that.$axios
        .get(that.$url_prefix + "sendTestReply", {
          params: {
            label: label,
            estate_id: estate_id,
          },
        })
        .then((res) => {
          that.$message({
            type: "success",
            message: "发送成功",
          });
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    changeListName(name) {
      if (this.listName == name) {
        return;
      }
      this.listName = "";
      let that = this;
      this.$nextTick(function () {
        that.listName = name;
      });
    },

    checkMatchRecord() {
      console.log(this.wenda);
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "checkMatchRecord", {
          params: {
            time: that.wenda,
          },
        })
        .then((res) => {
          that.$close();
          console.log("res", res);
          that.matchRecordList = res.data.data;
          that.changeListName("matchRecordList");
        })
        .catch(() => {
          that.$close();
        });
      that.$axios
        .get(that.$url_prefix + "getNum", {
          params: {
            time: that.wenda,
          },
        })
        .then((res) => {
          this.restreson = res.data.data;
        })
        .catch(() => {});
    },
    setMatchRecord(row, index, status) {
      let that = this;
      let obj = {
        _id: row._id,
        status: status,
      };
      let param = {
        db: "MatchRecordModel",
        model: "edit",
        item: JSON.stringify(obj),
      };
      that.$axios
        .post(that.$url_prefix + "updateData", param)
        .then((res) => {
          that.matchRecordList.splice(index, 1);
        })
        .catch((err) => {
          that.$message.error("操作失败");
        });
    },

    toCommentEstate() {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "getCommentUsers")
        .then((res) => {
          that.commentUsers = res.data.data;
          that.changeListName("commentEstate");
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    changeCommentType() {
      let that = this;
      this.commentWordList = {};
      if (
        (that.commentType === "户型评测" ||
          that.commentType === "样板房评测") &&
        that.commentEstateId
      ) {
        let dbMap = {
          杭州: "WpRealEstateModel",
          苏州: "SzEstateModel",
        };
        that.$axios
          .get(that.$url_prefix + "queryOneById", {
            params: {
              id: that.commentEstateId,
              db: dbMap[that.$store.state.Counter.city],
              projection: "-_id apartment",
            },
          })
          .then((res) => {
            let realEstate = res.data.data;
            if (realEstate && realEstate.apartment) {
              let apart = JSON.parse(realEstate.apartment);
              that.commentAparts = apart.imgList
                .filter((x) => x.time)
                .map((x) => {
                  return {
                    imgName1: x.imgName1,
                    imgName2: x.imgName2,
                  };
                });
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      }
    },
    addEstateComment() {
      let that = this;
      if (
        !that.commentType ||
        !that.commentUserId ||
        !that.commentWord ||
        (that.commentType === "板块评测" && !that.commentAreaId) ||
        (that.commentType !== "板块评测" && !that.commentEstateId)
      ) {
        that.$message.error("缺少信息");
        return;
      }
      if (that.commentType === "户型评测" && !that.commentApart) {
        that.$message.error("请选择户型");
        return;
      }
      let type = that.databaseTypes[that.commentType] || that.commentType;
      let obj = {
        type,
        user_id: that.commentUserId,
        real_estate_id: that.commentEstateId,
        words: that.commentWord,
      };
      if (that.commentType === "板块评测") {
        obj.area_id = that.commentAreaId;
      }
      if (that.commentType === "3D选房评测") {
        obj.type = "选房评测";
      }
      if (that.commentType === "户型评测") {
        obj.serial_number = that.commentApart;
      }
      that.commentFlag = true;
      that.$axios
        .post(that.$url_prefix + "addEstateComment", obj)
        .then((res) => {
          that.$message({
            type: "success",
            message: "评论成功",
          });
        })
        .catch((err) => {
          that.$message({
            type: "error",
            message: "评论失败",
          });
          console.log("err", err);
        });
      that.commentFlag = false;
    },
    getShareNum(type) {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getShareNum", {
          params: {
            date: that.checkDate1,
            type: type,
          },
        })
        .then(function (res) {
          console.log(res);
          that.checkDate1 = res.data.date;
          that.shareNumList = res.data.data;
          that.changeListName("shareNumList");
          that.$close();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },
    setSubstitute(target) {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "setSubstitute", {
          params: {
            target: target,
          },
        })
        .then((res) => {
          that.$message({
            type: "success",
            message: "操作成功，请在小程序查看",
          });
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    getPoiIformation() {
      this.$router.push({ path: "poiInformation" });
    },
    recommendrealestate() {
      this.ifrecommendrealestate = true;
    },
    setThisRealestate() {
      let city = this.$store.state.Counter.city;
      let dbMap = {
        杭州: "WpBackupModel",
        苏州: "SzBackupModel",
      };
      let param = {
        model: "edit",
        item: JSON.stringify({
          id: "pm7k1o1gsw",
          data: this.recommandEstate,
        }),
      };
      console.log(city, param);
      this.$axios
        .post(this.$url_prefix + "updateData", param)
        .then((res) => {
          console.log(res);
          this.$message({
            type: "success",
            message: "保存成功",
          });
          this.ifrecommendrealestate = false;
        })
        .catch((err) => {
          console.log("err", err);
          this.$message.error("保存失败");
        });
    },

    gohousetype() {
      this.$router.push({
        path: "/HouseType",
      });
    },
    toGetUpdataApp() {
      this.$router.push({
        path: "/UpDataApp",
      });
    },
    getUserNum() {
      this.$axios.get(this.$url_prefix + "xinghao/userNum").then((res) => {
        console.log(res);
        this.$message({
          type: "success",
          message: "数量为" + res.data.data,
        });
      });
    },
    getYunYinCountSysterm() {
      this.$router.push("/yunYinCount");
    },
    getshuju() {
      this.$router.push("/shujuCount");
    },
    getxiaoshou() {
      this.$router.push("/xiaoshouCount");
    },
    gotoOfficial() {
      this.$router.push("/officialAgent");
    },
    getCuctomers() {
      this.$router.push("/giveCustomers");
    },
    giveCuctomersRecord() {
      this.$router.push("/giveCuctomersRecord");
    },
    toBKdata() {
      this.$router.push("/housePicker/areaPage");
    },
    toLPdata() {
      this.$router.push("/housePicker/lpData");
    },
    getchuangxin() {
      this.$router.push("/chuangxinCount");
    },
    getDataInfo() {
      this.$router.push("/getDataInfo");
    },
    toNewGoods() {
      this.$router.push("/BusinessNewGoods");
    },
    toGoodsShow() {
      this.$router.push("/BusinessGoodsShow");
    },
    showzhineng() {
      if (this.commentType == "配套评测") {
        this.$axios
          .get(this.$url_prefix + "getMatchComment", {
            params: {
              commentEstateId: this.commentEstateId,
            },
          })
          .then((res) => {
            this.commentWord = res.data.data || res.data.msg;
          });
      } else if (this.commentType == "投资价值评测") {
        this.$axios
          .get(this.$url_prefix + "getValueComment", {
            params: {
              commentEstateId: this.commentEstateId,
            },
          })
          .then((res) => {
            this.commentWord = res.data.data || res.data.msg;
          });
      } else if (this.commentType == "规划分析") {
        this.$axios
          .get(this.$url_prefix + "getPlanComment", {
            params: {
              commentEstateId: this.commentEstateId,
            },
          })
          .then((res) => {
            this.commentWord = res.data.data || res.data.msg;
          });
      } else if (this.commentType == "户型评测") {
        this.$axios
          .get(this.$url_prefix + "condition/getComment", {
            params: {
              commentEstateId: this.commentEstateId,
              commentApart: this.commentApart,
            },
          })
          .then((res) => {
            this.commentWord = res.data.data;
          });
      } else if (
        this.commentType == "楼盘评测" ||
        this.commentType == "3D选房评测"
      ) {
        this.$axios
          .get(this.$url_prefix + "getChooseHouseComment", {
            params: {
              commentEstateId: this.commentEstateId,
            },
          })
          .then((res) => {
            console.log(res);
            let pingjia = res.data.data["评价"].sort((a, b) => {
              let x = a.louDong.split("#")[0] * 1;
              let y = b.louDong.split("#")[0] * 1;
              return x - y;
            });
            if (res.data.data["选房"]) {
              var xuanfanghao = res.data.data["选房"];
            }
            console.log(xuanfanghao);
            this.commentWordList = {
              pingjia,
              xuanfanghao,
            };
            console.log(this.commentWordList, "commentWordList");
          });
      } else if (this.commentType == "样板房评测") {
        this.$axios
          .get(this.$url_prefix + "getRoomComment", {
            params: {
              commentEstateId: this.commentEstateId,
              commentApart: this.commentApart,
            },
          })
          .then((res) => {
            console.log(res);
            this.commentWordList = res.data.data;
          });
      }
    },
    changeCommentWordType1() {
      this.commentWordList.pingjia.forEach((item) => {
        if (item.louDong == this.commentdd1) {
          this.commentdd13 = item.comment;
        }
      });
    },
    changeCommentWordType2() {
      // console.log(this.commentWordList.pingjia)
      this.commentWordList.xuanfanghao.forEach((item) => {
        if (item.key == this.commentdd2) {
          this.commentWord = item.value;
        }
      });
    },
    changeCommentWordType3() {
      // console.log(this.commentWordList.pingjia)
      this.commentdd13.forEach((item) => {
        if (item.key == this.commentdd3) {
          this.commentWord = item.value || "请输入";
        }
      });
    },
    changeCommentWordType4() {
      // console.log(this.commentWordList.pingjia)
      this.commentWordList.forEach((item) => {
        if (item.name == this.commentdd4) {
          this.commentWord = item.comment || "请输入";
        }
      });
    },
    getjudegcomment() {
      this.$router.push("/judegcomment");
    },
    gefinished() {
      this.$router.push("/finishTable");
    },
    toSalesDynamic() {
      this.$router.push("/salesDynamic");
    },
    toLive() {
      this.$router.push("/liveAudit");
    },
    uploadQuestion(content, id) {
      let that = this;
      if (that.loupanCheck == "楼盘") {
        that.$axios
          .post(that.$url_prefix + "uploadQuestion", {
            list: [content],
          })
          .then((res) => {
            that.$message({
              type: "success",
              message: `上传${res.data.data.total}条，成功${res.data.data.add}条`,
            });
          })
          .catch((err) => {
            that.$message.error("上传失败");
            console.log("uploadQuestion err", err);
          });
      } else {
        that.$axios
          .get(that.$url_prefix + "changeState", {
            params: {
              id: id,
              content: content,
            },
          })
          .then((res) => {
            this.$message({
              type: "success",
              message: `上传${res.data.data.total}条，成功${res.data.data.add}条`,
            });
            for (let item of this.checkTalks) {
              // console.log('111')
              for (let j of item) {
                if (j.id == id) {
                  if (!j.state) {
                    this.$set(j, "state", 1);
                  } else {
                    j.state = 1;
                  }
                  break;
                }
              }
            }
            console.log();
          })
          .catch((res) => {
            console.log(res);
            this.$message.error("录入失败");
          });
      }
    },
    toUserChatHistory(user_id) {
      this.$router.push({
        path: "/userChatHistory",
        query: { user_id },
      });
    },

    getConsultantShareList() {
      this.$open();
      this.$axios
        .get(this.$url_prefix + "getAllShare")
        .then((res) => {
          this.$close();
          // console.log(res);
          const url = res.data.data;
          // console.log(url);
          window.open(url);
        })
        .catch((err) => {
          this.$close();
          console.log(new Error("下载失败！"));
        });
    },
    changeCommentWordType2() {
      // console.log(this.commentWordList.pingjia)
      this.commentWordList.xuanfanghao.forEach((item) => {
        if (item.key == this.commentdd2) {
          this.commentWord = item.value;
        }
      });
    },
    changeCommentWordType3() {
      // console.log(this.commentWordList.pingjia)
      this.commentdd13.forEach((item) => {
        if (item.key == this.commentdd3) {
          this.commentWord = item.value || "请输入";
        }
      });
    },
    changeCommentWordType4() {
      // console.log(this.commentWordList.pingjia)
      this.commentWordList.forEach((item) => {
        if (item.name == this.commentdd4) {
          this.commentWord = item.comment || "请输入";
        }
      });
    },
    getjudegcomment() {
      this.$router.push("/judegcomment");
    },
    gefinished() {
      this.$router.push("/finishTable");
    },
    toSalesDynamic() {
      this.$router.push("/salesDynamic");
    },
    toLive() {
      this.$router.push("/liveAudit");
    },
    uploadQuestion(content, id) {
      let that = this;
      if (that.loupanCheck == "楼盘") {
        that.$axios
          .post(that.$url_prefix + "uploadQuestion", {
            list: [content],
          })
          .then((res) => {
            that.$message({
              type: "success",
              message: `上传${res.data.data.total}条，成功${res.data.data.add}条`,
            });
          })
          .catch((err) => {
            that.$message.error("上传失败");
            console.log("uploadQuestion err", err);
          });
      } else {
        that.$axios
          .get(that.$url_prefix + "changeState", {
            params: {
              id: id,
              content: content,
            },
          })
          .then((res) => {
            this.$message({
              type: "success",
              message: `上传${res.data.data.total}条，成功${res.data.data.add}条`,
            });
            for (let item of this.checkTalks) {
              // console.log('111')
              for (let j of item) {
                if (j.id == id) {
                  if (!j.state) {
                    this.$set(j, "state", 1);
                  } else {
                    j.state = 1;
                  }
                  break;
                }
              }
            }
            console.log();
          })
          .catch((res) => {
            console.log(res);
            this.$message.error("录入失败");
          });
      }
    },
    getAsumter() {
      this.$axios.get(this.$url_prefix + "getShareChat").then((res) => {
        this.listName = "asumer";
        this.guwenAs = res.data.data;
        console.log(res);
      });
    },
    getConsultantShareList() {
      this.$open();
      this.$axios
        .get(this.$url_prefix + "getAllShare")
        .then((res) => {
          this.$close();
          // console.log(res);
          const url = res.data.data;
          // console.log(url);
          window.open(url);
        })
        .catch((err) => {
          this.$close();
          console.log(new Error("下载失败！"));
        });
    },

    goBuildingValuation() {
      this.$router.push({
        name: "BuildingValuation",
      });
    },
    godownSideValuation() {
      this.$router.push({
        name: "downSideValuation",
      });
    },
    createAccout() {
      this.$router.push("/kfsAccout");
    },
    tohouseUploadData() {
      this.$router.push("/houseUploadData");
    },

    toServiceReply() {
      this.$router.push({
        name: "backup",
        params: {
          id: "244miqa3qqq",
          name: "服务号领取干货回复",
        },
      });
    },
    showXHTalkTotal() {
      if (this.listName == "xHGSTotal") {
        this.$refs.tableData1.clearFilter();
      }
      this.listName = "xHTalkTotal";
    },
    showxHGSTotal() {
      if (this.listName == "xHTalkTotal") {
        this.$refs.tableData.clearFilter();
      }
      this.listName = "xHGSTotal";
    },

    topicWordSelect(row) {
      let that = this;
      if (!row.label1 || !row.label2) {
        that.$message.error("请选择类目");
        return;
      }
      that.$axios
        .post(that.$url_prefix + "topicWordClass", {
          content: row.content,
          type: row.label1 + "|" + row.label2,
        })
        .then((res) => {
          that.$message({
            type: "success",
            message: "入库成功",
          });
        });
    },
    topOneTalk(row) {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "topOneTalk", {
          params: {
            chat_id: row.chat_id,
            talk_id: row._id,
          },
        })
        .then((res) => {
          that.$message({
            type: "success",
            message: "置顶成功",
          });
        });
    },
    onTopicLabelChange(label, index) {
      let level = 2;

      let nextOptions = [];
      let currentBase = this.baseLabelOptions;
      if (index > 0) {
        for (let i = 0; i < index; i++) {
          let preLable = this.topicLabels[i];
          let preIndex = currentBase.findIndex((x) => x.name === preLable);
          currentBase = currentBase[preIndex].children;
        }
      }

      let index1 = this.topicLabelOptions[index].findIndex((x) => x === label);
      if (index1 > -1) {
        nextOptions = currentBase[index1].children.map((x) => x.name);
      } else {
        currentBase.push({
          name: label,
          children: [],
        });
        this.topicLabelOptions[index].push(label);
      }

      let next = index + 1;
      if (next < level) {
        this.topicLabels[next] = "";
        this.topicLabelOptions[next] = nextOptions;
      }
      for (let k = next + 1; k < level; k++) {
        this.topicLabels.splice(k, 1);
      }

      this.updateTopicLabel();
    },
    updateTopicLabel() {
      let that = this;
      let obj = {
        id: that.topicLabelBackId,
        data: JSON.stringify(this.baseLabelOptions),
      };
      let param = {
        db: "WpBackupModel",
        model: "edit",
        item: JSON.stringify(obj),
      };
      that.$axios
        .post(that.$url_prefix + "updateData", param)
        .then(function (res) {
          console.log("发送返回", res);
          that.changeTopicLabel();
        })
        .catch(function (res) {
          console.log("上传失败", res);
          that.$message.error("更新标签失败");
        });
    },
    changeTopicLabel(nochange) {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "queryOneById", {
          params: {
            id: that.topicLabelBackId,
            db: "WpBackupModel",
          },
        })
        .then((res) => {
          that.baseLabelOptions = JSON.parse(res.data.data.data);
          let currentBase = that.baseLabelOptions;
          for (let i = 0; i < that.topicLabels.length; i++) {
            let label = that.topicLabels[i];
            that.topicLabelOptions.splice(
              i,
              1,
              currentBase.map((x) => x.name)
            );
            if (label) {
              let index = currentBase.findIndex((x) => x.name === label);
              currentBase = currentBase[index].children;
            }
          }
          console.log("baseLabelOptions", that.baseLabelOptions);
          let map = {};
          that.baseLabelOptions.forEach((x) => {
            map[x.name] = x.children.map((y) => y.name);
          });
          that.topicLabelMap = map;
          if (!nochange) {
            that.changeListName("setTopicLabel");
          }
        })
        .catch((err) => {
          console.log("获取标签失败", err);
          that.$message.error("获取标签失败");
        });
    },
    updataImage_sure() {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "screenshot/reset", {
          params: {
            estate_id: this.updataImage_text,
            type: this.updataImage_type,
          },
        })
        .then((res) => {
          if (res.data.success) {
            that.$message({
              type: "success",
              message: "成功",
            });
          } else {
            that.$message({
              type: "error",
              message: "失败",
            });
          }
        })
        .catch((err) => {
          that.$message({
            type: "error",
            message: "失败",
          });
        });
    },

    checkAutoReply() {
      let that = this;
      if (!that.judgeQuestion || !that.judgeQuestionEstate) {
        return;
      }
      that.$axios
        .post(that.$url_prefix + "judgeAutoReply", {
          estate_id: that.judgeQuestionEstate,
          content: that.judgeQuestion,
        })
        .then((res) => {
          alert(
            res.data.data.label +
              "\n" +
              ((res.data.data.reply && JSON.stringify(res.data.data.reply)) ||
                "")
          );
        });
    },

    changeLandStatus() {
      let that = this;
      that.$axios
        .post(that.$url_prefix + "setLandStatus", {
          state: that.landStatusState,
          batch: that.landStatusBatch,
        })
        .then((res) => {
          that.$message({
            type: "success",
            message: "修改成功",
          });
        });
    },
    createStore() {
      this.$router.push({
        path: "/store",
      });
    },
    toDrawStore() {
      this.$router.push({
        path: "/apartment",
        query: {
          drawType: "商铺",
        },
      });
    },
    toStoreLocation() {
      this.$router.push({
        path: "/storeLocation",
      });
    },
    toStorePeopleLocation() {
      this.$router.push({
        path: "/peopleLocation",
      });
    },
    toStoreHX() {
      this.$router.push({
        path: "/hxStore",
      });
    },
    toLandVR() {
      this.$router.push({
        path: "/toLandVR",
      });
    },
    switchTimedTask(type) {
      const keyMap = {
        定时任务: "switchTimedTask",
        用户校验: "check_delete_user",
        实时加分: "real_time_scoring",
        房源视频: "switchPropertyVideo",
      };
      this.$confirm(`确定开关${type}?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios
          .get(this.$url_prefix + "switchTimedTask", {
            params: {
              switch_key: keyMap[type],
            },
          })
          .then((res) => {
            this.$message.error("更改状态为：" + res.data.data);
          });
      });
    },

    toChoosePriceFile() {
      let input = document.createElement("input");
      input.type = "file";
      input.multiple = "multiple";
      input.addEventListener("change", this.getPriceInfoFromExcel);
      input.click();
    },
    async getPriceInfoFromExcel(event) {
      function getText(file) {
        return new Promise((resolve) => {
          let fileReader = new FileReader();
          fileReader.onload = function (ev) {
            resolve(ev.target.result);
          };
          fileReader.readAsText(file);
        });
      }
      let files = event.target.files;
      let result = [];
      let data = [];
      for (let file of files) {
        let fileName = file.name;
        if (fileName.includes(".xlsx")) {
          try {
            result = result.concat(await this.$readExcel(file));
          } catch (err) {
            console.log(err);
          }
        } else {
          if (fileName.includes(".txt")) {
            let str = await getText(files[0]);
            data = str
              .split("\n")
              .map((x) => {
                let temp = x.split(":");
                return {
                  name: temp[0],
                  price: parseInt(temp[1]),
                };
              })
              .filter((x) => x.price);
          }
        }
      }

      let estateObj = {};
      result.forEach((x) => {
        x["小区"] = x["小区"].replace('"', "").replace(" ", "");

        if (!estateObj[x["小区"]] && x["小区"]) {
          estateObj[x["小区"]] = {
            area: [],
            price: [],
          };
        }
        try {
          let area = x["面积"].split("| ")[1].split("平米")[0];
          let price = x["总价"];

          estateObj[x["小区"]].area.push(Number(area));
          estateObj[x["小区"]].price.push(Number(price) * 10000);
        } catch (err) {
          console.log(err);
        }
      });

      try {
        for (let key in estateObj) {
          let avgPrice = 0;
          let totalArea = 0;
          let totalPrice = 0;
          estateObj[key].area.forEach((x) => {
            totalArea += x;
          });
          estateObj[key].price.forEach((x) => {
            totalPrice += x;
          });
          avgPrice = totalPrice / totalArea;
          data.push({
            name: key,
            price: Math.round(avgPrice),
          });
        }
      } catch (err) {
        console.log(err);
      }
      console.log("data", data);
      this.$axios
        .post(this.$url_prefix + "updateAllOldEstatePrice", {
          data: data,
        })
        .then((res) => {
          this.$message({
            type: "success",
            message: "上传成功",
          });
        })
        .catch((err) => {
          console.log("update err", err);
        });
    },

    queryAllFreePrice() {
      this.$axios.get(this.$url_prefix + "queryAllFreePrice").then((res) => {
        console.log("resf, re", res);
        this.bindPriceList = res.data.data;
        this.changeListName("bindPriceList");
      });
    },
    toEstateImportDataModify() {
      this.$router.push({
        path: "/estateImportDataModify",
      });
    },
    showGFTnotice() {
      this.isLoading = true;
      this.$axios
        .post(this.$url_prefix + "gft/get_latest_opening")
        .then((res) => {
          this.noticeData = res.data.data;
          this.dialogTableVisible = true;
          this.isLoading = false;
        })
        .catch(() => {
          this.$message.error("查询失败");
          this.isLoading = false;
        });
    },
    getGFTcontent(scope) {
      this.$axios
        .post(this.$url_prefix + "gft/get_room_price", {
          build_id: scope.row.id.toString(),
        })
        .then((res) => {
          if (res.data.success) {
            this.$message.success(res.data.msg);
          } else {
            if (res.data.msg) {
              this.$message.error(res.data.msg);
            } else {
              this.$message.error("抓取失败");
            }
          }
        })
        .catch(() => {
          this.$message.error("抓取失败");
        });
    },
    toBindPriceEstate(row, index) {
      if (!this.bindPriceEstateId) {
        this.$message.error("请选择楼盘");
        return;
      }
      let estate = this.matchEstates.find(
        (x) => x.id === this.bindPriceEstateId
      );
      this.$confirm(
        `确定将${row.name}绑定到${estate.real_estate_name}上吗`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then((res) => {
          this.$axios
            .get(this.$url_prefix + "bindPriceToEstate", {
              params: {
                price_id: row._id,
                estate_id: this.bindPriceEstateId,
              },
            })
            .then((res) => {
              this.$message({
                type: "success",
                message: "成功",
              });
              this.bindPriceList.splice(index, 1);
            })
            .catch((err) => {
              this.$message.error("失败");
            });
        })
        .catch((err) => {
          console.log("cancel");
        });
    },
  }, // methods
  updated() {
    if (this.listName == "xHTalkTotal") {
      this.$nextTick(() => {
        this.$refs.tableData.doLayout();
      });
    }
    if (this.listName == "xHGSTotal") {
      this.$nextTick(() => {
        this.$refs.tableData1.doLayout();
      });
    }
    if (this.listName == "groupWaterTable") {
      this.$nextTick(() => {
        this.$refs.tableData2.doLayout();
      });
    }
    if (this.listName == "channelWaterTable") {
      this.$nextTick(() => {
        this.$refs.tableData3.doLayout();
      });
    }
  },
  computed: {
    filterHoting() {
      let s = this.tableSearch;
      return this.hotingList.filter((x) => {
        return (
          !s ||
          (x.real_estate_name && x.real_estate_name.includes(s)) ||
          (x.number && x.number.includes(s)) ||
          (x.area_name && x.area_name.includes(s))
        );
      });
    },
    filterUserList() {
      let s = this.userSearch;
      return this.userList.filter((x) => {
        return !s || (x.user_name && x.user_name.includes(s));
      });
    },
    showWaitMatchList() {
      if (this.matchListSearchText.trim()) {
        return this.waitMatchList.filter((x) =>
          x.name.includes(this.matchListSearchText)
        );
      }
      return this.waitMatchList;
    },
    showHadMatchList() {
      if (this.matchListSearchText.trim()) {
        return this.hadMatchList.filter(
          (x) =>
            x.estate_name.includes(this.matchListSearchText) ||
            x.match_name.includes(this.matchListSearchText)
        );
      }
      return this.hadMatchList;
    },
  },
};
</script>

<style lang="css" scoped>
.other {
  text-align: center;
  overflow: hidden;
}

.white {
  height: 50px;
}

.fDiv {
  display: flex;
  align-items: center;
  margin: 0 0 20px 0;
}
.fDiv img {
  width: 100px;
  height: 100px;
}

.image-background {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(169, 169, 169, 0.8);
  z-index: 999;
}
.edit-area {
  display: flex;
  width: 100%;
  height: 80%;
  align-items: center;
  justify-content: space-around;
}
.edit-left {
  width: 40%;
  height: 80%;
  background-color: #ffffff;
  overflow-y: auto;
  white-space: pre-wrap;
  text-align: left;
  padding: 0 10px;
}
.edit-right {
  width: 40%;
  height: 80%;
  resize: none;
  font-size: 20px;
}

.checkSaleOut {
  display: flex;
  flex-direction: column;
  padding: 30px 30px;
}
.checkSaleIn {
  display: flex;
}
.saleAd {
  padding: 0 20px;
}
.bgr {
  background-color: #ff0000;
}

.salesmanList {
  display: flex;
  flex-direction: column;
}
.sale {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 20px;
}
.sale img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.imageBox {
  margin: 20px auto;
}
.imageBox img {
  width: 100px;
  height: 100px;
}

.count {
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin: 40px 0;
}

.cover {
  width: 100px;
  height: 100px;
  object-fit: cover;
  margin: 0 20px;
}

.topicList {
  margin-top: 50px;
  display: flex;
  height: 600px;
}
.topic-check {
  width: 40%;
  overflow-y: auto;
}
.topic-map {
  width: 60%;
}
.normal {
  margin: 10px 5px;
}
.normal2 {
  margin: 0px 5px;
}

.image-background {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(169, 169, 169, 0.8);
  z-index: 8;
  text-align: center;
}

.image-preview {
  margin-top: 200px;
  background-color: #fff;
  text-align: center;
  border: 1px solid #865ea7;
  padding: 10px;
  display: inline-block;
  position: relative;
}
.image-preview2 {
  position: relative;
  left: 0;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  text-align: center;
  border: 1px solid #865ea7;
  padding: 10px;
  display: inline-block;
}

.close {
  padding: 5px;
  position: absolute;
  z-index: 100;
  top: 0;
  right: 0;
  background-color: red;
}

.salePays {
  display: flex;
  justify-content: center;
}
.salePay {
  padding: 10px;
}

.el-image {
  border: 1px solid #eeeeee;
  vertical-align: middle;
}

.cur {
  color: red;
}
.talkbox {
  display: inline-block;
  text-align: left;
}
.banktitle {
  display: flex;
  align-items: stretch;
}
.bank_interest {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.bank_interest div {
  display: inline-block;
  text-align: left;
}
.row {
  display: flex;
  align-items: stretch;
}
.column {
  flex: 1;
  border-top: 1px solid #ddd;
  border-left: 1px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60rpx;
}

#input_image {
  position: absolute;
  right: 0;
  top: 0;
  width: 80px;
  height: 28px;
  font-size: 200px;
  opacity: 0;
}

.input-box {
  display: inline-block;
}

.buju {
  display: flex;
  justify-content: center;
  align-items: center;
}
.alltitle {
  display: flex;
  font-weight: bold;
  justify-content: left;
  align-items: center;
  color: #ff7700;
  margin-top: 10px;
  margin-left: 55px;
}
.cititle {
  display: flex;
  font-weight: bold;
  justify-content: left;
  align-items: center;
  color: #000;
  margin-left: 55px;
}
.cibuttonwarp {
  display: flex;
  justify-content: left;
  align-items: center;
  color: #888;
  border-color: #888;
  margin-bottom: 10px;
  flex-wrap: wrap;
  margin-left: 50px;
}
.threetitle {
  display: flex;
  font-weight: normal;
  justify-content: left;
  align-items: center;
  color: #888;
  margin-left: 10px;
}
.add-margin {
  margin: 0 5px;
}
.download-button {
  margin: 5px 0;
}

.item-box {
  position: relative;
}
.item-box::after {
  position: absolute;
  top: -5px;
  right: -5px;
  content: "";
  display: block;
  width: 10px;
  height: 10px;
  background-color: #f00;
  border-radius: 50%;
}

>>> .cibutton {
  font-size: 14px;
  color: #888;
  border-color: #888;
  border-width: 1px;
  background-color: #fff;
  padding: 5px 15px;
  border-radius: 4px;
}
>>> .cibutton:hover {
  background-color: #888888;
  color: #ffffff;
}

/deep/.el-table .my_cell {
  vertical-align: top;
}
.citySelect {
  text-align: left;
}
.red-point-item {
  margin: 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/page/Other.vue